export default {
    "corporate": "Unternehmensprogramm",
    "onboarding": {
        "goal_desc": "Sie erhalten %{customPoints} für die Verfolgung Ihrer Aktivitäten und einen Bonus von %{customPoints} für das Erreichen Ihrer Ziele. Es ist an der Zeit, loszulegen! Sie können jeweils 3 persönliche Ziele gleichzeitig haben.",
        "sample_task": {
            "modalActivityTitle": "3 tiefe Atemzüge",
            "rewards_featured_title": "Unterstützt",
            "rewards_partners_title": "Partner",
            "header_description": "Sie erhalten %{customPoints}, indem Sie Ihre Aktivitäten verfolgen und Aufgaben, Ziele und Herausforderungen abschliessen.",
            "icon_text": "Tippen Sie auf {icon}, um einen tiefen Atemzug zu verfolgen.",
            "activityName": "tiefes Atmen",
            "activityUnit": "Atemzug"
        },
        "lets_get_started": "Auf geht´s!",
        "start_description": "Sie erhalten %{customPoints}, indem Sie Ihre Aktivitäten verfolgen und Aufgaben, Ziele und Herausforderungen abschliessen.",
        "complete_and_earn": "Abschließen und Punkte sammeln",
        "did_it": "Ich habe es geschafft!",
        "task_complete": "Aufgabe abgeschlossen!",
        "breath_sample_task": "Kurze Einführung in die Aktivitätsverfolgung",
        "track_a_sample_activity": "Verfolgen Sie eine Beispielaktivität",
        "nice": "Super!",
        "nice_one": "Gut gemacht!",
        "nice_subtext_1": "Sie haben %{points} %{customPoints} erhalten.",
        "nice_subtext_2": "Das Sammeln von %{customPoints} hilft Ihnen, aufzusteigen. Jedes Mal, wenn Sie ein Level aufsteigen, verdienen Sie %{reward_currency}, die für tolle Angebote eingelöst werden können.",
        "nice_subtext_3": "Sie erhalten mehr Punkte, wenn Sie mehr Aufgaben erledigen, Aktivitäten verfolgen und Ziele und Herausforderungen abschließen.",
        "progress_subtitle": "Ihre %{customPoints} und Ihr Fortschritt werden alle %{frequency} zurückgesetzt.",
        "skip_for_now": "Erstmal überspringen",
        "loadingText": "Warten Sie einen Moment, während wir Ihren Wohlbefindenswert berechnen.",
        "goal_title": "Setzen Sie sich ein persönliches Ziel",
        "swipe_for_more": "Wischen Sie über den Bildschirm, um mehr zu sehen",
        "skip_goals": "Ich bin fürs Erste fertig mit dem Festlegen von Zielen.",
        "complete_profile": "",
        "level": "Level",
        "finish_onboarding_action": "Bitte schließen Sie zuerst die Einführung ab",
        "vital_stats": {
            "height_ft": "Größe ft.",
            "height_in": "Größe in."
        },
        "rewards": "",
        "welcome": {
            "disclaimerTitle": "Ihre Privatsphäre ist wichtig"
        },
        "levels": {
            "title": "Erfolge und Belohnungen",
            "tableTitle": "Leistung"
        },
        "initialScreen": {
            "title": "Willkommen bei %{programName}, %{username}!",
            "getRewarded": "Lassen Sie sich mit %{rewardName} belohnen",
            "completeAgainst": "Treten Sie gegen Ihre Kollegen an",
            "earnPoints": "Erhalten Sie Punkte mit Wellness-Aktivitäten",
            "levelUp": "Steigern Sie Ihr Level und schalten Sie Abzeichen frei"
        },
        "starterGoals": {
            "title": "Wählen Sie ein Ziel",
            "subtitle": "Begeben Sie sich auf Ihren Weg zu mehr Wohlbefinden mit einer neuen gesunden Angewohnheit."
        }
    },
    "healthkit_not_available": "Keine Verbindung mit Apple Health möglich. Vergewissern Sie sich in der Health-App unter Quellen, dass Sie mindestens die Berechtigung für die Erfassung von Schritten aktiviert haben und dass mindestens 1 Schritt aufgezeichnet wurde.",
    "changeCover": "Foto ändern",
    "joiningCommunityToast": {
        "success": {
            "message": "Sie wurden erfolgreich Mitglied bei %{name}",
            "title": "Gemeinschaft beitreten"
        }
    },
    "achievement_starts_date": "Beginn am: %{date}",
    "editChallenge": "%{challengeName} bearbeiten",
    "createChallenge": {
        "activitiesOrCategory": {
            "subtitle": "Wählen Sie bis zu 5 Aktivitäten",
            "title": "Was möchten Sie tun?",
            "noActivityTitle": "Aktivitäten werden hinzugefügt",
            "noActivityMessage": "Wählen Sie mindestens eine Aktivität oder Kategorie.",
            "categoryItemDescription": "Alle Aktivitäten in der %{category} Kategorie",
            "addActivityTitle": "Wie viele %{unit} von %{activity} möchten Sie pro %{period} machen?",
            "addCategoryQuantityTitle": "Wie viele %{customPoints} möchten Sie in der Kategorie %{category} verdienen?",
            "subtitleCategories": "Wählen Sie eine Kategorie aus. Alle Aktivitäten aus dieser Kategorie werden Sie zum Ziel führen.",
            "subtitleWithActivities": "%{num} von %{max} Aktivitäten ausgewählt",
            "selectCategoryMessage": "Alle Aktivitäten in der Kategorie werden ausgewählt und die zuvor ausgewählten Aktivitäten werden verworfen.",
            "addActivityTitleTotal": "Wie viel %{aktivity} wollen Sie in %{period} machen?"
        },
        "inviteDepartments": {
            "title": "Abteilungen einladen"
        },
        "inviteRegions": {
            "title": "Regionen einladen"
        },
        "createInvitation": {
            "selectMore": "Bitte wählen Sie mindestens 2 %{entity}s!"
        },
        "visibility": {
            "title": "Sichtbarkeit",
            "description": "Team-Herausforderungen können von allen %{programName}-Benutzern gefunden und angenommen werden."
        },
        "highest": {
            "name": "Der mit den meisten %{customPoints} gewinnt",
            "description": "Keine Obergrenze, der mit den meisten %{customPoints} belegt den 1. Platz"
        },
        "compete": {
            "individual": "Als Einzelperson teilnehmen",
            "team": "Als Team teilnehmen"
        },
        "unitType": {
            "title": "Wählen Sie, wie Sie Ihr Ziel erreichen",
            "subtitle": "Wählen Sie aus den Aktivitäten oder einer Kategorie"
        },
        "category": {
            "name": "Alle Aktivitäten in einer Kategorie",
            "description": "Verfolgen Sie z. B. eine beliebige Aktivität unter \"Bewegen\"",
            "title": "Wählen Sie eine Kategorie",
            "subtitle": "Aus welcher Kategorie wollen Sie Aktivitäten verfolgen?"
        },
        "activities": {
            "name": "Gewählte Aktivitäten",
            "description": "Verfolgen Sie z. B. bestimmte Aktivitäten, wie Radfahren",
            "title": "Wählen Sie Aktivitäten",
            "subtitle": "Wir empfehlen, sich auf eine einzige Aktivität zu konzentrieren, aber Sie können bis zu 5 Aktivitäten hinzufügen",
            "maxModalTitle": "Sie haben das Maximum an Aktivitäten ausgewählt",
            "maxModalDescription": "Sie können bis zu 5 Aktivitäten hinzufügen. Tippen Sie auf \"Akzeptieren\", um mit Ihren 5 ausgewählten Aktivitäten fortzufahren, oder auf Bearbeiten, um Änderungen vorzunehmen.",
            "warningModalTitle": "Hoher Schwierigkeitsgrad",
            "warningModalDescription": "Sie haben für dieses Ziel eine große Anzahl von Aktivitäten pro Zeitraum festgelegt. Sind Sie sicher, dass Sie sich ein so anspruchsvolles Ziel setzen wollen?",
            "requiredPoints": "erforderlich zum Erfüllen %{period} %{challengeType}",
            "noActivitiesModalTitle": "Aktivitäten werden hinzugefügt",
            "noActivitiesModalDescription": "Wählen Sie mindestens eine Aktivität."
        },
        "categoryQuantity": {
            "title": "Legen Sie Ihr %{customPoints} Ziel fest",
            "subtitle": "Wie viele %{customPoints} möchten Sie pro %{period} in der Kategorie %{category} verdienen?",
            "subtitleTotal": "Wie viele %{customPoints} möchten Sie pro %{period} in der Kategorie %{category} verdienen?",
            "text": "Als Richtwert gilt, dass 30 Minuten moderate Aktivität etwa 105 %{customPoints} entsprechen",
            "noQuantityModalTitle": "Anzahl",
            "noQuantityModalDescription": "Geben Sie einen Wert ein",
            "defaultCategoryTitle": "derzeitige Kategorie"
        },
        "cancel": {
            "title": "Erstellung der Herausforderung abbrechen",
            "message": "Sind Sie sicher, dass Sie die Erstellung der Herausforderung abbrechen möchten?"
        },
        "createNew": "Neue Herausforderung erstellen",
        "chooseChallengeTitle": "Wählen Sie eine Herausforderung oder erstellen Sie Ihre eigene",
        "createOwn": {
            "title": "Meine eigene erstellen"
        },
        "frequency": {
            "title": "Wie oft werden Sie Ihr Ziel erreichen?",
            "subtitle": "Tägliche Ziele sind gut für die Entwicklung von Gewohnheiten"
        },
        "startAndDuration": {
            "title": "Wählen Sie ein Anfangsdatum und die Dauer",
            "subtitle": "",
            "noFieldsTitle": "Anfangsdatum und Dauer",
            "noFieldsMessage": "Bitte geben Sie das Anfangsdatum und die Dauer ein"
        },
        "finalize": {
            "title": "Überprüfen Sie Ihr neues Ziel",
            "subtitle": "",
            "noFieldsTitle": "Name und Anweisungen",
            "noFieldsMessage": "Bitte geben Sie einen Namen und Anweisungen ein",
            "name": "Mein %{frequency} %{names} Ziel",
            "instructionCategory": "Verdienen Sie %{points} %{customPoints} %{frequency} bei allen %{category} Aktivitäten",
            "instructionActivities": "Verfolgen Sie %{items} %{frequency} und erhalten Sie %{points} %{customPoints} %{pointsFrequency}",
            "instructionCompetitionCategory": "Erzielen Sie die meisten %{customPoints} aus allen Aktivitäten von %{category}, um diesen Wettstreit zu gewinnen",
            "instructionCompetitionActivities": "Erzielen Sie die meisten %{customPoints} von %{items}, um diesen Wettstreit zu gewinnen",
            "namePlaceholder": "Geben Sie Ihrem Wettstreit einen Namen",
            "titleChallenge": "Schließen Sie Ihre Herausforderung ab"
        },
        "dailyDescription": "Z. B. 8 Gläser Wasser pro Tag trinken",
        "weeklyDescription": "Z. B. 150 Minuten pro Woche gehen",
        "monthlyDescription": "Z. B. 150 km pro Monat joggen",
        "totalDescription": "Z. B. Insgesamt 10.000 km Radfahren",
        "title": "Mich selbst oder andere herausfordern?",
        "navigatorTitle": "Herausforderung erstellen",
        "me": {
            "name": "Nur mich",
            "description": "Fordern Sie sich selbst mit einem persönlichen Ziel heraus"
        },
        "others": {
            "name": "Mit anderen messen",
            "description": "Einzeln oder im Team antreten"
        },
        "one": {
            "name": "Einzeln",
            "description": "Treten Sie einzeln gegen andere Benutzer an"
        },
        "team": {
            "name": "Als Team",
            "description": "Treten Sie als Team gegen andere Teams an"
        },
        "company": {
            "name": "Herausforderung des Unternehmens",
            "description": "Erstellen Sie einen speziellen Wettstreit"
        },
        "adminItemTitle": "Als Administrator können Sie folgendes erstellen:",
        "userOrTeamTitle": "Einzeln oder im Team antreten?",
        "target": {
            "name": "Legen Sie ein zu erreichendes Ziel fest",
            "description": "Eine Herausforderung mit Obergrenze"
        },
        "typeTitle": "Wählen Sie eine Art von %{challengeType}",
        "teamSizeTitle": "Wählen Sie eine Größe für jedes Team",
        "teamSizeSubtitle": "Die Mindestgröße eines Teams beträgt %{min} und die Maximalgröße %{max}. Die %{customPoints} Ihres Teams entsprechen dem Durchschnitt aller Mitglieder des Teams und Sie können nur dann %{customPoints} verdienen, wenn Ihr Team die Mindestanzahl an Mitgliedern hat.",
        "teamSize": {
            "noFieldsTitle": "Min. und max.",
            "noFieldsMessage": "Wählen Sie die minimale und maximale Anzahl von Mitgliedern für ein Team"
        },
        "companyChallengeTitle": "Herausforderung des Unternehmens",
        "companyChallengeSubtitle": "Sie sind ein Administrator. Sie können abteilungsspezifische und andere Arten von Herausforderungen erstellen",
        "chooseDepartmentTitle": "Wählen Sie Abteilungen für die Herausforderung",
        "chooseRegionTitle": "Wählen Sie Regionen für die Herausforderung",
        "goToChallenge": "Zu meiner Herausforderung gehen",
        "additional": {
            "title": "Herausforderung erstellt",
            "subtitle": "Auf geht's! Laden Sie andere zum Mitmachen ein.",
            "makePublicName": "Öffentlich anzeigen",
            "makePublicDescription": "Jeder kann beitreten",
            "toDirectoryName": "An das Herausforderungsverzeichnis senden",
            "toDirectoryDescription": "Jeder kann eine wie diese erstellen",
            "inviteTitle": "Zur Herausforderung einladen",
            "titleGoal": "Ziel erstellt!"
        },
        "quantityMinimum": {
            "message": "Die erforderliche Mindestanzahl ist %{quantity}",
            "title": "Anzahl nicht ausreichend"
        },
        "toast": {
            "success": "%{challengeType} wurde erstellt."
        },
        "goToGoal": "Zu meinem Ziel gehen",
        "navigatorTitleGoal": "Ziel erstellen",
        "quantityError": {
            "wholeNumber": "Muss eine ganze Zahl sein",
            "greaterThanZero": "Muss größer als 0 sein"
        }
    },
    "wellbeing": {
        "description": {
            "overall": "Ihr Wohlbefindenswert wird berechnet, indem die Antworten, die Sie in der Umfrage zum Wohlbefinden gegeben haben, mit denen von Millionen anderer Menschen derselben Alters- und Geschlechtskategorie verglichen werden. Ihr Ergebnis zeigt, wo Sie im Vergleich zu diesen Personen stehen. Ihre Punktzahl wird jeden Monat automatisch aktualisiert, wenn sich Ihr Bewegungs-, Ess- und Wohlfühlverhalten ändert und Sie dies in der App eingeben. Wenn Sie sich konsequent Ziele setzen und positive Maßnahmen ergreifen, um Ihre Gesundheit zu verbessern, können Sie Ihren Wohlbefindenswert verbessern.",
            "excellent": "Ihr Gesundheitswert ist besser als bei 85 % der Personen Ihres Alters und Geschlechts. ",
            "very_good": "Ihr Gesundheitswert ist besser als bei 70-84 % der Personen Ihres Alters und Geschlechts.",
            "good": "Ihr Gesundheitswert ist besser als bei 51-69 % der Personen Ihres Alters und Geschlechts.",
            "fair": "Ihr Gesundheitswert ist besser als bei 31-50 % der Personen Ihres Alters und Geschlechts.",
            "poor": "Ihr Gesundheitswert ist niedriger als bei 70 % der Personen Ihres Alters und Geschlechts. Es ist nie zu spät, Ihre Gesundheit in den Vordergrund zu stellen. Nutzen Sie unsere Plattform, um auf Ihrem Weg zum Wohlbefinden voranzukommen!",
            "overall_result": "Ihr Gesamtwert für das Wohlbefinden beträgt %{status}.",
            "category_result": "Ihr Gesamtwert für {category} ist {string}.",
            "goals": "Ohne Ziele können Sie nicht gewinnen. Setzen Sie sich bis zu 3 persönliche Ziele und verfolgen Sie sie. Wenn Sie Ihren Lebensstil ändern, wird sich Ihre Punktzahl mit der Zeit verbessern."
        },
        "reminder": {
            "title": "Es ist an der Zeit, Ihre Umfrage zum Wohlbefinden zu aktualisieren!",
            "updateAnswers": "Meine Antworten aktualisieren"
        },
        "lastUpdated": "Zuletzt aktualisiert am %{date}",
        "scoreDescription": {
            "part1": "Ihr Punktestand ist",
            "part2": "Punktzahl von",
            "belowAverage": "unter dem Durchschnitt",
            "aboveAverage": "über dem Durchschnitt",
            "part3": "für andere Personen Ihres Alters und Geschlechts."
        },
        "improveScore": {
            "description": "Ihre Punktzahl wird auf der Grundlage Ihrer Antworten in der Umfrage zum Wohlbefinden und der erfassten Aktivitäten berechnet. Sie können Ihre Antworten aus der Umfrage aktualisieren oder sich neue Ziele setzen, um sich zu verbessern.",
            "desc1": "Ihre Punktzahl kann nicht viel höher werden! Damit Ihr Programm auch weiterhin abwechslungsreich bleibt, können Sie sich selbst mit Zielen herausfordern, die knapp über Ihrer normalen Leistung liegen und andere einladen, sich mit Ihnen zu messen, um motiviert zu bleiben.",
            "desc2": "Wenn Sie sich noch weiter steigern möchten, können Sie den Schwierigkeitsgrad erhöhen. Fordern Sie sich selbst mit Zielen heraus, die knapp über Ihrer normalen Leistung liegen und laden Sie andere ein, sich mit Ihnen zu messen, um motiviert zu bleiben.",
            "desc3": "Setzen Sie sich persönliche Ziele und erstellen Sie öffentliche Herausforderungen, um sich selbst zu motivieren und Ihre Motivation zu halten. Setzen Sie sich erreichbare Ziele und wählen Sie kurze Zeiträume – wir empfehlen jeweils 1 Woche.",
            "desc4": "Es ist wichtig jeden Tag aktiv zu sein. Wenn Sie sich in Ihrem Alltag nicht viel bewegen, können Sie mit kleinen Zielen beginnen, die zu Ihren Fähigkeiten und Interessen passen. Setzen Sie sich erreichbare Ziele und wählen Sie kurze Zeiträume – wir empfehlen jeweils 1 Woche."
        },
        "recommendedGoals": "Empfohlene Ziele",
        "recommendedDescription": {
            "desc1": "Festlegbare Ziele: bis zu ",
            "desc2": "3 Ziele ",
            "desc3": "um sich auf die Verbesserung des Wohlbefindens zu konzentrieren. Sie haben momentan "
        },
        "categoryScore": "Ihr %{category} Punktestand ist ",
        "learnMore": "Mehr erfahren",
        "youAreSet": "Fertig!",
        "goalSetting": "Festlegen der Ziele",
        "attention": "%{category} Punktzahl nicht verfügbar.",
        "move": {
            "error": "Aufgrund Ihrer Antworten ist die Punktzahl für Ihre Bewegung nicht verfügbar. "
        },
        "eat": {
            "error": "Sie haben angegeben, dass Sie von einer medizinischen Fachkraft erfahren haben, dass Sie Typ-2-Diabetes haben und dieser nicht behandelt wird. "
        },
        "feel": {
            "error": "Aufgrund Ihrer Antworten ist die Punktzahl für Ihre Gefühle nicht verfügbar. "
        },
        "survey": {
            "requiredField": "* Pflichtfeld"
        },
        "score_info_title": "Was mein Ergebnis bedeutet",
        "company_average_info": "Durchschnitt in meinem Unternehmen",
        "demographic_average_info": "Durchschnitt in meinem demografischen Umfeld",
        "score": "Wohlbefindenswert",
        "table": {
            "what_it_means": "Was dies bedeutet",
            "score": "Wert"
        },
        "updated": "Aktualisiert",
        "label": {
            "excellent": "Ausgezeichnet",
            "very_good": "Sehr gut",
            "good": "Gut",
            "fair": "Mittelmäßig",
            "poor": "Mangelhaft"
        },
        "activity": {
            "eat": "Essen Aktivität 1, Essen Aktivität 2, Essen Aktivität 3",
            "move": "Bewegen Aktivität 1, Bewegen Aktivität 2, Bewegen Aktivität 3",
            "feel": "Fühlen Aktivität 1, Fühlen Aktivität 2, Fühlen Aktivität 3"
        },
        "score_info_screen": "Wie wird mein Wert berechnet?",
        "details": "Details",
        "activities": "Aktivitäten",
        "improveCategoryScore": "Meinen Punktestand für %{category} verbessern",
        "meaning": {
            "heading": "Berechnung des Wertes"
        },
        "score_button": {
            "meaning": "Was bedeutet dieser Wert?"
        },
        "improve": "Empfohlene Ziele ansehen",
        "score_text": {
            "demographic": "Der Durchschnittswert für Ihr Alter und Geschlecht ist",
            "company": "und die durchschnittliche Punktzahl in Ihrem Unternehmen beträgt"
        },
        "scoreHigher": "höher als der Durchschnitt von",
        "scoreLower": "niedriger als der Durchschnitt von",
        "settedGoals": {
            "noGoals": "Keine Ziele gesetzt",
            "one": "1 Ziel gesetzt",
            "n": "%{count} Ziele gesetzt"
        },
        "yourScoreIsPoor": "Ihr %{category} Punktestand ist mangelhaft",
        "unlock": {
            "title": "Schalten Sie Ihren Wohlbefindenswert frei",
            "description": "Füllen Sie einen kurzen Fragebogen aus, um Ihre allgemeine Gesundheit im Vergleich zu anderen Menschen in Ihrem demografischen Umfeld zu ermitteln."
        },
        "browseAndSet": "Sie können neue Ziele suchen und setzen, nachdem Sie die aktuellen abgeschlossen haben.",
        "excellent": {
            "desc1": "Außergewöhnlich gesunder Lebensstil",
            "desc2": "Sehr niedriges Gesundheitsrisiko"
        },
        "veryGood": {
            "desc1": "Sehr gesunder Lebensstil",
            "desc2": "Niedriges Gesundheitsrisiko"
        },
        "good": {
            "desc1": "Gesunder Lebensstil",
            "desc2": "Durchschnittliches Gesundheitsrisiko"
        },
        "fair": {
            "desc1": "Einigermaßen gesunder Lebensstil",
            "desc2": "Überdurchschnittliches Gesundheitsrisiko"
        },
        "poor": {
            "desc1": "Hohes Gesundheitsrisiko",
            "desc2": "Es wird mehr Bewegung pro Tag empfohlen",
            "desc3": "Es ist mehr Bewegung pro Tag notwendig"
        },
        "calculateScore": {
            "description": "Wenn Sie die Umfrage zum Wohlbefinden ausfüllen, werden Ihre Antworten mithilfe von Milliarden von Datenvariablen von Personen Ihres Alters und Geschlechts analysiert. Die Berechnung berücksichtigt auch die Aktivität, die Sie mit %{programName} verfolgen.\n\nIhr Wohlbefindenswert wird regelmäßig aktualisiert, damit Sie die Veränderungen im Laufe der Zeit verfolgen können."
        },
        "improveYourScore": "Verbesserung Ihres Punktestands"
    },
    "challengerCount": "%{num} Mitstreiter",
    "team_name": "Team-Name",
    "syncingDeviceToast": {
        "danger": {
            "message": "Hoppla... Wir hatten ein Problem bei der Synchronisierung von %{name}. Bitte versuchen Sie es erneut.",
            "title": "Synchronisieren"
        },
        "success": {
            "title": "Synchronisieren",
            "message": "%{name} erfolgreich synchronisiert. Ihre Aktivitäten sind jetzt auf dem neuesten Stand."
        }
    },
    "allCompanyMembers": "Alle Firmenmitglieder",
    "allCompanyMembersTeam": "Alle Firmenmitglieder (Team)",
    "successfullyRedeemedItemForConfirmation": "Sie haben diesen Artikel erfolgreich eingelöst und eine Bestätigungs-E-Mail wurde an %{email} gesendet.",
    "no_all_events_placeholder": "Es scheint, als gäbe es derzeit keine Veranstaltungen, an denen Sie teilnehmen können. Warum erstellen Sie nicht eine?",
    "confirmDeleteAccount": "Bestätigen Sie die Löschung, indem Sie die mit Ihrem Konto verbundene E-Mail-Adresse eingeben",
    "deleteAccount": "Konto löschen",
    "linkAccounts": "Verknüpfte Konten verwalten",
    "titleSlug": {
        "icon_reward_text": "Anspruchsberechtigte Mitglieder können ganz einfach mehr Punkte sammeln, indem sie bei unseren Partnern einkaufen oder sich bei einem Members' Choice Advantage-Zahnarzt untersuchen lassen und dabei ihre Zusatzleistungen in Anspruch nehmen.",
        "icon_move_text": "Wenn Sie sich im Alltag gesundheitsbewusst verhalten, z. B. besser schlafen oder mehr Gemüse essen, können Sie Live Better-Punkte verdienen.",
        "icon_redeem_text": "Live Better belohnt Medibank-Mitglieder, die eine Krankenhaus- oder Zusatzversicherung haben, dafür, dass sie sich um ihre Gesundheit kümmern. ",
        "icon_phone_text": "Melden Sie sich an und lösen Sie Prämien ein, z. B. Gutscheine für Ihre Gesundheit und Ihr Wohlbefinden oder Einsparungen bei Ihrem Krankenversicherungsschutz. ",
        "wellness": "Willkommen in der Welt der Wellness",
        "goals": "Erreichen Sie Ihre Ziele",
        "devices": "Bleiben Sie am Ball",
        "challenges": "Erstellen Sie Herausforderungen",
        "celebrate": "Soziales Wohlbefinden",
        "habits": "Gesunde Gewohnheiten entwickeln",
        "joinChallenge": "Schliessen Sie sich der Herausforderung an",
        "getSocial": "Werden Sie gesellig",
        "reward": "Lassen Sie sich für einen gesünderen Lebensstil belohnen.",
        "move": "Bewegen, essen & fühlen Sie sich besser.",
        "phone": "Besser leben, besser fühlen."
    },
    "viewProgress": {
        "goal": "Zielfortschritt anzeigen",
        "challenge": "Fortschritt der Herausforderung ansehen",
        "progress": "Fortschritt ansehen"
    },
    "vitalStats": {
        "disclaimer": {
            "message": "Die Eingabe dieser Informationen ist optional, zu Ihrem eigenen Nutzen und nur für Sie bestimmt."
        }
    },
    "eventBonusPoints": {
        "section": {
            "title": "Für dieses Event sind %{potentialBonusPoints} Bonuspunkte %{customPoints} verfügbar!"
        },
        "modal": {
            "paragraph1": "Durch die Teilnahme an diesem Event verdienen Sie %{pointsName} Bonuspunkte.",
            "paragraph2": "Alle %{pointsName} Bonuspunkte werden nach Abschluss des Events vergeben. Für Ereignisse, an denen Sie nicht teilnehmen, erhalten Sie keine Bonuspunkte."
        }
    },
    "EAP": {
        "contactInfo": "Kontaktinformationen",
        "doLater": "Ich mache das später",
        "tellMore": "Mehr erfahren",
        "contactMe": "Kontaktieren Sie mich",
        "title": "Hilfsprogramm für Mitarbeiter & Familien",
        "reachGoal": {
            "title": "Hilfe verfügbar",
            "description": "Ihr Hilfsprogramm für Mitarbeiter und Familien (Employee and Family Assistance Program, EFAP), das von %{providerName} bereitgestellt wird, bietet eine Reihe von Gesundheitsberatungsleistungen an, die Ihnen helfen, Ihre Ziele zu erreichen.\n\nMöchten Sie, dass %{providerName} Sie für weitere Informationen kontaktiert?"
        },
        "privacyPolicy": "%{provider} Datenschutzbestimmungen"
    },
    "HRIS": {
        "disclaimer": "Einige Felder werden automatisch aktualisiert und können nicht geändert werden."
    },
    "settingGoals": {
        "description": "Wenn Sie sich jeweils auf 3 empfohlene Ziele konzentrieren, erhöht sich Ihre Erfolgswahrscheinlichkeit.",
        "title": {
            "one": "Sie haben 1 Ziel festgelegt"
        }
    },
    "auth": {
        "linkAccount": {
            "alreadyLinkedToUser": "Konto bereits mit einem anderen Benutzer verknüpft",
            "lastAccountMessage": "Sind Sie sicher, dass Sie Ihr zuletzt verknüpftes Konto entfernen möchten? Nach der Entfernung müssen Sie sich mit der E-Mail-Adresse %{email} und einem neuen Passwort anmelden.",
            "unlinkCorpAccountMessage": "Sind Sie sicher, dass Sie das mit Ihrem Unternehmen verknüpfte Konto entfernen möchten? Nach dem Entfernen müssen Sie sich erneut mit der E-Mail-Adresse %{email} anmelden.",
            "alreadyLinked": "Das Konto ist bereits verknüpft",
            "unlinkMessage": "Sind Sie sicher, dass Sie ein verknüpftes Konto entfernen möchten?"
        },
        "sso": {
            "emailNotVerified": "Ihre E-Mail wurde nicht verifiziert."
        },
        "signIn": {
            "dontHaveAccount": "Sie haben noch kein Konto?",
            "enterPIN": "Geben Sie die Identifizierungsnummer Ihres Unternehmensprogramms ein",
            "dontKnowPIN": "Kennen Sie Ihre PIN nicht?",
            "pin": "PIN",
            "register": "Registrieren",
            "pinDescription": "Wenden Sie sich an Ihren Programmadministrator, wenn Sie die PIN (Program Identification Number) für Ihre Organisation nicht kennen. Wenn Sie eine PIN haben und Schwierigkeiten haben, mit dem nächsten Schritt fortzufahren, müssen Sie sich an support@sproutatwork.com wenden.",
            "keepMeTooltip": "Wenn Sie dieses Kontrollkästchen aktivieren, bleibt Ihre Sitzung 30 Tage lang bestehen. Bei gemeinsam genutzten Geräten empfehlen wir Ihnen, dieses Kästchen zu deaktivieren und sich abzumelden, wenn Sie fertig sind."
        },
        "signUp": {
            "backToLogin": "Zurück zur anmeldung",
            "termsOfService": "Nutzungsbedingungen",
            "privacyPolicy": "Datenschutzbestimmungen"
        },
        "createYourAccount": "Erstellen Sie Ihr Konto",
        "setYourDetails": "Legen Sie Ihre Details fest",
        "ModaHybridLogin": {
            "noAccessDashboard": "Sie haben keinen Zugriff auf das Mitglieder-Dashboard?",
            "signUpSSOButton": "Melden Sie sich über das Moda Member Dashboard an.",
            "noAccessDashboardWeb": "Wenn Sie keinen Zugriff auf das Mitglieder-Dashboard haben, melden Sie sich unten mit Ihrer E-Mail-Adresse und Ihrem Passwort an.",
            "loginSSOButton": "Melden Sie sich über das Moda Member Dashboard an."
        }
    },
    "entityHasBeenDeleted": "%{name} wurde gelöscht",
    "track_challenge": {
        "message": {
            "manually": "Manuell verfolgen",
            "automatically": "Automatisch verfolgt mit %{appOrDeviceName}",
            "manuallyOrConnect": "Manuell verfolgen oder eine App oder ein Gerät verbinden",
            "manuallyAndBy": "Manuell und automatisch verfolgen mit %{appOrDeviceName}",
            "reconnectDevice": "Gerät erforderlich. Bitte verbinden Sie Ihr Gerät erneut",
            "manualAndAuto": "Manuell und automatisch verfolgen",
            "trackedAutomatically": "Automatisch verfolgt"
        }
    },
    "signUpPartnerSSOToast": {
        "danger": {
            "title": "Anmeldung nicht möglich",
            "message": "Die Benutzerdaten können nicht vom Partner abgerufen werden. Bitte versuchen Sie es später erneut"
        }
    },
    "app_device_required": {
        "disclaimer": {
            "title": "Für dieses %{goalName} ist eine App oder ein Gerät erforderlich.",
            "subTitle": "Bitte verbinden Sie eine App oder ein Gerät"
        }
    },
    "descriptionSlug": {
        "wellness": "Treten Sie der Gesundheitsgemeinschaft bei, die Ihnen hilft, sich Ziele zu setzen, Kontakte zu knüpfen und am Ball zu bleiben.",
        "goals": "Sagen Sie uns, worauf Sie hinarbeiten. Wir helfen Ihnen mit Empfehlungen dabei, Ihr Ziel zu erreichen.",
        "devices": "Synchronisieren Sie Ihr Fitnessgerät oder protokollieren Sie Ihre Aktivitäten und verfolgen Sie Ihre Wellness-Ziele.",
        "challenges": "Starten Sie einen freundschaftlichen Wettbewerb. Erstellen Sie eine Herausforderung und laden Sie andere zum Mitmachen ein.",
        "celebrate": "Tauschen Sie sich mit Kollegen aus und feiern Sie gemeinsam Ihre Erfolge.",
        "habits": "Verfolgen Sie Ihre Wellness-Aktivitäten und sammeln Sie Punkte. Verbinden Sie Ihr Telefon oder Armband, um schneller Punkte zu sammeln.",
        "joinChallenge": "Sehen Sie, wie Sie in freundschaftlichen Wettstreits im Vergleich zu Ihren Kollegen abschneiden.",
        "getSocial": "Tauschen Sie sich mit Kollegen aus und feiern Sie gemeinsam Ihre Erfolge.",
        "reward_text": "Sammeln Sie Punkte für Ihre täglichen Aktivitäten und für persönliche Herausforderungen.",
        "move_text": "Egal, ob es sich um einen Spaziergang um den Block, fünf Minuten der Achtsamkeit oder eine gesunde Ernährungsweise handelt, wir belohnen Sie.",
        "phone_text": "Nutzen Sie Ihre Punkte für Rabatte bei Ihrem Versicherungsschutz und weitere tolle Angebote. Sie haben die Wahl.",
        "none": ""
    },
    "core": {
        "featureNotEnabled": "Funktion nicht aktiviert",
        "checkAppVersion": {
            "message": "Es scheint, dass Ihre App nicht mehr aktuell ist. Bitte installieren Sie das neueste Update.",
            "button": "%{appName} aktualisieren"
        },
        "noConnection": {
            "title": "Keine Verbindung mit dem Netzwerk",
            "description": "Sie sind scheinbar nicht mit dem Internet verbunden. Sie können die Anwendung nicht vollständig nutzen, wenn Sie keine Verbindung haben.",
            "button": "Erneut versuchen"
        },
        "uploadPhotoText": "Fügen Sie ein Foto für %{entityType} hinzu",
        "entities": {
            "community": "Gemeinschaft",
            "event": "Event",
            "team": "team",
            "goal": "Ziel",
            "challenge": "herausforderung",
            "competition": "Wettstreit"
        }
    },
    "registration": {
        "login": {
            "errorHeading": "Anmeldung nicht möglich",
            "resetPasswordHeading": "Zurücksetzen des Passworts erforderlich"
        },
        "signup": {
            "corporateOrOther": "Sind Sie kein Medibank Mitglied? Oder Teil eines Unternehmensprogramms?",
            "sign_up_here": "Hier anmelden ",
            "errorHeading": "Anmeldung nicht möglich",
            "areYouMedibankMember": "Sind Sie ein Medibank Mitglied?",
            "isMedibankMember": "Ich bin ein Mitglied",
            "isNotMedibankMember": "Ich bin kein Mitglied"
        },
        "bpidExists": "Die angegebene E-Mail-Adresse ist bereits mit einem Live-Better-Benutzer verknüpft, die E-Mail-Adresse darf nur einmal verwendet werden.",
        "generalError": "Der Dienst ist derzeit nicht verfügbar"
    },
    "rewardsNoAvailableProducts": "Zur Zeit sind keine Produkte verfügbar.",
    "endedGoal": {
        "timeToTrack": {
            "yes": "Sie haben noch Zeit nachzuverfolgen!",
            "no": "%{type} ist zu Ende"
        },
        "grace": "%{type} ist zwar abgeschlossen, aber Sie haben noch %{n} %{text}, um alle vergessenen Aktivitäten zu verfolgen",
        "notGrace": {
            "goal": "Herzlichen Glückwunsch! Sie haben Ihr Ziel erreicht! Machen Sie weiter so und setzen Sie sich ein neues Ziel, um Ihr Wohlbefinden beizubehalten.",
            "competition": "Herzlichen Glückwunsch zum Abschluss der Herausforderung! Behalten Sie Ihren Elan bei, indem Sie an einer anderen Herausforderung teilnehmen oder Ihre eigene erstellen."
        }
    },
    "appDeviceModal": {
        "defaultMessage": "Verbinden Sie Ihr Gerät oder Ihre App und genießen Sie die nahtlose Verfolgung. Ihre Authentifizierung ermöglicht es unserem Technologiepartner \"Sprout\", Ihre Daten sicher von Ihrem %{appDeviceTitle}-Konto zu übertragen."
    },
    "noTransactionsMessage": "Es sieht so aus, als hätten Sie noch keine Transaktionen durchgeführt.",
    "noRedemptionsMessage": "Es sieht so aus, als hätten Sie noch keine Einlösungen vorgenommen.",
    "challengeCarousel": {
        "emptyChallenge": {
            "subtitle": "Sie können an Herausforderungen als Einzelperson oder als Team teilnehmen",
            "prompt": "Derzeit gibt es keine Herausforderungen, an denen Sie teilnehmen können. Warum erstellen Sie nicht eine?"
        },
        "createChallengeButton": "Herausforderung erstellen"
    },
    "eventCarousel": {
        "emptyEvents": {
            "subtitle": "Events können entweder auf Einladung oder für alle zugänglich sein.",
            "button": "Event erstellen"
        },
        "emptyEventsMessage": "Derzeit gibt es keine Events, bei denen Sie teilnehmen können. Warum erstellen Sie nicht eins?"
    },
    "appnameLiveBetter": "Live Better",
    "appnameTelus": "Wohlbefinden",
    "appnameUPnGo": "UPnGO",
    "personal_goal": {
        "carousel": {
            "headingNoSet": "Sie haben noch keine Ziele festgelegt!",
            "descriptionNoSet": "Verbessern Sie Ihr Wohlbefinden, indem Sie sich ein paar Ziele setzen. Beginnen Sie gleich mit einem empfohlenen Ziel, wählen Sie aus dem Katalog oder erstellen Sie Ihr eigenes.",
            "descriptionSet": "Sie können sich eines der empfohlenen Ziele setzen, die wir für Sie bereithalten, den gesamten Katalog durchsuchen oder Ihr eigenes Ziel erstellen.",
            "action_text": "Neues Ziel festlegen",
            "heading_singular": "Sie können 1 weiteres Ziel festlegen",
            "heading_plural": "Sie können %{number} weitere Ziele festlegen"
        },
        "heading": "Persönliche Ziele",
        "single": "Persönliches Ziel"
    },
    "settingGoal": {
        "yourGoal": "Ihre %{units}",
        "yourGoalDescription": "Es geht los! Die folgenden %{units} werden eingestellt und beginnen sofort.",
        "selectedGoals": "Ausgewählte Ziele",
        "recommendedDescription": {
            "maximumSet": "Sie haben die maximale Anzahl von Zielen festgelegt. Sie können neue Ziele suchen und setzen, nachdem Ihre aktuellen Ziele abgeschlossen sind.",
            "maximumSetTitle": "Sie haben %{count} Ziele festgelegt"
        }
    },
    "activityLogRemoved": {
        "single": {
            "success": "Die Aktivität wurde entfernt",
            "info": "Etwas ist schief gelaufen. Bitte versuchen Sie es erneut.",
            "danger": "Etwas ist schief gelaufen. Bitte versuchen Sie es erneut."
        },
        "plural": {
            "success": "Die Aktivitäten wurde entfernt",
            "info": "Etwas ist schief gelaufen. Bitte versuchen Sie es erneut.",
            "danger": "Etwas ist schief gelaufen. Bitte versuchen Sie es erneut."
        },
        "success": "Die Aktivität wurde entfernt",
        "info": "Die Aktivität wurde nicht entfernt. Bitte versuchen Sie es erneut.",
        "danger": "Die Aktivität wurde nicht entfernt. Bitte versuchen Sie es erneut."
    },
    "participants": "Teilnehmer",
    "members": "Mitglied\/er",
    "timeSittingInformationOld": "Die Empfehlungen lauten:\n- Minimieren Sie die Zeit, die Sie im Sitzen verbringen.\n- Unterbrechen Sie lange Sitzperioden so oft wie möglich.",
    "timeSittingInformation": {
        "title": "Die Empfehlungen lauten:",
        "list": "- Minimieren Sie die Zeit, die Sie im Sitzen verbringen.\n- Unterbrechen Sie lange Sitzperioden so oft wie möglich."
    },
    "activityLevelInformationOld": "Die Empfehlungen lauten:\n- Seien Sie an den meisten, vorzugsweise an allen, Tagen der Woche aktiv.\n- Bewegen Sie sich jede Woche mehr als 150 Minuten mit mäßiger Intensität.\n- Führen Sie an mindestens 2 Tagen pro Woche muskelstärkende Aktivitäten durch.",
    "activityLevelInformation": {
        "title": "Die Empfehlungen lauten:",
        "list": "- Seien Sie an den meisten, vorzugsweise an allen, Tagen der Woche aktiv.\n- Bewegen Sie sich jede Woche mehr als 150 Minuten mit mäßiger Intensität.\n- Führen Sie an mindestens 2 Tagen pro Woche muskelstärkende Aktivitäten durch."
    },
    "viewGuidelines": "Empfehlungen ansehen",
    "corporateAccountLink": {
        "verification": {
            "title": "Verifizieren Sie Ihre Arbeits-E-Mail-Adresse",
            "description": "Sie müssen Ihre berufliche E-Mail-Adresse verifizieren, um den Verknüpfungsprozess erfolgreich abzuschließen. Bitte folgen Sie den Anweisungen, die gesendet wurden an:"
        }
    },
    "invitation": {
        "findFriendsAndFamily": "Freunde & Familie finden",
        "findFriends&Family": "Freunde & Familie finden",
        "tapToAddFriendsAndFamily": "Antippen, um zu Freunde & Familie hinzuzufügen",
        "addedFriendsAndFamily": "Zu Freunden & Familie hinzugefügt",
        "whoYouAreLookingFor": "Finden Sie nicht, wen Sie suchen?",
        "inviteWithEmail": "Mit einer E-Mail einladen",
        "sentInvitations": "Einladungen senden",
        "foundPerson": "Wir haben diese Person mit einer übereinstimmenden E-Mail-Adresse gefunden",
        "youAreBoth": "Sie sind beide bei %{entityName}",
        "youAreBothMore": "Sie sind beide bei %{entityName}, sowie +%{n} andere",
        "noFriendsAndFamilyAdded": "Sie haben noch keine Freunde oder Familie hinzugefügt.",
        "sendInvitation": "Einladung senden",
        "youHaveNoSentInvitations": "Sie haben keine Einladungen versendet",
        "toast": {
            "success_title": "Einladung gesendet",
            "success_description": "%{invite_email} wird die Einladung im Posteingang finden",
            "danger_title": "Die Einladung war nicht erfolgreich",
            "danger_description": "Bitte versuchen Sie es später erneut"
        },
        "email": {
            "invalid_email": "Geben Sie bitte eine gültige E-Mail-Adresse ein"
        },
        "inviteOthers": "Andere einladen",
        "searchForSomeone": "Jemanden suchen",
        "searchForOthersToInvite": "Andere zum einladen suchen",
        "programNameOnly": {
            "title": "Nur %{programName}",
            "description": "%{entityType} ist nur für Personen verfügbar, die ein Teil von %{programName} sind"
        },
        "domainCannotBeUsed": "Diese Domain kann nicht mit %{programName} verwendet werden",
        "actionSearchByEmail": "Per E-Mail einladen, wenn Sie die gesuchte Person nicht finden können",
        "send": "Senden",
        "addEmailToList": "E-Mail-Adresse zur Liste hinzufügen",
        "toBeSent": "Zu versendende Einladungen",
        "noInvitationsToBeSent": "Keine Einladungen",
        "removeEmailConfirmation": "Sind Sie sicher, dass Sie diese E-Mail-Adresse aus der Liste entfernen möchten?",
        "yes": "Ja",
        "no": "Nein",
        "foundByEmail": "Wir haben diese Person mit einer übereinstimmenden E-Mail-Adresse gefunden",
        "addToFriendsAndFamily": "Zu Freunde & Familie hinzufügen",
        "alreadyAddedEmail": "Sie haben diese E-Mail-Adresse bereits in die Liste aufgenommen"
    },
    "pointsCurrencyAdditionalInfo": "Ihre %{pointsName} und Stufen beginnen alle %{period} neu. Alle von Ihnen verfolgten Aktivitäten tragen zu Ihrem Gesamtniveau in diesem Zeitraum bei.",
    "rankLabel": "Platz",
    "leaderboards": {
        "loadingLabel": "Ranking wird geladen... Das kann ein paar Minuten dauern - es sieht so aus, als wären alle unterwegs und aktiv!"
    },
    "feeds": {
        "emptyListHomePage": "Es sind noch keine Beiträge zu sehen. Versuchen Sie, den Stream so anzupassen, dass mehr Beiträge angezeigt werden.",
        "viewingPostsFrom": "Anzeige von Posts von",
        "postActivity": "Fügen Sie einen Kommentar oder ein Foto zu Ihren Aktivitäten hinzu!",
        "indicatorLoader": {
            "defaultTitle": "Wird aktualisiert...",
            "successfulLoadedTitle": "Synchronisiert & aktualisiert..."
        },
        "inapropriateTextError": {
            "message": "Der Inhalt Ihrer Nachricht könnte unangemessen sein. Bitte versuchen Sie, eine freundlichere Sprache zu verwenden."
        },
        "postImageError": {
            "title": "Leider können wir das nicht posten",
            "message": "Das Bild, das Sie hinzugefügt haben, ist möglicherweise unangemessen. Bitte versuchen Sie es mit einem anderen."
        }
    },
    "syncModal": {
        "connect": {
            "title": "%{name} wird verbunden",
            "description": "Um Ihre %{name}-Daten mit Ihrem Konto zu verbinden, müssen Sie folgende Schritte ausführen:",
            "firstStep": "Laden Sie die mobile App %{appName} aus dem %{storeName} herunter und installieren Sie sie",
            "fourthStep": "Wählen Sie die Option zum Verbinden mit %{name}",
            "fifthStep": "Wenn Sie dazu aufgefordert werden, müssen Sie die mit %{appName} zu synchronisierenden Gesundheitsmetriken auswählen und \"Fertig\" wählen",
            "additionalInfo": "Bitte beachten Sie, dass %{appName} geöffnet sein muss, um die Synchronisierung über die Gesundheits-App durchzuführen. Sie müssen die App nicht geöffnet lassen, aber es kann eine Stunde dauern, bis die Synchronisierung abgeschlossen ist und in Ihrem Aktivitätsprotokoll erscheint."
        },
        "title": "%{name} wird synchronisiert",
        "description": "Um Ihre %{name}-Daten mit Ihrem Konto zu synchronisieren, müssen Sie folgende Schritte ausführen:",
        "steps": {
            "one": "Melden Sie sich auf Ihrem Telefon bei %{appName} an",
            "two": "Öffnen Sie den Abschnitt Apps & Geräte in Ihrem Profil",
            "three": "Drücken Sie die Schaltfläche \"Synchronisieren\" neben %{name}",
            "iPhone": "Melden Sie sich auf Ihrem Telefon bei %{appName} an"
        }
    },
    "accountLinkingToast": {
        "success": {
            "title": "Berufliches Konto",
            "message": "Konto erfolgreich verbunden"
        },
        "danger": {
            "message": "Fehler beim Verbinden des Kontos"
        },
        "conflict": {
            "message": "Das Konto ist bereits mit einem anderen Benutzer verknüpft"
        }
    },
    "accountUnlinkingToast": {
        "success": {
            "title": "Berufliches Konto",
            "message": "Konto erfolgreich getrennt"
        },
        "danger": {
            "title": "Konten verknüpfen",
            "message": "Fehler beim Trennen des Kontos"
        }
    },
    "earnMoreWithPartners": "Mehr verdienen mithilfe von Partnern",
    "connectPartnersToEarnByShopping": "Verbinden Sie Ihre Konten und verdienen Sie mehr %{unit_type}, indem Sie bei %{program_name} Partnern einkaufen.",
    "viewAllPartners": "Alle Partner ansehen",
    "myPartnerMemberships": "Meine Partnermitgliedschaften",
    "linkAccount": "Mitgliedschaft verlinken",
    "linkToPartner": "Link zum Partner",
    "linkingError": "Beim Verknüpfen Ihres Kontos ist ein Problem aufgetreten. Bitte versuchen Sie es erneut.",
    "linkPending": "Verknüpfung ausstehend",
    "unlinkAccount": "Konto nicht mehr verknüpfen",
    "linkedToPartnerName": "Verknüpft mit %{partner_name}",
    "linked": "Verknüpft",
    "permission": {
        "facebookTitle": "Mit Facebook anmelden",
        "googleTitle": "Mit Google anmelden",
        "facebookDescription": "Wenn Sie sich mit Facebook anmelden, müssen Sie unserem Technologiepartner \"Sprout\" die Erlaubnis erteilen, auf Ihre Identität zuzugreifen und Ihr Konto bei %{programName} zu erstellen.",
        "googleDescription": "Wenn Sie sich mit Google anmelden, müssen Sie unserem Technologiepartner \"Sprout\" die Erlaubnis erteilen, auf Ihre Identität zuzugreifen und Ihr Konto bei %{programName} zu erstellen.",
        "camera": {
            "title": "Zugriff auf die Kamera",
            "description": "Der Zugriff auf die Kamera ist erforderlich, um ein Foto zu machen. Tippen Sie in den iPhone-Einstellungen auf %{appName} und aktivieren Sie die Kamera.\n\nBitte beachten Sie, dass Sie möglicherweise nicht gespeicherte Änderungen verlieren."
        },
        "notNow": "Nicht jetzt",
        "openSettings": "Einstellungen öffnen",
        "photos": {
            "title": "Bitte erlauben Sie den Zugriff auf Fotos",
            "description": "Damit können Sie Fotos aus Ihrer Mediathek freigeben und Fotos in Ihrer Galerie speichern. Tippen Sie in den iPhone-Einstellungen auf %{appName} und schalten Sie die Fotooptionen frei.\n\nBitte beachten Sie, dass nicht gespeicherte Änderungen verloren gehen können."
        }
    },
    "firstNameContainsSpecialChar": "Ihr Vorname darf nur englische Buchstaben, Bindestriche - und Apostrophe enthalten",
    "lastNameContainsSpecialChar": "Ihr Nachname darf nur englische Buchstaben, Bindestriche - und Apostrophe enthalten",
    "goToPartnerSite": "Zur Partnerseite gehen",
    "noPartnersFound": "Keine Partner gefunden",
    "noLinkedPartners": "Keine verknüpften Partner",
    "noPartnersInCategory": "Keine Partner in dieser Kategorie",
    "partnerAccountPendingVerification": "Verifizierung des Kontos ausstehend",
    "shopWithPartner": "Bei Partner einkaufen",
    "shopWithPartnerName": "Bei %{partner_name} einkaufen",
    "linkToPartnerName": "Mit %{partner_name} verknüpfen",
    "earnPartnerMembershipIdentifier": "Feststellung der Mitgliedschaft",
    "earnPartnerAccountPendingAddLink": "Ihre Mitgliedschaft wird verknüpft und es kann einige Tage dauern, bis dies abgeschlossen ist.",
    "earnPartnerAccountPendingRemoveLink": "Die Verknüpfung Ihrer Mitgliedschaft wird aufgehoben und es kann einige Tage dauern, bis dies abgeschlossen ist.",
    "linkStatusUpdating": "Aktualisierung des Verknüpfungsstatus",
    "activityTracking": {
        "firstActivityModal": {
            "description1": "Herzlichen Glückwunsch! Sie haben Ihre ersten Aktivitäten hinzugefügt! \n\nWenn Sie möchten, können Sie weitere Aktivitäten für heute und andere Tage hinzufügen. Wenn Sie mit den Aktivitäten für heute fertig sind, können Sie",
            "description2": " auf den nächsten Bildschirm tippen, wenn Sie nichts mehr zu erfassen haben."
        },
        "listTitle": "Verfolgte Aktivitäten am",
        "dots": {
            "tracked": "An diesem Tag verfolgte Aktivitäten",
            "added": "Die Aktivitäten wurden hinzugefügt und warten auf die Übertragung"
        },
        "trackedActivitiesFor": "Verfolgte Aktivitäten am %{date}",
        "activityTracking": "Verfolgung von Aktivitäten",
        "addedPending": "Hinzugefügt (Übertragung ausstehend)",
        "search": {
            "description1": "Antippen",
            "description2": "um verfügbare Aktivitäten anzuzeigen oder nach einer bestimmten Aktivität zu suchen"
        },
        "addActivity": "Aktivität hinzufügen",
        "addAnotherActivity": "Weitere Aktivität hinzufügen"
    },
    "rewardsBalance": "%{currencyName} Kontostand: %{points}",
    "membershipIdentifierRequiredError": "Ihre Mitgliedskennung ist für die Verknüpfung erforderlich",
    "incorrectValueInRange": "Bitte geben Sie einen Wert zwischen %{min} und %{max} ein",
    "joinTeam": {
        "title": "Team beitreten",
        "createInsteadText": "Treten Sie einem Team bei oder erstellen Sie ein Team, um an dieser Herausforderung teilzunehmen"
    },
    "teamRank": "Team-Platzierung",
    "teamScore": "Punktestand des Teams",
    "appsDevices": {
        "infoText": "Sie werden gebeten, unseren Technologiepartner Sprout Wellness Solutions, Inc. zu ermächtigen, auf Ihre Gesundheitsdaten zuzugreifen, wenn Sie eine App oder ein Gerät hinzufügen.",
        "connectModal": {
            "title": "Autorisierung",
            "paragraph1Part1": "Sie werden gebeten, unseren Technologiepartner",
            "paragraph1Part2": "Sprout Wellness Solutions, Inc.",
            "paragraph1Part3": "zu autorisieren, auf Ihre Gesundheitsdaten zuzugreifen.",
            "paragraph2Desc1": "Ihre autorisierung erlaubt",
            "paragraph2Desc2": "Sprout",
            "paragraph2Desc3": "Ihre Daten",
            "paragraph2Desc4": "sicher zu synchronisieren",
            "paragraph2Desc5": "und hilft Ihnen, mehr %{pointsName} zu bekommen!"
        },
        "statusAlert": {
            "connectMessage": "Verbinden Sie eine App oder ein Gerät zur Aktivitätsverfolgung und erleichtern Sie sich die Synchronisierung und Verfolgung von Aktivitäten",
            "connectAction": "Verbinden Sie eine App oder ein Gerät",
            "errorMessage": "Ein paar der verbundenen Apps oder Geräte können nicht synchronisiert werden",
            "warningMessage": "Ein paar der verbundenen Apps oder Geräte haben möglicherweise ein Verbindungsproblem",
            "errorAction": "Fehler beheben",
            "warningAction": "Warnmeldung beheben",
            "syncingError": "Synchronisierungsfehler",
            "syncingIssue": "Synchronisierungsproblem"
        },
        "deviceDetails": {
            "warningMessage": "Diese App oder dieses Gerät weist Probleme bei der Synchronisierung auf",
            "errorMessage": "Diese App oder dieses Gerät kann nicht synchronisiert werden",
            "warningAction": "Warnung ignorieren",
            "noActivities": "In den letzten 7 Tagen wurden keine %{deviceName}-Aktivitäten mit %{programName} synchronisiert. \n\nEs kann bis zu einer Stunde dauern, bis die Aktivitäten hier angezeigt werden, nachdem sie mit dem %{deviceName} aufgezeichnet wurden. \n\nWenn Sie eine andere App oder ein anderes Gerät verknüpft haben und mehr Schritte von der anderen App oder dem anderen Gerät aufgezeichnet wurden, werden die Aktivitäten dort angezeigt. Versuchen Sie andernfalls, die Verbindung zu %{deviceName} zu trennen und erneut herzustellen. Wenn Sie aufgefordert werden, sich zu authentifizieren oder Berechtigungen zu erteilen, müssen Sie sicherstellen, dass die Aktivitätsdaten aktiviert sind und dass Sie zur Authentifizierung dasselbe Konto verwenden, das auch für die Verfolgung der Aktivitäten verwendet wird. Weitere Informationen finden Sie in den Schritten zur Fehlerbehebung.  "
        },
        "troubleshooting": "Fehlerbehebung",
        "deviceItem": {
            "error": "Verbindungsfehler",
            "warning": "Verbindungswarnung",
            "unableToSync": "Synchronisierung nicht möglich"
        },
        "platformDevice": {
            "defaultApp": "Die Standard-Gesundheits-App für Ihr Gerät ist",
            "continueMore": "Weiter zu weiteren Apps und Geräten"
        }
    },
    "friendsAndFamily": {
        "learnMore": "Mehr erfahren zu Freunde & Familie",
        "learnModal": {
            "title": "Über Freunde & Familie",
            "description": "Wenn Sie jemanden zu Freunde & Familie hinzugefügt haben, können Sie Ihre Beiträge bei %{programName} ausschliesslich mit diesen Personen teilen.\n\nSie können auch Beiträge, die Sie bei %{programName} sehen, nur für die Personen in Ihrer Freundes- und Familienliste filtern, wenn sie für alle oder für Sie gepostet wurden.",
            "description_line1": "Wenn Sie jemanden zu Freunde & Familie hinzugefügt haben, können Sie Ihre Beiträge bei %{programName} ausschliesslich mit diesen Personen teilen.",
            "description_line2": "Sie können auch Beiträge, die Sie bei %{programName} sehen, nur für die Personen in Ihrer Freundes- und Familienliste filtern, wenn sie für alle oder für Sie gepostet wurden.",
            "whatIconsMean": "Bedeutung der Icons",
            "canAdd": "Hinzufügen",
            "added": "Hinzugefügt"
        },
        "searchDescription1": "Suchen Sie nach Personen, die Sie zu Ihren Freunden und Ihrer Familie hinzufügen möchten.",
        "searchDescription2": "Sie sehen nicht, wen Sie suchen? Laden Sie sie per E-Mail ein.",
        "friends&Family": "Freunde & Familie",
        "managingTour": {
            "title": "Freunde & Familie verwalten",
            "body": "Wenn Sie jemanden aus Ihrem Freundes- und Familienkreis entfernen möchten, müssen Sie auf das Symbol tippen"
        },
        "removeOption": "Von Freunde & Familie entfernen",
        "inviteDescription1": "Suchen Sie Ihre Freunde und Familie.",
        "inviteDescription2": "Finden Sie nicht, wen Sie suchen?"
    },
    "deletePlatformInvitationToast": {
        "success": {
            "message": "Die Beiträge, die Sie nur für Freunde & Familie freigeben, sind für %{userFirstName} nicht mehr sichtbar."
        }
    },
    "skipAll": "Alle überspringen",
    "smallMin": "mind.",
    "eap": {
        "skipModal": {
            "title": "Sind sie sicher?",
            "description": "Sie können das Employee & Family Assistance Programm jederzeit über Ihr Profil kontaktieren, wenn Sie Hilfe benötigen."
        },
        "contact": {
            "whatIsBestNumber": "Unter welcher Nummer sind Sie am besten zu erreichen?",
            "whatIsBestTime": "Wann sind Sie am besten zu erreichen?",
            "morning": "Morgens",
            "afternoon": "Nachmittags",
            "evening": "Abends",
            "additionalDetails": "Zusätzliche Angaben zur Uhrzeit\/Datum, wann Sie kontaktiert werden möchten",
            "message": "Kontaktieren Sie mich am %{weekDay}, unter %{phoneNumber}. Zusätzliche Informationen: %{additional}",
            "description": "Hinweis: Wir empfehlen, einen Zeitpunkt außerhalb Ihrer Arbeitszeiten zu wählen und einen Ort zu wählen, an dem Sie ein Privatgespräch führen können. Bitte geben Sie Ihre Zeitzone an."
        },
        "phoneNumber": {
            "empty": "Dieses Feld darf nicht leer sein",
            "missingDigits": "Die Telefonnummer muss mindestens 4 Zahlen enthalten"
        },
        "myEAP": "Mein Hilfsprogramm für Mitarbeiter und Familien"
    },
    "healthSurveySkipAllTitle": "Umfrage zum Wohlbefinden überspringen",
    "healthSurveySkipAllAlert": "Sind Sie sicher, dass Sie alle restlichen Fragen der Umfrage zum Wohlbefinden überspringen möchten?",
    "eapSavingWithoutDataToast": {
        "danger": {
            "title": "Hilfsprogramm für Mitarbeiter und Familien",
            "message": "Bitte geben Sie Ihre Telefonnummer und die beste Zeit zur Kontaktaufnahme an"
        }
    },
    "allMyChallenges": "Meine Herausforderungen",
    "invitedChallenges": "Einladungen",
    "companyChallenges": "Herausforderungen des Unternehmens",
    "completedChallengesEmpty": "Sie haben anscheinend noch keine Herausforderungen beendet.",
    "myChallengesEmpty": "Sie haben sich scheinbar noch keiner Herausforderung angeschlossen.",
    "allChallengesEmpty": "Keine Herausforderungen vorhanden.",
    "startsToday": "Beginnt heute",
    "startedDaysAgo": "Hat vor %{dayCount} Tagen begonnen",
    "startsInDays": "Beginnt in %{dayCount} Tagen",
    "privacyOn": "Aus",
    "privacyOff": "An\/am",
    "dashboard": {
        "viewLeaderboard": "Bestenliste anzeigen",
        "timePeriodProgress": "Ihr Fortschritt diese\/n\/s %{period}",
        "howToEarn": "So erhalten Sie Punkte"
    },
    "privacyChangeConfirmationMessage": "Privatsphäre ändern?",
    "privacySettingsTitle": "Privatsphäre",
    "privacySettingsDescription": "Sie können die Sichtbarkeit Ihres Bildes, Namens und Profils für andere Nutzer einstellen. ",
    "mainLeaderBoardSettingsTitle": "?Gesamtes Ranking",
    "challengeLeaderBoardSettingsTitle": "?Ranking der Herausforderungen",
    "managePrivacySettingUrlTitle": "Privatsphäreeinstellungen verwalten",
    "onboardingFamilyPrivacySettingsMessageOn": "Sie sind in den Suchergebnissen für Freunde & Familie sichtbar. Sie können sich selbst aus den Suchergebnissen ausblenden.",
    "onboardingFamilyPrivacySettingsMessageOff": "Ihre Privatsphäreneinstellungen verbergen Sie derzeit in den Suchergebnissen für Freunde & Familie.",
    "challengeInvitationPrivacySettingsMessageOn": "Sie sind in den Suchergebnissen für Einladungen zu Herausforderungen sichtbar. Sie können sich selbst aus den Suchergebnissen ausblenden.",
    "challengeInvitationPrivacySettingsMessageOff": "Ihre Privatsphäreneinstellungen verbergen Sie derzeit in den Suchergebnissen für Einladungen zu Herausforderungen.",
    "challengeParticipationPrivacySettingsMessageOn": "Sie sind ein Teilnehmer an dieser Herausforderung. Sie können sich in Ihren Herausforderungen als Teilnehmer verbergen.",
    "challengeParticipationPrivacySettingsMessageOff": "Aufgrund Ihrer Privatsphäreneinstellungen sind Sie derzeit nicht in der Teilnehmerliste dieser Herausforderung zu sehen.",
    "communityInvitationPrivacySettingsMessageOn": "Sie sind in den Suchergebnissen für Einladungen zu Gemeinschaften sichtbar. Sie können sich selbst aus den Suchergebnissen ausblenden.",
    "communityInvitationPrivacySettingsMessageOff": "Ihre Privatsphäreneinstellungen verbergen Sie derzeit in den Suchergebnissen für Einladungen zu Gemeinschaften.",
    "communityParticipationPrivacySettingsMessageOn": "Sie sind ein Mitglied in dieser Gemeinschaft. Sie können sich in Ihren Gemeinschaften als Mitglied verbergen.",
    "communityParticipationPrivacySettingsMessageOff": "Aufgrund Ihrer Privatsphäreneinstellungen sind Sie derzeit nicht in der Mitgliederliste zu sehen.",
    "eventInvitationPrivacySettingsMessageOn": "Sie sind in den Suchergebnissen für Einladungen zu Events sichtbar. Sie können sich selbst aus den Suchergebnissen ausblenden.",
    "eventInvitationPrivacySettingsMessageOff": "Ihre Privatsphäreneinstellungen verbergen Sie derzeit in den Suchergebnissen für Einladungen zu Events.",
    "eventParticipationPrivacySettingsMessageOn": "Sie sind ein Teilnehmer an diesem Event. Sie können sich in Ihren Events als Teilnehmer verbergen.",
    "eventParticipationPrivacySettingsMessageOff": "Aufgrund Ihrer Privatsphäreneinstellungen sind Sie derzeit nicht in der Teilnehmerliste zu sehen.",
    "mainLeaderboardPrivacySettingsMessageOn": "Sie werden in den Ranglisten der Herausforderungen angezeigt. Sie können sich selbst verbergen, wodurch Ihre Platzierung, Ihr Bild und Ihr Name entfernt werden, wenn andere das Ranking der Herausforderungen ansehen.",
    "mainLeaderboardPrivacySettingsMessageOff": "Ihre Privatsphäreneinstellungen verbergen Sie derzeit, wenn andere das Ranking ansehen.",
    "challengeLeaderboardPrivacySettingsMessageOn": "Sie werden in den Ranglisten der Herausforderungen angezeigt. Sie können sich selbst verbergen, wodurch Ihre Platzierung, Ihr Bild und Ihr Name entfernt werden, wenn andere das Ranking der Herausforderungen ansehen.",
    "challengeLeaderboardPrivacySettingsMessageOff": "Ihre Privatsphäreneinstellungen verbergen Sie derzeit, wenn andere das Ranking ansehen.",
    "thumbsUpConfirmationTitle": "Daumen hoch",
    "thumbsUpConfirmationDescriptionline1": "Herzlichen Glückwunsch! Sie sind dabei, Ihre erste positive Bewertung abzugeben und andere zu motivieren!",
    "thumbsUpConfirmationDescriptionline2": "Sie werden in die Liste der Personen aufgenommen, die diesen Beitrag mit \"Daumen hoch\" bewertet haben, und andere können Ihr Bild, Ihren Namen und Ihr Profil sehen.",
    "thumbsUpConfirmationButtonOk": "Daumen hoch",
    "commentToActionInfoTitle": "Was können die anderen sehen?",
    "commentToActionMessage": "Wenn Sie einen Beitrag kommentieren, können andere Ihr Bild und Ihren Namen sehen und Ihr Profil aufrufen.",
    "postToActionTitle": "Wer kann diesen Beitrag sehen?",
    "postToActionMessageLine1": "Wenn Sie einen Beitrag erstellen, können Sie festlegen, wer ihn sehen kann, und ihn sogar nur für sich selbst anzeigen lassen.",
    "postToActionMessageLine2": "Wenn Sie Beiträge für andere freigeben, werden Ihr Bild und Ihr Name angezeigt und andere können Ihr Profil ansehen",
    "privateUsersDescriptionChallenge": "Diese Teilnehmer haben sich in der Liste ausgeblendet",
    "privateUsersFirstNamePlaceHolderChallenge": "%{n} privat",
    "privateUsersLastNamePlaceHolderChallenge": "Teilnehmer",
    "privateUsersDescriptionEvent": "Diese Teilnehmer haben sich in der Liste ausgeblendet",
    "privateUsersFirstNamePlaceHolderEvent": "%{n} privat",
    "privateUsersLastNamePlaceHolderEvent": "Teilnehmer",
    "privateUsersDescriptionCommunity": "Diese Teilnehmer haben sich in der Liste ausgeblendet",
    "privateUsersFirstNamePlaceHolderCommunity": "%{n} privat",
    "privateUsersLastNamePlaceHolderCommunity": "mitglied\/er",
    "noPrivacySettings": "Keine Privatsphäreeinstellungen",
    "linkToPartnerNameWebsite": "Link über die Webseite von %{partner_name}",
    "linkToPartnerWebsiteUrl": "URL der Partnerwebseite",
    "start_end_time": "Beginn und Ende:",
    "joinCreateTeamPrivacyDisclaimer": "Ihr Bild, Name und Profil sind immer für alle sichtbar, wenn Ihr Team an einer Herausforderung teilnimmt, auch wenn Sie Ihre Privatsphäreeinstellungen zu Privat geändert haben.",
    "carouselInstructions": {
        "swipe": "Wischen Sie die Karten hin und her, um all Ihre Ziele und Herausforderungen anzusehen.",
        "click": "Klicken Sie auf die Karten, um all Ihre Ziele und Herausforderungen anzusehen."
    },
    "achieved": "Erreicht",
    "hours": "Stunden",
    "createCommunityFlow": {
        "navigatorTitle": "Gemeinschaft erstellen",
        "stepType": {
            "title": "Sichtbarkeit der Gemeinschaft",
            "subTitle": "Wer kann die Gemeinschaft sehen und ihr beitreten?",
            "privateName": "Privat",
            "publicName": "Öffentlich",
            "privateDescription": "Nur Personen, die Sie einladen, können die Gemeinschaft sehen oder ihr beitreten",
            "publicDescription": "Jeder kann diese Gemeinschaft sehen und ihr beitreten"
        },
        "stepName": {
            "title": "Geben Sie Ihrer Gemeinschaft einen Namen",
            "subTitle": "Geben Sie Ihrer Gemeinschaft einen Namen, der die Leute wissen lässt, worum es geht.",
            "namePlaceholder": "Name der Gemeinschaft",
            "noFieldsTitle": "Name",
            "noFieldsMessage": "Noch kein Name gewählt"
        },
        "stepDescription": {
            "title": "Über Ihre Gemeinschaft",
            "subTitle": "Sagen Sie anderen, worum es in Ihrer Gemeinschaft geht.",
            "descriptionPlaceholder": "Beschreibung (optional)",
            "noFieldsTitle": "Beschreibung",
            "noFieldsMessage": "Noch kein Beschreibung hinzugefügt"
        },
        "stepImage": {
            "uploadPhotoButtonTitle": "Foto hinzufügen"
        },
        "stepJoin": {
            "title": "Wir haben änhliche Gemeinschaften gefunden",
            "subTitle": "Möchten Sie lieber einer dieser Gemeinschaften beitreten?"
        },
        "createNew": "Neue Gemeinschaft erstellen"
    },
    "challengeCard": {
        "allActivities": "Alle Aktivitäten in der",
        "category": "Kategorie"
    },
    "myLinkedPartners": "Meine verknüpften Partner",
    "leaderboardPosition": "Platzierung im gesamten Ranking",
    "remainingInChallenge": "verbleibend in der Herausforderung",
    "todays_progress": "Fortschritt heute",
    "this_weeks_progress": "Fortschritt diese Woche",
    "this_months_progress": "Fortschritt diesen Monat",
    "achievement": "leistung",
    "challengeCardHeader": {
        "challenge": "Herausforderung",
        "recommended_personal_goals": "Empfohlenes persönliches Ziel",
        "personal_goal": "Persönliches Ziel",
        "competition": "Wettstreit",
        "recommended_goals": "Empfohlenes Ziel",
        "team_competition": "Team-Wettstreit",
        "team": "Team"
    },
    "MyMedibank": "My Medibank",
    "Google": "Google",
    "Facebook": "Facebook",
    "errorEntityTimeMessage": "Der Endzeitpunkt kann nicht vor dem Startzeitpunkt liegen",
    "company": "Unternehmen",
    "lessThan1DayRemain": "weniger als 1 Tag",
    "lessThan1HourRemain": "weniger als 1 Stunde",
    "remainingToday": "für den Rest des Tages",
    "periodEndsDateAndTime": "Der Zeitraum endet am %{date}, um %{time}",
    "moreToGo": "%{n} %{unit} mehr",
    "reachedYourGoal": "Sie haben Ihr Ziel %{period} erreicht!",
    "reachedYourGoalToday": "Sie haben Ihr Ziel heute erreicht!",
    "editProfileItemCorrectRange": "Bitte geben Sie einen gültigen Wert für %{itemName} zwischen dem Mindestwert %{min} und dem Höchstwert %{max} an",
    "invalidUrl": "Ungültige URL",
    "activityLogChanged": {
        "success": "Die Änderungen für die Aktivität wurden gespeichert",
        "info": "Etwas ist schief gelaufen... Bitte versuchen Sie es erneut.",
        "danger": "Etwas ist schief gelaufen... Bitte versuchen Sie es erneut."
    },
    "discardAlert": {
        "createChallenge": "Sind Sie sicher, dass Sie diese %{challengeType} verwerfen wollen?",
        "inviteByEmail": "Sind Sie sicher, dass Sie die Änderungen verwerfen wollen?",
        "createTeam": "Sind Sie sicher, dass Sie die Erstellung dieses Teams abbrechen möchten?",
        "cancel": "Abbrechen",
        "confirm": "Ja, verwerfen"
    },
    "entityInvalidNameError": "Der Name von %{entity} sollte nur Zahlen oder eine Zeichenfolge enthalten und darf nicht leer sein",
    "accept": "Annehmen",
    "sync_now": "Jetzt synchronisieren",
    "reconnect_device": "Erneut verbinden",
    "supported_activities": "Unterstützte Aktivitäten",
    "recentlySynced_activity": "Kürzlich synchronisierte Aktivitäten",
    "noSyncedActivity_sevenDays": "In den letzten 7 Tagen wurden keine Aktivitäten synchronisiert",
    "recentActivityLog": {
        "convertingActivityPoints": "Aktivitäten werden synchronisiert...",
        "activityMinuteOrTwo": "Dies kann ein paar Minuten dauern...",
        "noNewActivities": "Keine neuen Aktivitäten hinzugefügt... Es kann bis zu einer Stunde dauern, bis die neuen Aktivitäten synchronisiert sind."
    },
    "deleteCommunityCheckbox": "Ich verstehe, dass dies nicht rückgängig gemacht werden kann",
    "createEvent": {
        "type": {
            "company": "Unternehmes-Event",
            "user": "Benutzer-Event",
            "title": "Art des Events"
        },
        "privacy": "Privatsphäre (Teilnehmer anzeigen oder nicht)",
        "cost": "Kosten",
        "associated": {
            "location": "Hinzugefügter Standort",
            "department": "Hinzugefügte Abteilung"
        },
        "maxParticipants": "Max. Teilnehmer (optional)",
        "errorMessage": {
            "limit": "Der Wert darf nicht größer sein als %{maxValue}",
            "negative": "Der Wert darf nicht negativ sein",
            "selectedLocations": "Bitte wählen Sie einen oder mehrer Standorte"
        },
        "selectLocations": "Ausgewählte Standorte",
        "createNew": "Neues Event erstellen"
    },
    "selected": "Ausgewählt",
    "deleteEventButton": "Dieses Event löschen",
    "notification": {
        "priorityNotification": {
            "title": "Sie haben wichtige ungelesene Updates",
            "subtitle": "Zum Lesen antippen",
            "subtitleWeb": "Zum Lesen anklicken"
        },
        "sectionTitle": {
            "priorityUnread": "Wichtige ungelesene Updates",
            "all": "Alle Benachrichtigungen"
        },
        "modalTitle": "Sie haben %{count} ungelesene Updates",
        "priorityModalTitle": {
            "defaultTitle": "Alle Aktualisierungen ansehen"
        }
    },
    "createEntity": {
        "cancel": {
            "title": "%{entity} %{actionType} abbrechen",
            "message": "Sind Sie sicher, dass Sie %{entity} %{actionType} abbrechen möchten?"
        },
        "action": {
            "creating": "wird erstellt",
            "editing": "wird bearbeitet"
        },
        "type": {
            "team": "team",
            "community": "Gemeinschaft",
            "event": "Event",
            "challenge": "herausforderung",
            "goal": "Ziel"
        }
    },
    "publicVisibilitySwitch": {
        "modalTitle": {
            "public": "Öffentlich anzeigen?",
            "private": "Privat belassen?"
        },
        "modalSubtitle": {
            "public": "Wenn Sie %{entityType} öffentlich anzeigen, kann das jeder sehen und beitreten. Sind Sie sicher, dass Sie %{entityType} öffentlich anzeigen wollen?",
            "private": "Wenn Sie %{entityType} privat belassen, kann das niemand sehen oder beitreten. Sind Sie sicher, dass Sie %{entityType} privat belassen wollen?"
        },
        "footerButton": {
            "makePublic": "Ja, öffentlich anzeigen",
            "makePrivate": "Ja, privat belassen",
            "keepPrivate": "Weiterhin privat belassen",
            "keepPublic": "Weiterhin öffentlich anzeigen"
        },
        "label": {
            "title": "%{entityType} öffentlich anzeigen",
            "subtitle": "Jeder kann das sehen und beitreten"
        }
    },
    "imageUploader": {
        "changeImageButton": "Bild ändern"
    },
    "copyright": "Copyright © Sprout 2019",
    "samsunghealth_not_available": "Keine Verbindung mit Samsung Health möglich. Vergewissern Sie sich in der Health-App unter Datenberechtigungen, dass Sie mindestens die Berechtigung für die Erfassung von Schritten aktiviert haben und dass mindestens 1 Schritt aufgezeichnet wurde.",
    "rewardsHowDoIEarn": "Wie bekomme ich %{currencyName}?",
    "unlockAchievements": "Leistungen freischalten",
    "unlockAchievementsDescription": "Verfolgen Sie Ihre Aktivitäten, erhalten Sie %{pointsName}, schalten Sie Level frei und erhalten Sie mehr %{currencyName}. Tippen Sie auf jede Leistung, um zu sehen, was Sie tun müssen.",
    "myDay": "Mein Tag",
    "myGoalsChallengesTasks": "Meine Ziele, Herausforderungen und Aufgaben",
    "yourGoalsChallenges": "Ihre Ziele und Herausforderungen",
    "mySocialStream": "Beiträge der Gemeinschaft",
    "viewAllAchievements": "Alle Leistungen ansehen",
    "viewAllBonusChallenges": "Alle Bonusherausforderungen ansehen",
    "newVersionOfAppAvailable": "Eine neue Version ist verfügbar! Bitte laden Sie diese Seite neu",
    "noBonusChallengesToDisplay": "Derzeit sind keine Bonusherausforderungen verfügbar.",
    "bonusChallenges": "Bonusherausforderungen",
    "reloadAppVersion": "Neu laden",
    "appname": "Sprout",
    "cancel_tracking_confirmation": "Sind Sie sicher, dass Sie %{activity_name} entfernen möchten?",
    "activity_tracker_instruction_header": "Tippen Sie auf einen Tag, um die Aktivitäten für diesen Tag zu verfolgen, oder sehen Sie sich an, was bereits aufgezeichnet wurde.",
    "alertDashboardFunctionalityToBeAdded": "Ein Tracking-Zeitraum ist so ähnlich wie bei den Treueprogrammen von Fluggesellschaften, bei denen die Benutzer in einem Kalenderjahr \"Meilen\" sammeln müssen, um den Status für das nächste Jahr zu erhalten.",
    "noNumberEntered": "Geben Sie die Zeit der Aktivität ein",
    "feed": "Stream",
    "home": "Startseite",
    "challenges": "Herausforderungen",
    "explore": "Erkunden",
    "rewards": "Belohnungen",
    "reward": "belohnung",
    "balance": "Mein %{programName} Belohnungsstatus",
    "profile": "Profil",
    "loading": "Wird geladen...",
    "me": "Ich",
    "back": "Zurück",
    "next": "Weiter",
    "skip": "Überspringen",
    "signup": "Anmelden",
    "signin": "Einloggen",
    "signin_maintitle": "Sprout",
    "signin_subtitle": "",
    "signinto": "Bei Live Better anmelden",
    "signup_with_medibank": "Als Medibank Mitglied anmelden",
    "signup_with_facebook": "Mit Facebook anmelden",
    "signup_with_google": "Mit Google anmelden",
    "signup_with_email": "Mit E-Mail-Adresse anmelden",
    "signin_with_medibank": "Mit My Medibank anmelden",
    "signin_with_facebook": "Mit Facebook anmelden",
    "signin_with_google": "Mit Google anmelden",
    "signin_with_email": "Mit E-Mail-Adresse anmelden",
    "signup_heading": "Konto erstellen",
    "not_a_medibank_member": "Sind Sie kein Medibank Mitglied?",
    "keep_me_signed_in": "Angemeldet bleiben",
    "forgotpassword": "Passwort vergessen?",
    "emailaddress": "E-Mail-Adresse",
    "password": "Passwort",
    "enterEmailAddress": "Geben Sie Ihre E-Mail-Adresse ein",
    "enterYourPassword": "Geben Sie Ihr Passwort ein",
    "password_for_error": "passwort",
    "reset_password": "Passwort zurücksetzen",
    "passwordResetSuccess": "Passwort zurückgesetzt",
    "passwordResetEmailSent": "Wenn wir eine übereinstimmende E-Mail-Adresse in unserem System haben, wurden Ihnen Anweisungen zum Zurücksetzen des Passworts per E-Mail zugesandt.",
    "loginerror": "Beim Einloggen ist ein Fehler aufgetreten:",
    "logincancelled": "Anmeldung abgebrochen",
    "part_of_corporate_program": "Melden Sie sich für ein Unternehmensprogramm an?",
    "continue_here": "Fahren Sie hier fort",
    "program_name": "Name des Programms",
    "error_provide_program_name": "Bitte geben Sie einen Programmnamen ein.",
    "program_not_found": "Programm nicht gefunden",
    "registration_field_email": "E-Mail-Adresse",
    "employeeId": "Mitarbeiter-ID",
    "registration_field_firstName": "Vorname",
    "registration_field_lastName": "Nachname",
    "no_first_name": "Kein Vorname",
    "no_last_name": "Kein Nachname",
    "registration_field_password": "Neues Passwort",
    "no_disclaimer_available": "Hoppla, es ist ein Problem aufgetreten... Wir konnten die Allgemeinen Geschäftsbedingungen Ihrer Organisation nicht abrufen. Bitte versuchen Sie, sich später erneut zu registrieren. ",
    "registration_account_not_registered": "Sie haben scheinbar Ihre E-Mail-Adresse noch nicht verifiziert. Möchten Sie, dass wir Ihnen die E-Mail erneut zusenden?",
    "resend_verification_email": "Verifizierung der E-Mail-Adresse",
    "resend_verification_email_successful": "Wir haben Ihre Verifizierungs-E-Mail erneut versandt.",
    "resend_verification_email_unsuccessful": "Hoppla, es gab ein Problem... wir konnten die Verifizierungs-E-Mail nicht erneut versenden. Versuchen Sie es bitte erneut.",
    "not_supported": "Dieser Beitrag kann im Moment nicht angezeigt werden. Bitte versuchen Sie es später noch einmal.",
    "policyAgreeError": "Zum Fortfahren müssen Sie den Nutzungsbedingungen und Datenschutzbestimmungen zustimmen.",
    "challenge_completion_bonus": "Abschlussbonus",
    "me_tabs": {
        "activity": "Aktivität",
        "bookmarks": "Lesezeichen"
    },
    "health_tab": {
        "my_health_score": "Ihr Wohlbefindenswert",
        "overall_health_score_description": "Ihr Wohlbefindenswert beträgt",
        "health_score_explanation": "Ihr Wohlbefindenswert wird aus den Angaben zu Ihrer Gesundheit und Ihrem Aktivitätsniveau berechnet. \n\nIhr Wert wird jeden Monat auf der Grundlage Ihres Aktivitätsniveaus aktualisiert. Sie können sich persönliche Ziele setzen und diese erreichen, um Ihren Wohlbefindenswert zu verbessern.",
        "health_score_calculation_failed_onboarding": "Es ist etwas schief gelaufen und wir konnten Ihren Wohlbefindenswert nicht abrufen. Sie können vorerst weitermachen und sobald das Problem behoben ist, aktualisieren wir Ihren Punktestand."
    },
    "track_activity": "Aktivität verfolgen",
    "track_an_activity": "Verfolgen Sie eine Aktivität",
    "track": "Verfolgen",
    "unable_to_track": "Verfolgung nicht möglich",
    "enter_before_track": "Geben Sie die Anzahl der zu verfolgenden Aktivitäten ein",
    "what_to_share": "Welche Art von Update möchten Sie teilen?",
    "remove": "Entfernen",
    "activity_tracking_description": "Wie viele %{units} möchten Sie verfolgen?",
    "excessive_submission": "Wow! Sie sind dabei, über 2.000 %{customPoints} für %{activity_name} zu sammeln. Überprüfen Sie, ob das richtig ist, bevor Sie die Daten übermitteln.",
    "on": "an\/am",
    "in": "in\/im",
    "from": "von",
    "at": "um",
    "no_activities": "Es gibt keine Aktivitäten, die Ihrer Suche entsprechen.",
    "activity_tracking_desc": "Sie müssen eine Zahl eingeben, um fortzufahren. Tippen Sie zum Abbrechen auf das X in der linken Ecke.",
    "activity_tracking_desc2": "Tippen Sie auf eine beliebige Aktivität, um sie zu bearbeiten; tippen Sie auf +, um das Ziel zu verfolgen",
    "vital_stats_title": "Über Sie",
    "invalid_numeric_response": "Ungültig",
    "invalid_numeric_response_range": "Diese Zahl muss zwischen %{minimum} und %{maximum} liegen",
    "search_placeholder": "Mediathek durchsuchen...",
    "search_activities": "Aktivitäten suchen",
    "searching": "Suchen...",
    "searchEmpty": "Keine Übereinstimmungen gefunden",
    "vital_stats_description": "Erzählen Sie und von sich",
    "health_survey_questions": "Fragen der Umfrage zum Wohlbefinden",
    "health_survey_title": "Füllen Sie die Umfrage zum Wohlbefinden aus",
    "health_survey_results": "Ergebnisse der Umfrage zum Wohlbefinden",
    "health_survey_card_desc": "Füllen Sie den Fragebogen aus, um eine Momentaufnahme Ihres Wohlbefindens zu erhalten und setzen Sie sich individuelle Ziele.",
    "apps_devices_title": "Apps und Geräte verknüpfen",
    "apps_devices_card_desc": "Synchronisieren Sie Ihre Apps und Geräte und machen Sie das Sammeln von %{customPoints} ganz einfach.",
    "interests_title": "Interessen",
    "interests_card_desc": "Nennen Sie uns Ihre Interessen. So können wir Ihnen Ziele und Gemeinschaften empfehlen, die für Sie von Interesse sein könnten.",
    "interests_screen_desc": "Was möchten Sie erreichen?",
    "health_obj_title": "Ziele für das Wohlbefinden",
    "health_obj_card_desc": "Es ist an der Zeit, sich ein paar Ziele zu setzen. Wenn wir Ihre Ziele kennen, können wir Ihnen bessere Empfehlungen geben. Keine Sorge, wenn Sie Ihre Meinung ändern, können Sie später in Ihrem Profil problemlos Änderungen vornehmen. ",
    "health_obj_screen_desc": "An welchen Bereichen möchten Sie arbeiten?",
    "my_heatlh_obj": "Meine Ziele für das Wohlbefinden",
    "health_topic_title": "Themen zum Wohlbefinden",
    "health_topic_card_desc": "Gestalten Sie Ihr Erlebnis individuell, indem Sie Ihre Wunschthemen angeben.",
    "health_topic_screen_desc": "Worüber möchten Sie mehr erfahren?",
    "multi_select_check_error": "Bitte wählen Sie mindestens 1 Option aus, um fortzufahren",
    "my_health_topics": "Meine Wohlfühlthemen",
    "build_your_profile": "Gestalten Sie Ihr Profil",
    "personalize_title": "Individuell gestalten",
    "personalize_desc": "Beantworten Sie ein paar kurze Fragen, um Ihre Erfahrungen individuell zu gestalten.",
    "set_goals_title": "Empfohlene Ziele ansehen",
    "set_goals_desc": "Empfohlene Ziele ansehen. Setzen Sie sich individuelle Ziele, um zu einer besseren Gesundheit zu gelangen.",
    "set_this_goal": "Dieses Ziel festlegen",
    "goal_set": "Ziel festgelegt",
    "required": "Erforderlich",
    "apps_devices_description": "Verbinden Sie eine Fitness-Plattform, um automatisch mehr %{customPoints} zu bekommen.",
    "connected": "Verbunden",
    "num_connected": "(%{numDevices} verbunden)",
    "available": "Verfügbar",
    "inProgress": "In Bearbeitung...",
    "time_a_m": "am",
    "time_p_m": "pm",
    "last_synced": "Zuletzt synchronisiert",
    "last_synced_lc": "zuletzt synchronisiert",
    "no_connected_devices": "Keine Geräte verbunden",
    "apps_devices_confirm_disconnect": "Sind Sie sicher, dass Sie die Verbindung trennen möchten",
    "button_delete": "Löschen",
    "button_disconnect": "Trennen",
    "button_cancel": "Abbrechen",
    "button_dismiss": "Verwerfen",
    "ok": "OK",
    "waist_helper_text": "Der Taillenumfang sollte unterhalb der Rippen, in der Regel auf Höhe des Bauchnabels, und im Stehen gemessen werden. Wenn Sie nicht sicher sind können Sie auch den Umfang Ihrer Jeans verwenden.",
    "apps_devices_manage": "Meine Apps und Geräte verwalten",
    "my_apps_devices": "Meine Apps und Geräte",
    "completeRegistration": "Registrierung abschließen",
    "havingTrouble": "Haben Sie Schwierigkeiten?",
    "contactUs": "Hilfe erhalten Sie unter support@sproutatwork.com",
    "done": "Erledigt",
    "brand": "Sprout",
    "cannotTrackTitle": "Verfolgung der Aktivität nicht möglich",
    "cannotTrackPrior": "Moment mal. Die Aktivitäten können erst nach dem Anfangsdatum erfasst werden.",
    "cannotTrackFuture": "Nicht so schnell. Die Aktivitäten können nur bis zum aktuellen Tag nachverfolgt werden.",
    "cannotTrack": "Die Aktivitäten können weder vor dem Anfangsdatum noch für einen Tag in der Zukunft erfasst werden.",
    "disclaimer": "Haftungsausschluss",
    "acceptTerms": "Ich akzeptiere die Allgemeinen Geschäftsbedingungen",
    "verificationEmailTitle": "Verifizieren Sie Ihre E-Mail-Adresse",
    "email_not_yet_verified": "Sie haben scheinbar Ihre E-Mail-Adresse noch nicht verifiziert. ",
    "email_successfully_verified_title": "Willkommen",
    "email_successfully_verified": "Ihre E-Mail-Adresse wurde erfolgreich verifiziert",
    "pleaseVerifyEmailMessage1": "Sie müssen Ihre E-Mail-Adresse verifizieren, um fortzufahren.",
    "pleaseVerifyEmailMessage2": "Bitte befolgen Sie die Anweisungen, die gesendet wurden an:",
    "supportEmail": "support@sproutatwork.com",
    "resendEmail": "E-Mail erneut senden",
    "restart": "Zurück zur anmeldung",
    "firstName": "Vorname",
    "firstNamePlaceholder": "Ihr Vorname",
    "lastName": "Nachname",
    "lastNamePlaceholder": "Ihr Nachname",
    "email": "E-Mail-Adresse",
    "emailPlaceholder": "Ihre E-Mail-Adresse",
    "employeId": "Mitarbeiter-ID",
    "employeIdPlaceholder": "Unternehmensmitarbeiter-ID",
    "passwordPlaceholder": "Neues Passwort",
    "datePickerTitle": "Geben Sie Ihr Geburtsdatum an",
    "datePickerConfirm": "Bestätigen",
    "datePickerCancel": "Abbrechen",
    "termsOfUsePrivacyPreLinks": "Ich stimme folgendem zu:",
    "sendMePromoCommunications": "Ich möchte Werbemitteilungen erhalten",
    "sendMePromoCommunicationsFromPartners": "Ich möchte Werbemitteilungen von Partnern erhalten",
    "termsOfService": "Nutzungsbedingungen",
    "legal": "Rechtliches",
    "privacyPolicy": "Datenschutzbestimmungen",
    "and": "und",
    "programDomainLabel": "Name des Programms",
    "programDomainPlaceholder": "Name des Programms",
    "findProgramName": "Meinen Programmnamen finden",
    "findProgramNameButton": "Namen des Programms finden",
    "findProgramNameTitle": "Meinen Programmnamen finden",
    "findProgramNameDescription": "Berufliche E-Mail-Adresse",
    "findProgramNamePlaceholder": "E-Mail-Adresse",
    "findProgramSuccessMessage": "Die Suchergebnisse für den Namen des Programms wurden Ihnen per E-Mail zugeschickt.",
    "findProgramSuccessTitle": "Name des Programms",
    "findProgramErrorTitle": "Name des Programms",
    "findProgramErrorMessage": "Hoppla, es ist ein Problem aufgetreten... Beim Abrufen Ihres Programmnamens ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
    "countryLabel": "Land wählen",
    "countryName": "Land",
    "regionLabel": "Region wählen",
    "regionName": "Region",
    "cityLabel": "Stadt wählen",
    "cityName": "Stadt",
    "locationWorkLabel": "Standort wählen",
    "locationWorkName": "Standort",
    "locationLabel": "Standort wählen",
    "locationName": "Standort",
    "departmentLabel": "Abteilung wählen",
    "departmentName": "Abteilung",
    "no_department": "Keine Abteilung",
    "enterPIN": "Bitte geben Sie Ihre Unternehmens-PIN ein",
    "verifyEmailTitle": "Verifizierung der E-Mail-Adresse",
    "verifyEmailMsg": "Sie haben scheinbar Ihre E-Mail-Adresse noch nicht verifiziert",
    "resendEmailTitle": "Verifizierung der E-Mail-Adresse",
    "resendEmailMsg": "Erneut senden an: %{userEmail}",
    "select_date": "Wählen Sie ein Datum",
    "changePasswordTitle": "Passwort ändern",
    "currentPassword": "Derzeitiges Passwort",
    "newPassword": "Neues Passwort",
    "confirmNewPassword": "Neues Passwort bestätigen",
    "passwordChangeError": {
        "currentPasswordMissing": "Geben Sie Ihr derzeitiges Passwort ein",
        "newPasswordMissing": "Geben Sie Ihr neues Passwort ein",
        "confirmPasswordMissing": "Bestätigen Sie Ihr neues Passwort",
        "passwordsMatch": "Die Passwörter stimmen nicht überein",
        "passwordIncorrect": "Falsches Passwort. Versuchen Sie es bitte erneut."
    },
    "settings": "Einstellungen",
    "signOut": "Abmelden",
    "updateApp": "App aktualisieren",
    "updateAppRight": "Aktuell: %{version}",
    "appleStoreUrlSprout": "https:\/\/itunes.apple.com\/us\/app\/sprout-at-work\/id904741273",
    "playStoreUrlSprout": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.sproutmobileapp",
    "appleStoreUrlLiveBetter": "https:\/\/itunes.apple.com\/us\/app\/live-better\/id1289314646",
    "playStoreUrlLiveBetter": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.livebetter",
    "appleStoreUrlTelus": "https:\/\/apps.apple.com\/app\/telus-health-wellbeing\/id1627569346",
    "playStoreUrlTelus": "https:\/\/play.google.com\/store\/apps\/details?id=com.telus.health.wellbeing",
    "appleStoreUrlUPnGO": "https:\/\/itunes.apple.com\/us\/app\/upngo-with-participaction\/id1079958142",
    "playStoreUrlUPnGO": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.upngo",
    "getHelp": "Hilfe erhalten",
    "feedback": "Feedback",
    "feedback_success_title": "Feedback übermittelt",
    "feedback_success_msg": "Vielen Dank für Ihr Feedback, wir sind sehr dankbar dafür!",
    "feedback_failure_title": "Fehler",
    "feedback_failure_msg": "Schade... Bei der Übermittlung Ihres Feedbacks ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
    "submit": "Absenden",
    "feedback_char_limit": "Sie haben die maximale Zeichenanzahl überschritten.",
    "feedback_char_limit_toast_title": "Die Nachricht ist zu lang",
    "feedback_char_limit_toast_msg": "Ihre Nachricht überschreitet die maximale Länge von 2000 Zeichen.",
    "feedback_char_length_msg_1": "Sie haben",
    "feedback_char_length_msg_2": "\/2000 Zeichen verwendet.",
    "feedback_empty_toast_title": "Nachricht leer",
    "feedback_empty_toast_msg": "Sie haben scheinbar noch nichts eingegeben. Geben Sie eine Nachricht ein, bevor Sie sie absenden.",
    "feedback_email_message": "Nachricht:",
    "feedback_email_user_id": ", Benutzer-ID:",
    "feedback_email_device": ", Gerät:",
    "feedback_email_os_version": ", OS-Version:",
    "feedback_email_app_version": ", App-Version:",
    "savingUserToast": {
        "success": {
            "title": "Änderungen speichern",
            "message": "Profiländerungen gespeichert"
        },
        "danger": {
            "title": "Ein Fehler ist aufgetreten",
            "message": "Hoppla... Beim Versuch Ihre Änderungen zu speichern, ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut."
        }
    },
    "edit_profile_user_error_msg": "Bitte überprüfen Sie die Fehler, bevor Sie versuchen, Ihre Änderungen zu speichern",
    "edit_profile_location_error": "Sie müssen Ihren Standort angeben",
    "edit_profile_department_error": "Sie müssen Ihre Abteilung angeben",
    "edit_profile_unspecified_value": "Sie müssen einen Wert angeben",
    "edit_profile_value_too_low": "Der Wert muss größer sein als",
    "edit_profile_value_too_high": "Der Wert muss kleiner sein als",
    "choose_gender": "Geschlecht wählen",
    "activity_tracked_successfuly": "Ihre Aktivität wird aufgezeichnet",
    "multi_activity_tracked_successfully": "Ihre Aktivitäten werden aufgezeichnet",
    "no_activities_tracked": "Es wurden keine Aktivitäten aufgezeichnet",
    "track_activity_to_submit": "Wählen Sie ein Datum, um eine Aktivität zu verfolgen",
    "last_day": "Vorherige",
    "days_remaining": "verbleibende Tage",
    "day_remaining": "verbleibender Tag",
    "days_remaining_this_week": "verbleibende Tage diese Woche",
    "day_remaining_this_week": "verbleibender Tag diese Woche",
    "days_remaining_this_month": "verbleibende Tage diesen Monat",
    "day_remaining_this_month": "verbleibender Tag diesen Monat",
    "earned_today": "Heute erhalten",
    "earned_this_week": "Diese Woche erhalten",
    "earned_this_month": "Diesen Monat erhalten",
    "earned_in_total": "Insgesamt erhalten",
    "goal_completed": "Ziel erreicht,",
    "see_results": "Ergebnisse anzeigen",
    "pts": "%{customPoints}",
    "of": "von",
    "daily_goal": "Tagesziel",
    "weekly_goal": "Wochenziel",
    "monthly_goal": "Monatsziel",
    "total_goal": "Gesamtziel",
    "weeks": "Wochen",
    "today": "Heute",
    "this_week": "Diese Woche",
    "this_month": "Diesen Monat",
    "overall": "Gesamt",
    "level": "Level",
    "days_remaining_in_period": "%{remainingDays} verbleibende Tage",
    "days_left_in_period": "%{remainingDays} verbleibende Tage zur Verfolgung",
    "pointsToLevel": "Fortschritte für %{levelName}",
    "levelCompleted": "%{levelName} abgeschlossen",
    "keepTrackingUntil": "Weiter verfolgen bis",
    "activityLevelTitle": "Mein Aktivitätslevel",
    "activityLevelDescription": "Wie viel Zeit verbringen Sie in einer typischen Woche damit, zumindest mäßig aktiv zu sein - d. h., wenn Sie sich so anstrengen, dass sich Ihre Herzfrequenz erhöht und Sie ins Schwitzen kommen? ",
    "activityLevelUnder60": "Weniger als 60 Minuten",
    "activityLevelUnder150": "60 bis 150 Minuten",
    "activityLevelOver150": "Über 150 Minuten",
    "gender_male": "Männlich",
    "gender_female": "Weiblich",
    "gender_rather_not_say": "Ich möchte dies nicht beantworten",
    "date_of_birth": "Geburtsdatum",
    "height": "Größe",
    "Height": "Größe",
    "weight": "Gewicht",
    "waistCircumference": "Taillenumfang",
    "bloodPressureHg": "Systolischer Blutdruck",
    "bloodPressureMm": "Diastolischer Blutdruck",
    "bloodCholesterol": "Gesamter Cholesteringehalt im Blut",
    "ldl": "Fettgewebe niedriger Dichte (LDL)",
    "hdl": "Fettgewebe hoher Dichte (HDL)",
    "restingHeartRate": "Herzfrequenz im Ruhezustand",
    "percentageBodyFat": "Prozentualer Körperfettanteil",
    "hipCircumference": "Hüftumfang",
    "bloodGlucose": "Blutzucker",
    "triglycerides": "Triglyzeride",
    "error_401_signed_out_message": "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.",
    "first_name": "Vorname",
    "last_name": "Nachname",
    "preferred_name": "Bevorzugter Name",
    "notifications": "Benachrichtigungen",
    "notificationsMarkAllReadButton": "Alle Nachrichten als gelesen markieren",
    "notificationsSettingsButton": "Einstellungen",
    "notificationsSettingsTitle": "Benachrichtigungen & E-Mails",
    "notificationEmptyMessage": "Sie sind auf dem neuesten Stand bezüglich Ihrer Benachrichtigungen",
    "priorityModalTitle": "Meine wichtigsten Benachrichtigungen",
    "remindMeLater": "Später erinnern",
    "priorityAdminTitle": "Benachrichtigung von Ihrem Administrator",
    "markAsRead": "Als gelesen markieren",
    "expand": "Zum Ausklappen antippen",
    "collapse": "Zum Zusammenklappen antippen",
    "takePhoto": "Neues Foto machen",
    "choosePhoto": "Foto wählen",
    "deletePhoto": "Foto löschen",
    "profileImageChangeErrorTitle": "Ein Fehler ist aufgetreten",
    "profileImageChangeErrorMessage": "Hoppla... Bei der Bearbeitung Ihres Fotos ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
    "editProfile": "Profil bearbeiten",
    "postButton": "Posten",
    "shareYourDayName": "Was haben Sie vor?",
    "greeting": "Hallo %{firstNameDisplay}!",
    "shareAnUpdate": "Was haben Sie vor?",
    "shareYourDaySubtitle": "Was haben Sie vor?",
    "shareAPost": "Teilen Sie einen Beitrag",
    "postVisibleTo": "Sichtbar für",
    "link": "Link",
    "photo": "Foto",
    "insertLink": "Fügen Sie Ihrem Beitrag einen Link hinzu",
    "save": "Speichern",
    "sampleLink": "http:\/\/sample.com",
    "shareErrorText": "Sie müssen Inhalte zu Ihrem Beitrag hinzufügen, bevor Sie ihn posten.",
    "generalErrorTitle": "Beitrag leer",
    "generalSuccessTitle": "Geschafft",
    "simplePlaceholder": "Was haben Sie vor?",
    "likesCountLabel": "Daumen hoch",
    "likesReceivedLabel": "Daumen hoch erhalten",
    "commentsCountLabel": "Kommantare",
    "commentsCountLabelSingular": "Kommentar",
    "likeButton": "Daumen hoch",
    "commentButton": "Kommentar",
    "seePreviousComments": "Vorherige Kommentar ansehen",
    "addCommentPlaceholder": "Kommentar hinzufügen",
    "postCommentButton": "Posten",
    "seeMoreLongComment": "Mehr ansehen",
    "activityPoints": "%{customPoints}",
    "activityLog": "Aktivitätsprotokoll",
    "discardPost": "Verwerfen",
    "discardPostMessage": "Sind Sie sicher, dass Sie diesen Beitrag verwerfen wollen?",
    "stream_filter_title": "Stream",
    "stream_filter_screen_desc": "Wählen Sie die Beiträge, die Sie im Stream ansehen möchten",
    "stream_filter_selection": "Anzeigen:",
    "moderate": "Als unangemessen markieren",
    "moderateDescription": "Als unangemessen markieren Wenn Sie diesen Beitrag als unangemessen markieren, wird er entfernt und ein Administrator wird benachrichtigt.",
    "editPost": "Beitrag bearbeiten",
    "deletePost": "Beitrag löschen",
    "deleteComment": "Kommentar löschen",
    "editComment": "Kommentar bearbeiten",
    "visibleOnlyToMe": "Nur für mich sichtbar",
    "joinEvent": "RSVP für das Event",
    "joinEventDetail": "Am Event teilnehmen",
    "joinedEvent": "Ich nehme Teil",
    "joiningEventToast": {
        "success": {
            "title": "%{eventName}",
            "messageName": "Sie nehmen an diesem Event teil",
            "message": "Sie haben sich erfolgreich für dieses Event eingetragen"
        }
    },
    "joinChallenge": "Herausforderung beitreten",
    "viewChallenge": "Herausforderung ansehen",
    "joinedChallenge": "Herausforderung beigetreten",
    "joinCommunity": "Gemeinschaft beitreten",
    "joinedCommunity": "Gemeinschaft beigetreten",
    "joinProgress": "Beitritt in Bearbeitung",
    "joinSuccess": "Beigetreten",
    "invitePeopleToCommunity": "Personen in die Gemeinschaft einladen",
    "numberOfMembers": "%{num} Mitglieder",
    "joinToView": "Dieser Gemeinschaft beitreten, um andere Mitglieder zu sehen und ihnen zu schreiben",
    "numberOfAttendees": "%{num} Teilnehmer",
    "numberOfParticipants": "%{num} Teilnehmer",
    "numberOfMembersWithUser": "Sie und %{num} weitere Mitglieder",
    "numberOfAttendeesWithUser": "Sie und %{num} weitere Teilnehmer",
    "numberOfParticipantsWithUser": "Sie und %{num} weitere Teilnehmer",
    "communityMembers": "%{numberOfMembers} Mitglieder",
    "communityEvents": "%{numberOfEvents} zukünftige Events",
    "myEvents": "Meine Events",
    "seeAll": "Alle ansehen",
    "noUpcomingEvents": "Keine baldigen Events. Treten Sie einem bei!",
    "myCommunities": "Meine Gemeinschaften",
    "invitedCommunities": "Eingeladen",
    "invitationSendingMessage": "Einladungen werden gesendet...",
    "invitationReceivedMessage": "hat Sie eingeladen mitzumachen bei",
    "invitationMessage": "Wir würden uns freuen, Sie in unserer Gemeinschaft begrüßen zu dürfen!",
    "recommendedCommunities": "Für Sie empfohlen",
    "leaveCommunity": "Diese Gemeinschaft verlassen",
    "leaveTeam": "Sind Sie sicher, dass Sie dieses Team verlassen möchten",
    "leaveTeamLastMember": "in dieser Herausforderung? Wenn Sie das letzte Mitglied des Teams sind und die Herausforderung verlassen, wird das Team gelöscht.",
    "leaveTeamChallenge": "in dieser Herausforderung?",
    "Oops": "Hoppla, etwas ist schief gelaufen",
    "editCommunity": "Gemeinschaft bearbeiten",
    "deleteCommunity": "Diese Gemeinschaft löschen",
    "leaveCommunityDescription": "Sind Sie sicher, dass Sie diese Gemeinschaft verlassen möchten?",
    "inviteToCommunity": "Zur Gemeinschaft einladen",
    "inviteByMembers": "Per Name einladen",
    "inviteByEmail": "Per E-Mail einladen",
    "select_person": "Bitte wählen Sie mindestens eine Person, die Sie einladen möchten",
    "no_users_found": "Hmm... wir können niemanden unter diesem Namen finden.",
    "promptJoinCommunities": "Scheinbar sind Sie noch keiner Gemeinschaft beigetreten. Treten Sie Gemeinschaften bei, um sich mit anderen auszutauschen und Ihre Erfahrungen zu teilen.",
    "exploreCommunities": "Gemeinschaften entdecken",
    "sendInviteByMembers": "%{num} Personen einladen",
    "sendInviteByEmail": "Einladung per E-Mail senden",
    "createNewCommunity": "Neue Gemeinschaft erstellen",
    "createCommunity": "Gemeinschaft erstellen",
    "uploadCover": "Foto hinzufügen",
    "cover": "Abdecken",
    "nameOfCommunity": "Name der Gemeinschaft",
    "whatCommunityAbout": "Worum geht es in dieser Gemeinschaft?",
    "companyMembersOnly": "Nur für Mitglieder des Unternehmens",
    "viewAllButton": "Alle ansehen",
    "communities": "Gemeinschaften",
    "contentLibrary": "Mediathek",
    "events": "Events",
    "past_events": "Vergangene Events",
    "invitationCommunity": "Gemeinschaft",
    "searchPeople": "Nach Personen suchen",
    "enterEmail": "E-Mail eingeben",
    "personalMessageToNewInvitees": "Persönliche Nachricht für neue Teilnehmer",
    "dangerToastTitle": "Fehler",
    "dangerToastMessage": "Hmm... Etwas ist schief gelaufen. Bitte versuchen Sie es erneut.",
    "successToastTitle": "Geschafft",
    "successToastMessage": "Aktion ausgeführt",
    "joiningToast": {
        "success": {
            "message": "Sie sind beigetreten"
        }
    },
    "deletingCommentToast": {
        "success": {
            "message": "Kommentar gelöscht"
        }
    },
    "moderatingCommentToast": {
        "success": {
            "message": "Der Kommentar wurde als unangemessen markiert"
        }
    },
    "editingCommentToast": {
        "success": {
            "message": "Kommentar aktualisiert"
        }
    },
    "gettingLikesToast": {
        "success": {
            "message": "Kommentar aktualisiert"
        }
    },
    "updatingAvatarToast": {
        "success": {
            "message": "Profilbild aktualisiert"
        }
    },
    "deletingAvatarAvatarToast": {
        "success": {
            "message": "Profilbild gelöscht"
        }
    },
    "creatingStreamToast": {
        "success": {
            "title": "Im Stream posten",
            "message": "Ihr Beitrag wurde erstellt"
        }
    },
    "editingStreamToast": {
        "success": {
            "title": "Beitrag bearbeiten",
            "message": "Ihr Beitrag wurde bearbeitet"
        }
    },
    "deletingPostToast": {
        "success": {
            "title": "Beitrag löschen",
            "message": "Ihr Beitrag wurde gelöscht"
        }
    },
    "moderatingPostToast": {
        "success": {
            "title": "Als unangemessen marikieren",
            "message": "Der Beitrag wurde als unangemessen markiert"
        }
    },
    "markingAllNotificationsToast": {
        "success": {
            "title": "Als gelesen markieren",
            "message": "Alle Nachrichten wurden als gelesen markiert"
        },
        "info": {
            "title": "Als gelesen markieren",
            "message": "Es wurden bereits alle Benachrichtigungen als gelesen markiert."
        },
        "danger": {
            "title": "Als gelesen markieren"
        }
    },
    "markingNotificationToast": {
        "danger": {
            "title": "Die Benachrichtigung konnte nicht als gelesen markiert werden"
        }
    },
    "changePasswordToast": {
        "success": {
            "title": "Passwort aktualisiert",
            "message": "Melden Sie sich mit Ihrem neuen Passwort an"
        },
        "danger": {
            "title": "Passwirt aktualisieren",
            "message": "Hoppla... Beim Versuch, Ihr Passwort zu aktualisieren ist etwas schief gelaufen. Bitte versuchen Sie es erneut."
        }
    },
    "joining": {
        "success": {
            "message": "Sie sind %{name} beigetreten"
        }
    },
    "invitingUsersToast": {
        "success": {
            "title": "Einladungen",
            "message": "Die Einladung\/en wurde\/n gesendet"
        }
    },
    "creatingCommunityToast": {
        "success": {
            "title": "Gemeinschaft erstellen",
            "message": "Ihre neue Gemeinschaft wurde erstellt"
        }
    },
    "restartingCustomGoalToast": {
        "success": {
            "message": "Ihr Ziel wurde neu gestartet"
        },
        "danger": {
            "message": "Das Ziel kann nicht neu gestartet werden"
        }
    },
    "quit": "Verlassen",
    "wellbeing_survey_completed": "Umfrage zum Wohlbefinden abgeschlossen",
    "wellbeing_survey_completed_message": "Vielen Dank, dass Sie die Umfrage ausgefüllt haben. Wir hoffen, dass Sie dadurch einen guten Einblick in Ihr Wohlbefinden erhalten haben.",
    "update_wellbeing_score": "Meine Antworten aktualisieren",
    "get_wellbeing_score": "Erhalten Sie Ihren Wohlbefindenswert",
    "stats": "Statistiken",
    "my_wellbeing_score": "Mein Wohlbefindenswert",
    "see_details": "Details ansehen",
    "how_score_calculated": "Wie wird mein Wert berechnet?",
    "contentTitle": "Mediathek",
    "promoted": "Unterstützt",
    "recommended": "Empfohlen",
    "recommendedForMe": "Für mich empfohlen",
    "recent": "Küzlich hinzugefügt",
    "view": "Ansehen",
    "added": "Hinzugefügt",
    "more": "mehr",
    "openLibrary": "Auf zur Mediathek",
    "readToEarn": "Lesen Sie dies, um zu verdienen",
    "readArticle": "Link öffnen",
    "see_more": "Mehr ansehen (%{num})",
    "see_more_activities": "%{num} mehr",
    "my_achievements": "Meine Leistungen",
    "achievements": "Leistungen",
    "achievement_earned_date": "Verdient: %{date}",
    "achievement_start_date": "Begonnen am: %{date}",
    "achievement_end_date": "Endet am: %{date}",
    "achievement_earned": "Verdient",
    "achievement_start": "Beginn",
    "achievement_end": "Ende",
    "achievement_earned_times": "%{num} Mal",
    "achievement_earned_time": "%{num} Mal",
    "in_progress": "In Bearbeitung",
    "date_earned": "Verdient am",
    "earned": "Verdient",
    "past_dates_earned_heading": "Vergangene Belohnungen",
    "all": "Alle",
    "eat": "Essen",
    "move": "Bewegen",
    "feel": "Fühlen",
    "profile_completion": "Profilvervollständigung: %{percentage}%",
    "complete_my_profile": "Vervollständigen Sie Ihr Profil",
    "do_following_tasks": "Erledigen Sie folgende %{num} Aufgabe\/n, um Ihr Profil zu vervollständigen.",
    "improve_my_score": "Verbessern Sie Ihren Punktestand",
    "see_which_goals": "Überprüfen Sie die Ziele, die Sie sich gesetzt haben, um sich besser zu ernähren, zu bewegen und zu fühlen.",
    "havent_set_goal": "Sie haben noch kein Ziel festgelegt.",
    "set_a_goal": "Ziel festlegen",
    "set_another_goal": "Weiteres Ziel festlegen",
    "set_another_goal_here": "Legen Sie hier ein neues Ziel fest.",
    "my_recently_tracked_activities": "Meine neuesten Aktivitäten",
    "a_few_seconds_ago": "vor ein paar Sekunden",
    "a_day_ago": "vor einem Tag",
    "yesterday": "Gestern",
    "earn": "Verdienen",
    "delete_activity_confirmation": "Sind Sie sicher, dass Sie diese Aktivität entfernen möchten?",
    "delete_activity_title": "%{measurement} von %{activity_name} entfernen?",
    "reached_daily_goal": "Sie haben heute Ihr Ziel erreicht. Ausgezeichnet!",
    "multiple_activity_non_daily_instruction": "Tippen Sie auf eine Aktivitätszeile, um mit der Aufzeichnung zu beginnen und %{customPoints} zu verdienen!",
    "multiple_activity_daily_instruction": "Tippen Sie auf das Pluszeichen, um die Zeit einer Aktivität zu erfassen, die Sie benötigen, um Ihr Ziel zu erreichen. Tippen Sie auf eine beliebige andere Stelle in der Aktivitätszeile, um eine beliebige Zeit dieser Aktivität zu verfolgen.",
    "only_automatic_activities": "Die Aktivitäten, die zu diesem Ziel führen, können nur automatisch verfolgt werden",
    "only_automatic_activity": "Die Aktivität, die zu diesem Ziel führt, kann nur automatisch verfolgt werden",
    "earn_pts_and_reach_goal": "Verdienen Sie %{pts} Punkte und erreichen Sie Ihr Ziel, indem Sie %{qty} verfolgen",
    "earn_pts_for_every": "Verdienen Sie %{pts} Punkte für alle",
    "you_track": "die Sie aufzeichnen!",
    "you_have_tracked": "Sie haben %{qty} aufgezeichnet",
    "so_far": "bis jetzt!",
    "start_goal": "Dieses Ziel festlegen",
    "about_this_goal": "Über dieses Ziel",
    "start_date": "Anfangsdatum",
    "end_date": "Abschlussdatum",
    "activities": "Aktivitäten",
    "goal": "Ziel",
    "instructions": "Anweisungen",
    "daily": "Täglich",
    "weekly": "Wöchentlich",
    "monthly": "Monatlich",
    "total": "Gesamt",
    "week": "Woche",
    "day": "Tag",
    "days": "Tage",
    "month": "Monat",
    "months": "Monate",
    "progress": "Fortschritt",
    "about": "Über",
    "days_remaining_to_track": "Sie haben %{num} Tage, um verpasste Aktivitäten zu verfolgen",
    "number_days": "%{num} Tage",
    "one_day": "1 Tag",
    "points_earned_this_week": "Diese Woche erhaltene Punkte",
    "points_earned_year": "Dieses Jahr verdiente Punkte",
    "completed": "Abgeschlossen",
    "what_you_need_to_do": "Was Sie noch tun müssen",
    "see_all_num": "Alle %{num} ansehen",
    "my_week_progress": "Ihr wöchentlicher Fortschritt",
    "my_day_progress": "Ihr täglicher Fortschritt",
    "my_month_progress": "Ihr monatlicher Fortschritt",
    "my_total_progress": "Ihr gesamter Fortschritt",
    "my_overall_progress": "Gesamter Fortschritt",
    "you_earned": "Sie haben erhalten:",
    "of_this_week": "%{num} diese Woche",
    "of_this_day": "%{num} heute",
    "of_this_month": "%{num} diesen Monat",
    "of_this_total": "%{num} gesamt",
    "of_this_overall": "%{num} gesamt",
    "remaining_this_week": "verbleibend diese Woche",
    "remaining_this_month": "verbleibend diesen Monat",
    "remaining_this_total": "verbleibend",
    "remaining_this_overall": "insgesamt verbleibend",
    "view_history": "Verlauf ansehen",
    "this_goal_is": "Dieses Ziel ist",
    "will_run_for": "Dauert",
    "button_unset_goal": "Ziel entfernen",
    "button_leave_challenge": "Herausforderung verlassen",
    "leaveChallenge": {
        "menu": "%{challengeName} verlassen"
    },
    "deleteChallenge": {
        "menu": "%{challengeName} löschen"
    },
    "unsetGoalToast": {
        "success": {
            "title": "%{title_name}",
            "message": "Sie haben dieses Ziel entfernt."
        }
    },
    "leaveChallengeToast": {
        "success": {
            "title": "%{title_name}",
            "message": "Sie haben die Herausforderng verlassen."
        }
    },
    "activities_tracked": "Verfolgte Aktivitäten",
    "recently_tracked_activities": "Kürzlich verfolgte Aktivitäten",
    "add": "Hinzufügen",
    "change_before_track": "Sie haben scheinbar noch keine Änderungen vorgenommen. Bearbeiten Sie die Anzahl der Aktivitäten für diesen Tag oder verlassen Sie die Herausforderung ohne Änderungen vorzunehmen.",
    "havent_tracked_today": "Sie haben scheinbar noch keine Aktivitäten für diesen Tag erfasst. Beginnen Sie mit der Suche nach einer Aktivität.",
    "cancel_tracking_quantity": "Verfolgung von %{quantity} von %{activity_name} abbrechen",
    "points": "%{customPoints}",
    "discard_activity_edits_confirmation": "Beim Beenden werden die Änderungen an Ihrem Aktivitätsverlauf verworfen. Sind Sie sicher?",
    "discard_activity_edits_confirmation_date": "Beim Beenden werden die Änderungen an Ihrem Aktivitätsverlauf für %{date} verworfen. Sind Sie sicher?",
    "yes_discard_edits": "Ja, beenden und Änderungen verwerfen",
    "createGoal": {
        "navigatorTitle": "Ein persönliches Ziel erstellen",
        "navigatorSubtitle": "Schritt %{step} von 4"
    },
    "allCommunities": "Alles",
    "deleteCommunityDescription": "Sind Sie sicher, dass Sie diese Gemeinschaft löschen möchten?",
    "remaining": "verbleibend",
    "recommended_goal": "Empfohlenes Ziel",
    "pinError": "Die PIN %{pin} ist ungültig. Bitte versuchen Sie es erneut.",
    "previousPersonalGoals": "Meine erreichten persönlichen Ziele",
    "previousGoalsTitle": "Meine vorherigen Ziele",
    "endedOn": "abgeschlossen am",
    "achievedOfGoal": "Sie haben %{num}% des Ziels erreicht",
    "previousGoalsEmptyMessage": "Sie haben keine vorherigen Ziele",
    "emptyListDefaultMessage": "Hier wurden keine Items für Sie gefunden",
    "myCommunitiesEmpty": "Scheinbar sind Sie noch keiner Gemeinschaft beigetreten. Treten Sie Gemeinschaften bei, um sich mit anderen auszutauschen und Ihre Erfahrungen zu teilen.",
    "discoverMoreCommunities": "Mehr Gemeinschaften entdecken",
    "howLong": "Dauer",
    "frequency": "Häufigkeit",
    "discard": "Verwerfen",
    "description": "Beschreibung",
    "optional": "optional",
    "instruction": "Anweisung",
    "name": "Name",
    "create": "Erstellen",
    "categories": "Kategorien",
    "uploadPhoto": "Foto hinzufügen",
    "delete_goal": "%{name} löschen",
    "delete_goal_confirmation": "Sind Sie sicher, dass Sie dieses Ziel löschen möchten?",
    "leave_goal_confirmation": "Sind Sie sicher, dass Sie diese Herausforderung verlassen möchten?",
    "creatingCustomGoalToast": {
        "success": {
            "message": "Ihr Ziel wurde erstellt."
        }
    },
    "defaultSelectMessage": "Bitte wählen Sie eine Option",
    "search": "Suchen",
    "inTotal": "insgesamt",
    "State": "Bundesland",
    "Business unit": "Unternehmensbereich",
    "Work location": "Arbeitsort",
    "whenStart": "Wann möchten Sie beginnen?",
    "every": "alle",
    "acceptChallenge": "Herausforderung annehmen",
    "activity_history_challenge": "Aktivitätsverlauf für die Herausforderung",
    "havent_tracked_challenge": "Sie haben keine Aktivitäten für diese Herausforderung erfasst",
    "earned_lowercase": "verdient",
    "noone_tracked_yet": "Niemand hat bisher etwas aufgezeichnet. Beginnen Sie mit der Verfolgung, um in diesem Wettbewerb die Nase vorn zu haben!",
    "you": "Sie",
    "your_team": "Mein Team",
    "congrats_first_place": "Herzlichen Glückwunsch, ihr seid auf dem ersten Platz! Weiter so.",
    "leader": "Anführer",
    "average": "Durchschnitt",
    "show_leader": "Anführer anzeigen",
    "show_me": "Mich anzeigen",
    "show_my_team": "Mein Team anzeigen",
    "leaderboard": "Bestenliste",
    "my_team": "Mein Team",
    "remaining_to_track": "noch zu verfolgen",
    "avg": "Durchschnitt",
    "invite": "Einladen",
    "team_members": "Mitglieder des Teams",
    "daysLeft": "Verbleibende tage",
    "regionNameLiveBetter": "Bundesland",
    "locationNameLiveBetter": "Arbeitsort",
    "departmentNameLiveBetter": "Unternehmensbereich",
    "regionLabelLiveBetter": "Bundesland wählen",
    "locationLabelLiveBetter": "Arbeitsort wählen",
    "departmentLabelLiveBetter": "Unternehmensbereich wählen",
    "companyLocation": "Arbeitsort",
    "no_location": "Kein Standort",
    "connect": "Verbinden",
    "syncing": "Wird synchronisiert",
    "sync": "Synchronisieren",
    "havent_tracked_in_a_while": "Keine kürzlich verfolgten Aktivitäten",
    "contact": "Kontakt",
    "manage": "Verwalten",
    "creator": "Verfasser",
    "allow_notifications": "Benachrichtigungen verwalten",
    "enable_notifications": "Benachrichtigungen einschalten",
    "appload": "Warten Sie einen Moment, während {app_name} aktualisiert wird...",
    "sendResetEmail": "E-Mail zum Zurücksetzen senden",
    "min": "Mind.",
    "max": "Max.",
    "error_joining_team": "Beitritt zum Team fehlgeschlagen",
    "cannot_add_to_team": "Hoppla... Beim Versuch, Sie zu diesem Team hinzuzufügen, ist etwas schief gelaufen. Es kann sein, dass das Team seine maximale Mitgliederzahl erreicht hat oder nicht mehr existiert. Versuchen Sie es erneut, falls ein anderer Fehler aufgetreten ist.",
    "members_needed": "%{num} Mitglieder notwendig",
    "member_needed": "%{num} Mitglied notwendig",
    "spots_left": "%{num} Plätze frei",
    "join": "Beitreten",
    "no_teams_create": "Derzeit gibt es keine Teams, denen Sie beitreten können. Warum erstellen Sie nicht eins?",
    "number_teams": "%{num} Teams",
    "youLowercase": "Sie",
    "joined_challenge_on_team": "Sie sind einer Herausforderung im Team %{team_name} beigetreten.",
    "join_team": "Einem Team beitreten",
    "former_members": "Ehemalige Mitglieder",
    "letsGo": "Auf geht´s",
    "invite_to_team": "Zum Team einladen",
    "connectingDeviceToast": {
        "success": {
            "title": "Verbinden Sie eine App oder ein Gerät",
            "message": "Geschafft! Ihre App oder Ihr Gerät ist verbunden."
        },
        "danger": {
            "title": "Verbinden Sie eine App oder ein Gerät",
            "message": "Hoppla... Wir hatten ein Problem beim Verbinden dieses Dienstes. Bitte versuchen Sie es erneut."
        }
    },
    "disconnectingDeviceToast": {
        "success": {
            "title": "Trennen Sie eine App oder ein Gerät",
            "message": "Sie haben %{name} erfolgreich getrennt."
        },
        "danger": {
            "title": "Trennen Sie eine App oder ein Gerät",
            "message": "Hoppla... Wir hatten ein Problem beim Trennen von %{name}. Bitte versuchen Sie es erneut."
        }
    },
    "leave_entity_question": "%{name} verlassen?",
    "delete_entity_question": "%{name} löschen?",
    "leave_team_challenge_confirmation": "Sind Sie sicher, dass %{name} in dieser Herausforderung bleiben soll?",
    "leave_last_team_member": "Wenn Sie das letzte Mitglied des Teams sind und diese Herausforderung verlassen, wird das Team gelöscht.",
    "oops_msg": "Hoppla... Beim Versuch diese Aktion auszuführen ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
    "has_been_created": "Sie sind der Herausforderung im Team %{name} beigetreten.",
    "specify_team_name": "Bitte geben Sie einen Teamnamen ein",
    "invite_members": "Mitglieder einladen",
    "upload_photo_no_question": "Foto hinzufügen",
    "my_progress": "Mein Fortschritt",
    "rewardsPointsAdditionalInfo": "Erhalten Sie %{reward_currency} für jedes erreichte Level pro %{period}. Ihre %{customPoints} und Levels fangen pro %{period} neu an, d. h. Sie haben die Möglichkeit, weiterhin %{reward_currency} zu verdienen, auch wenn Sie im vorherigen Zeitraum das höchste Level erreicht haben.",
    "rewardsPointsInfo": "Ihre %{customPoints} und Ihr Fortschritt wird pro %{period} zurückgesetzt.",
    "departments": "Abteilungen",
    "regions": "Regionen",
    "noItemsSelected": "Keine Einträge gewählt",
    "pleaseSelectOne": "Bitte wählen Sie mindestens einen Eintrag aus der Liste",
    "tracked": "Verfolgt",
    "starts": "Beginn",
    "duration": "Dauer",
    "bonus": "Bonus",
    "invited_by": "Eingeladen von",
    "create_team": "Ein Team erstellen",
    "discardConfirmation": "Sind Sie sicher, dass Sie die Verbindung beenden möchten?",
    "discardYes": "Ja",
    "discardStay": "Zurück",
    "create_team_toast_title": "Team erstellen",
    "edit_team": "Team bearbeiten",
    "team_edits_submitted": "Ihr Team wurde aktualisiert.",
    "challenge_ended_still_trackable": "%{type} ist zu Ende, zum Glück haben Sie noch %{num} Tage Zeit für die Nachverfolgung!",
    "tracking_period_ended": "Der Verfolgungszeitraum für %{type} ist vorbei.",
    "unlimited": "Unbegrenzt",
    "ends_in": "Endet in",
    "challenge_toast": {
        "success": {
            "join": "Geschafft!",
            "message": "Sie haben sich der Herausforderung erfolgreich angeschlossen."
        },
        "danger": {
            "error": "Fehler",
            "message": "Etwas ist schief gelaufen. Bitte versuchen Sie es später erneut, sich der Herausforderung anzuschließen."
        }
    },
    "members_to_invite": "Einzuladende Mitglieder",
    "members_to_remove": "Zu entfernende Mitglieder",
    "myChallenges": "Wettstreits",
    "upcoming": "Bevorstehend",
    "myPersonalGoals": "Ziele",
    "companyCompetitions": "Unternehmenswettstreits",
    "communityCompetitions": "Gemeinschaftswettstreits",
    "edit_your_team": "Ihr Team bearbeiten",
    "emails": "E-Mails",
    "CompletedOverall": "Insgesamt abgeschlossen",
    "TotalEarned": "Insgesamt verdient",
    "notify_header": "Ich möchte benachrichtigt werden:",
    "AdditionalBonus": "Zusätzlicher Bonus",
    "goalEndedNotification": "Ziel erreicht, weiter so!",
    "compEndedNotification": "Wettstreit beendet, weiter so!",
    "congrats_tracking_first": "Gratulation zu Ihrer ersten Aktivität!",
    "keep_tracking": "Verfolgen Sie Ihre Aktivitäten, um Ihre Ziele zu und ein höheres Level zu erreichen.",
    "understanding_tracking": "Hinweise zur Nachverfolgung",
    "cannot_track_this_day": "Die Verfolgung ist an diesem Tag nicht möglich.",
    "nothing_tracked_this_day": "Sie haben an diesem Tag noch nichts verfolgt.",
    "tracked_something_this_day": "Sie haben an diesem Tag etwas erfasst.",
    "reached_goal_this_day": "Sie haben Ihr Ziel für diesen Tag erreicht (nur bei Tageszielen).",
    "got_it": "Verstanden!",
    "notDismissedMultiTitle": "Zusammenfassung der Herausforderung",
    "notDismissedMultiSubtitle": "Ein paar Herausforderungen sind vorbei. Sehen Sie sich die einzelnen Herausforderungen genauer an, um zu erfahren, wie Sie abgeschnitten haben. ",
    "daySummary": "%{userName}, hier ist eine Zusammenfassung Ihres bisherigen Tages",
    "goals": "Ziele",
    "competitions": "Wettstreits",
    "totalAccumulated": "Insgesamt erhalten",
    "tracking_for_date": "Aufzeichnung für den %{date}",
    "activity_tracker_instruction": "Tippen zum Bearbeiten oder Entfernen einer manuell verfolgten Aktivität",
    "ended": "Beendet",
    "notYetAvailableBeta": "Noch nicht in der Beta-Version verfügbar",
    "suggestedGoal": "Vorgeschlagenes Ziel",
    "singleFor": "für",
    "seeLessLongComment": "Weniger ansehen",
    "synced_data": "Synchronisierte Daten:",
    "doThisLater": "Ich mache das später",
    "inviteUsers": "Andere zum Mitmachen einladen",
    "cannotTrackAfterDeadline": "Sie versuchen eine Aktivität nach dem Enddatum der Herausforderung zu erfassen.",
    "potentialBonusPoints": {
        "section": {
            "title": "Für dieses Ziel sind %{potentialBonusPoints} Bonuspunkte %{customPoints} verfügbar!",
            "titleNotCompleted": "Sie haben den %{potentialBonusPoints}-Bonus %{customPoints} um %{activityCompletedPercentage}% verpasst.",
            "titleCompleted": "Glückwunsch! Sie haben erhalten:",
            "titleCompletedBold": "%{potentialBonusPoints} Bonus %{customPoints}!",
            "subtitle": "Erfahren Sie mehr über den %{customPoints} Bonus"
        },
        "modal": {
            "title": "%{customPoints} Bonus",
            "desc1": "Wir wissen, dass niemand perfekt ist und die Ziele nicht immer zu 100 % erreicht werden können.",
            "desc2": "Deshalb vergeben wir %{customPoints} als Bonus, wenn Ihr Gesamtfortschritt 85 % oder mehr beträgt.",
            "desc3": "Jeder Bonus in Form von %{customPoints} wird nach Abschluss des Ziels gutgeschrieben und wenn Sie Ihre gesamten Aufzeichnungen über eine verbundene App oder ein verbundenes Gerät vorgenommen haben, erhalten Sie einen doppelten Bonus in Form von %{customPoints}!",
            "desc4": "Sie erhalten keinen Bonus in Form von %{customPoints} für Ziele, die Sie vorzeitig verlassen."
        },
        "msg": {
            "title": "Dieses Ziel ist abgelaufen",
            "subtitle": "Das Ziel endete am %{goalEndedDate}"
        },
        "msgEnded": {
            "title": "Die Zeit ist um! Ihr Ziel ist abgelaufen",
            "subtitle": "Sie haben %{daysNum} %{daysOrDay}, um Ihre Aktivität zu verfolgen."
        }
    },
    "finish": "Abschließen",
    "personalGoal": {
        "all_goals": {
            "selected": "Alle %{maxGoals} Ziele festgelegt!",
            "description": "Gefällt Ihnen das? Sie können jedes Ziel ersetzen, wenn Sie Ihre Meinung ändern. Keine Sorge, Sie können Ihr Ziel später wieder zurücksetzen.",
            "set": "Alle Ziele wurden festgelegt!",
            "action": "Alles eingestellt. Es kann losgehen!",
            "error": "Übertreiben Sie nicht! Wenn Sie sich auf max. 3 konkrete Ziele gleichzeitig konzentrieren, ist Ihre Erfolgswahrscheinlichkeit höher.",
            "errorHeading": "Ziele werden gesetzt"
        },
        "set_more": "Sie können %{maxGoals} weitere Ziele festlegen",
        "select_goal": {
            "heading": "Legen Sie ein empfohlenes Ziel fest oder erstellen Sie Ihr eigenes"
        },
        "set_more_1": "Sie können 1 weiteres aktives Ziel festlegen"
    },
    "restartPersonalGoal": "Ziel mit neuen Zielsetzungen erneut starten",
    "delete_challenge_confirmation": "Sind Sie sicher, dass Sie diese Herausforderung löschen möchten?",
    "personal_goal_unit": "Ziel",
    "personal_goal_units": "Ziele",
    "day_summary": {
        "steps_taken": "Getätigte Schritte",
        "calories_in": "Kalorienaufnahme",
        "calories_out": "Kalorienverbrennung",
        "avg_daily": "tägl. Durchschnitt",
        "most_earned_daily": "höchster Tageswert"
    },
    "invitedBy": "Eingeladen von %{person}",
    "resetPasswordMissingField": "Geben Sie bitte eine E-Mail-Adresse ein",
    "resetPasswordInvalidValue": "Geben Sie bitte eine gültige E-Mail-Adresse ein",
    "resetPasswordNotFound": "Ihre E-Mail-Adresse wurde nicht gefunden",
    "resetPasswordNotCompleted": "Ihre Anfrage konnte nicht ausgeführt werden",
    "resetGoalInstructions": {
        "start": "Machen Sie %{quantity} %{units} von %{activity}",
        "additional": ", %{quantity} %{units} von %{activity}",
        "end": "%{frequency} und erhalten Sie %{points} %{customPoints} %{frequency}"
    },
    "goalSet": {
        "one": "Ein Ziel gesetzt. Ansehen",
        "two": "Zwei Ziele gesetzt. Ansehen",
        "three": "Drei Ziele gesetzt. Ansehen",
        "none": "Keine Ziele gesetzt. Ziele setzen"
    },
    "searchCommunitiesEmpty": "Keine Gemeinschaften gefunden",
    "searchCommunitiesPlaceholder": "Gemeinschaften suchen",
    "updating": "Wird aktualisiert...",
    "pts_tracked": "Verfolgt %{activityName} - %{num} %{customPoints}",
    "improving_wellbeing_score": "Machen Sie weiter so, Sie sind auf dem besten Weg, Ihren Wohlbefindenswert zu verbessern.",
    "progressHistory": "Fortschrittsverlauf",
    "privateCommunity": "Dies ist eine private Gemeinschaft",
    "do_combo_of_activities": "Führen Sie eine der folgenden Kombinationen aus.",
    "noActivitiesTracked": "Es wurden keine Aktivitäten aufgezeichnet",
    "trackingWithFollowingApps": "Aufzeichnung mit folgenden Apps\/Geräten",
    "recommendedApps": "Empfohlene Apps\/Geräte für %{challengeType}",
    "collapseWord": "Zusammenklappen",
    "started": "Begonnen",
    "ends": "Ende ",
    "do_activities": "Aktivitäten ausführen",
    "rewards_placeholder": "Beispielprämien aus dem Shop, Platzhalter. Die Benutzer sehen verschiedene Produkte, die sie kaufen können, und die Kosten unter %{rewardName}.",
    "personalGoals": {
        "top": {
            "label": "Nach oben"
        },
        "allGoals": "Alle Ziele",
        "seeMoreCard": {
            "heading": "Finden Sie nicht, was Sie suchen?",
            "description": "Sehen Sie sich alle empfohlenen Ziele an",
            "button": "Ziele erkunden"
        }
    },
    "rewardsNotAvailable": "Belohnungen sind in dieser Beta-Version noch nicht verfügbar. Sobald sie verfügbar sind, können Sie den Katalog aufrufen und eine Prämie einlösen.",
    "editProfileProvideRestingHeartRate": "Bitte geben Sie einen gültigen Wert (mindestens 40) für Ihren Ruhepuls an",
    "liveBetterHealthInfo": "Wir bieten eine Reihe von Programmen und Gesundheitsinhalten an, die verschiedene Gesundheitsbedürfnisse ansprechen und Ihnen helfen sollen, gesünder zu leben. Wir haben noch nicht für jeden Gesundheitszustand und jedes Bedürfnis ein Programm, aber wir arbeiten daran! Wenn Sie aber die folgenden Fragen beantworten, werden wir uns mit Ihnen in Verbindung setzen, wenn wir Gesundheitsprogramme oder -dienste finden, die für Sie von Nutzen sein könnten, und\/oder Ihnen evidenzbasierte Informationen schicken, die Ihnen helfen Ihre medizinischen Bedürfnisse besser zu verstehen und damit umzugehen. Bitte beachten Sie, dass wir diese Informationen nicht verwenden, um Ihren Versicherungsschutz zu bewerten. Wenn Sie wissen möchten, was Ihre Versicherung abdeckt, oder wenn Sie Fragen zu Ihrem Vertrag haben, können Sie unser Customer-Connect-Team unter der Nummer 132 331 erreichen.",
    "deleteGoalToast": {
        "success": {
            "title": "%{title_name}",
            "message": "Sie haben das Ziel gelöscht"
        }
    },
    "deleteChallengeToast": {
        "success": {
            "title": "%{title_name}",
            "message": "Sie haben die Herausforderng gelöscht"
        }
    },
    "invitations": "Einladungen",
    "learnMorePeriods": "Erfahren Sie mehr über die Zeiträume",
    "tracked_by_app_name": "Aufgezeichnet von %{app_name}",
    "device_required": {
        "text": "%{challengeType} erfordert eine App oder ein Gerät",
        "button": "Verbinden Sie eine App oder ein Gerät"
    },
    "editingCommunityToast": {
        "success": {
            "title": "Gemeinschaft bearbeiten",
            "message": "Die Gemeinschaft wurde bearbeitet"
        }
    },
    "competition": "Wettstreit",
    "close": "Schließen",
    "only_automatic_activities_with_device": "Die Aktivitäten für dieses\/n %{goal_or_competition} werden automatisch mit Ihren verbundenen Apps\/Geräten erfasst.",
    "only_automatic_activity_with_device": "Die Aktivität für dieses\/n %{goal_or_competition} wird automatisch mit Ihren verbundenen Apps\/Geräten erfasst.",
    "deletingCommunityToast": {
        "success": {
            "title": "%{name}",
            "message": "Gemeinschaft gelöscht"
        }
    },
    "teamSizeMessage": "Ihr Team braucht mindestens %{min} Personen, um %{customPoints} für die Herausforderung zu verdienen.",
    "captain": "Teamleiter",
    "inviteOthersToTeam": "Andere in mein Team einladen",
    "loadingMetrics": "Verknüpfung mit Quellen zur Aktualisierung Ihres Tages...",
    "aboutTeamSize": {
        "title": "Teamgröße",
        "text": "%{min} bis %{max}"
    },
    "pointsOverview": "%{customPoints} Übersicht",
    "deepLinks": {
        "requestCouldNotBeCompleted": "Ihre Anfrage konnte nicht ausgeführt werden",
        "error": "Fehler"
    },
    "required_lc": "erforderlich",
    "personal": "Persönliche Angaben",
    "biometrics": "Biometrische Daten",
    "makeSelection": "Wählen Sie etwas aus",
    "ask_question_success_msg": "Vielen Dank. Wir werden Ihnen so schnell wie möglich antworten.",
    "report_issue_success_msg": "Vielen Dank. Wir werden Ihnen so schnell wie möglich antworten.",
    "ask_question_success_title": "Frage gesendet",
    "report_issue_success_title": "Technische Probleme übermittelt",
    "ask_question_failure_msg": "Schade... Beim senden Ihrer Frage ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
    "report_issue_failure_msg": "Schade... Bei der Übermittlung des Problems ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
    "notTrackedActivities": "Sie haben für diesen Zeitraum keine Aktivitäten erfasst",
    "learn": "Mehr erfahren",
    "Balance": "Punktestand",
    "details": "Details",
    "Reward": "Belohnung",
    "levelsReset": "Die Levels werden in %{remainingDays} Tagen zurückgesetzt",
    "redeem": "Einlösen",
    "redeemAt": "Einlösen ab %{points}",
    "needPointsToRedeem": "Sie brauchen %{points} mehr %{rewardName}.",
    "learnEarnMore": "Erfahren Sie, wie Sie mehr Punkte erhalten können",
    "currency": "SproutBucks",
    "joiningTeamChallengeToast": {
        "success": {
            "title": "Team beitreten",
            "message": "Sie sind dem Team erfolgreich beigetreten!"
        },
        "danger": {
            "message": "Es ist ein Fehler aufgetreten. Wir konnten das Team nicht finden. Es existiert evtl. nicht mehr."
        }
    },
    "NoMatchingDeepLinkToast": {
        "danger": {
            "title": "Aktion nicht möglich",
            "message": "Ihre Anfrage konnte nicht ausgeführt werden."
        }
    },
    "transactionLog": "Transaktionen",
    "orderHistory": "Bestellungen",
    "pointsAvailableToEarn": "%{points} zum Sammeln verfügbar",
    "missedYTD": "%{missed} bis jetzt verpasst",
    "rewardsDetails": "Belohnungen",
    "successfullyRedeemedItem": "Sie haben diesen Artikel erfolgreich eingelöst",
    "orderNumber": "Bestellnummer",
    "amountSpent": "Ausgegebener Betrag",
    "status": "Status",
    "dateRedeemed": "Einlösedatum",
    "additionalInformation": "Zusätzliche Informationen",
    "shipToAddress": "An diese Adresse versenden",
    "pointMissedYearToDate": "%{rewardCurrencyName} verpasst in diesem Jahr",
    "pointMissedYearToDateDescription": "Wenn Sie ein Level nicht vor Ablauf des Zeitraums erreichen, verpassen Sie somit die damit verbundenen %{rewardCurrencyName}, die Sie hätten erhalten können.",
    "NoLibraryContentToast": {
        "info": {
            "title": "Artikel nicht gefunden",
            "message": "Artikel nicht gefunden. Er wurde evtl. entfernt oder ist nicht mehr verfügbar."
        }
    },
    "CommunityNotFoundToast": {
        "danger": {
            "title": "Gemeinschaft nicht gefunden",
            "message": "Gemeinschaft nicht gefunden. Sie wurde evtl. entfernt oder ist nicht mehr verfügbar."
        }
    },
    "shippingAddress": "Versand-\/Rechnungsadresse",
    "enterShippingAddress": "Geben Sie Ihre Versand-\/Rechnungsadresse ein",
    "streetLine": "Straße %{num}",
    "stateProvince": "Bundesland",
    "postcodePostalcodeZip": "PLZ",
    "phoneNumber": "Tel.-Nr.",
    "order": "Bestellung",
    "redemptionConfirmation": "Einlösebestätigung",
    "edit": "Bearbeiten",
    "processing": "Wird verarbeitet",
    "checkIsYouFirst": "Wir müssen erst prüfen, ob Sie es sind",
    "discardSomeGoals": "Sie haben sich ein paar Ziele gesetzt. Diese Ziele werden verworfen, wenn Sie fortfahren.",
    "settingGoalsToast": {
        "success": {
            "message": "Ihre neuen Ziele wurden festgelegt!"
        }
    },
    "one_team": "1 Team",
    "noAchievementsToEarnMessage": "Es gibt in diesem Zeitraum scheinbar keine Abzeichen mehr, um %{rewardCurrencyName} zu erhalten.",
    "shopRewards": "Belohnungen ansehen",
    "validateShippingAddressToast": {
        "danger": {
            "title": "Versand-\/Rechnungsadresse",
            "message": "Bitte füllen Sie alle Felder aus, bevor Sie fortfahren."
        }
    },
    "viewDetails": "Details ansehen",
    "potential": "Möglichkeiten",
    "missed": "Verpasst",
    "rewardsStoreNotAvailable": "Der Prämienshop ist derzeit nicht für Sie verfügbar.",
    "havent_tracked_in_a_while_date": "Keine Aktivitäten für %{currentDate} erfasst",
    "challengeNotFoundToast": {
        "danger": {
            "title": "Herausforderung nicht gefunden",
            "message": "Herausforderung nicht gefunden. Sie wurde evtl. entfernt oder ist nicht mehr verfügbar."
        }
    },
    "shareYourDaySubtitleActivity": "Fügen Sie ein Bild hinzu oder schreiben Sie etwas über diese Aktivität!",
    "goal_ended": "Ziel vorbei",
    "challenge_ended": "Herausforderung vorbei",
    "day_remaining_to_track": "Sie haben 1 Tag, um die verpassten Aktivitäten zu verfolgen",
    "challengeGoalCardSubtitleEndDate": "%{challengeOrGoal} endete am %{endDate}",
    "goalEndedModal": {
        "title": "Vergessene Aktivitäten nachholen",
        "message": "Nachdem ein persönliches Ziel oder eine Herausforderung vorbei ist, haben Sie ab dem Abschlussdatum drei Tage Zeit, um alle Aktivitäten zu erfassen, die Sie evtl. vergessen haben. Nach Ablauf dieser Frist können Sie keine weiteren Aktivitäten aufzeichnen, die zu dem Ziel oder der Herausforderung gehören."
    },
    "summary": "Zusammenfassung",
    "placedRank": "Sie sind auf dem %{rank} Platz von %{total}",
    "rank": {
        "first": "1.",
        "second": "2.",
        "third": "3.",
        "n": "%{rank}."
    },
    "event_name": "Name des Events",
    "this_is": "Dies ist ein\/e  ",
    "location_info": "Standort & Infos",
    "what_event": "Worum geht es bei diesem Event",
    "event_is": "Dieses Event ist",
    "start_on": "Anfangsdatum:",
    "end_on": "Abschlussdatum:",
    "location": "Standort",
    "chooseLeaderboard": "Wählen Sie ein Ranking",
    "filterOneOfFollowing": "Filtern Sie eine der folgenden Optionen",
    "showChallengeInstead": "Lieber eine Herausforderung anzeigen",
    "showActivityInstead": "Lieber eine Aktivität anzeigen",
    "showAll": "Alle anzeigen",
    "activitiesShowSame": "Aktivitäten: %{activityName}",
    "challengeShowSame": "Herausforderung: %{challengeName}",
    "chooseTimePeriod": "Wählen Sie einen Zeitraum",
    "youCanFilterOneAtTime": "Es kann jeweils ein Filter gewählt werden",
    "saveHealthTopicsToast": {
        "success": {
            "message": "Gesundheitsthemen gespeichert",
            "title": "Geschafft!"
        },
        "info": {
            "message": "Speichern nicht möglich"
        },
        "danger": {
            "title": "Fehler!"
        }
    },
    "saveHealthObjectivesToast": {
        "success": {
            "message": "Gesundheitsziele gespeichert",
            "title": "Geschafft!"
        },
        "info": {
            "message": "Speichern nicht möglich"
        },
        "danger": {
            "title": "Fehler!"
        }
    },
    "saveInterestGroupsToast": {
        "success": {
            "message": "Interessen gespeichert",
            "title": "Geschafft!"
        },
        "info": {
            "message": "Speichern nicht möglich"
        },
        "danger": {
            "title": "Fehler!"
        }
    },
    "edit_event": "Event bearbeiten",
    "leave": "Verlassen",
    "delete_event": "Event löschen",
    "no_events": "Keine Events",
    "no_events_placeholder": "Sie haben derzeit keine zukünftigen Events geplant. Warum nehmen Sie nicht an einem teil?",
    "event": "Event  ",
    "challenge": "Herausforderung",
    "invited_you": "Hat Sie eingeladen",
    "public": "Öffentlich",
    "private": "Privat",
    "deleteEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "Event erfolgreich gelöscht."
        }
    },
    "leaveEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "Sie haben das Event verlassen"
        }
    },
    "editEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "Event erfolgreich aktualisiert."
        }
    },
    "createEventToast": {
        "success": {
            "message": "Event erfolgreich erstellt.",
            "title": "%{eventName}"
        }
    },
    "contentIsDeletedOrInappropriate": "Der Inhalt, den Sie ansehen möchten, ist derzeit nicht verfügbar. Er wurde evtl. vom Autor gelöscht oder als unangemessen markiert.",
    "start_time": "Anfangszeitpunkt",
    "end_time": "Endzeitpunkt",
    "event_type": "%{eventType} Event",
    "leave_event_modal": {
        "title": "Wenn Sie dieses Event verlassen",
        "message": "Wird es gelöscht"
    },
    "leave_event ": "Sind Sie sicher, dass Sie dieses Event verlassen möchten?",
    "create_event": "Ein Event erstellen",
    "created_by": "Erstellt von",
    "eventActionToast": {
        "danger": {
            "title": "Fehler",
            "message": "Etwas ist schief gelaufen. "
        }
    },
    "continue": "Fortfahren",
    "wantExitTour": "Sind Sie sicher, dass Sie die Tour beenden möchten?",
    "exitTour": "Tour beenden",
    "deleveEventPopup": "Sind Sie sicher, dass Sie dieses Event löschen möchten?",
    "attendeesTitle": "Teilnehmer",
    "userEvents": "%{name}s Events",
    "createEventIndicator": "Event wird erstellt",
    "inviteToEvent": "Zum Event einladen",
    "noDescription": "Keine Beschreibung vorhanden.",
    "leaderboardIsEmpty": "Dieses Ranking enthält keine Informationen oder Sie müssen Ihre Aktivitäten innerhalb des ausgewählten Zeitraums erfassen, um es anzusehen",
    "notParticipantingInAnyChallenges": "Sie nehmen an keiner Herausforderung teil",
    "buttonLeaveEvent": "Event verlassen",
    "leaveEvent ": "%{name} verlassen?",
    "canceledCreatingChallenge": "Das Erstellen von %{challengeType} wurde erfolgreich abgebrochen",
    "swipeReadNotification": "Lesen",
    "productTour": {
        "initialScreen": {
            "title": "Willkommen bei %{programName}!",
            "body": "Machen Sie eine kleine Tour, um die Grundlagen zu verstehen."
        },
        "dashboard": {
            "title": "Übersicht",
            "body": "Hier sehen Sie Ihre %{pointsName} und Ihren Fortschritt bei den Levels. Im Ranking können Sie dann sehen, wie Sie abschneiden."
        },
        "rewards": {
            "title": "Belohnungen",
            "body": "Erfahren Sie, wie viele %{rewardPointName} Sie haben und lösen Sie sie im Shop ein."
        },
        "goals": {
            "title": "Ziele & Herausforderungen",
            "body": "Hier finden Sie Ihre persönlichen aktivierten Ziele, Herausforderungen mit anderen und besonderen Aufgaben."
        },
        "explore": {
            "title": "Erkunden",
            "body": "Hier können Sie sich mit anderen an Herausforderungen beteiligen, sich mit anderen über Ihre Interessen austauschen und einen neuen Artikel in der Mediathek entdecken."
        },
        "me": {
            "title": "Ich",
            "body": "Hier finden Sie Ihren Wohlbefindenswert, können Ihre Statistiken einsehen und Ihr Profil & Ihre Einstellungen bearbeiten."
        },
        "finishScreen": {
            "title": "Sie sind soweit",
            "body": "Vielen Dank, dass Sie die Tour abgeschlossen haben.",
            "button": "Auf geht´s"
        },
        "skip": {
            "title": "Sind Sie sicher, dass Sie die Tour überspringen möchten?",
            "body": "Dadurch wird die Tour beendet und Sie können sofort loslegen."
        }
    },
    "getTemporaryRewardRedemptionTokenToast": {
        "danger": {
            "title": "Authentifizierungsfehler",
            "message": "Die Prämieneinlösung konnte nicht durchgeführt werden. Bei der Authentifizierung beim Prämienanbieter ist ein Fehler aufgetreten."
        }
    },
    "rewardRedemptionFailureToast": {
        "danger": {
            "title": "Einlösen fehlgeschlagen",
            "message": "%{displayMessage}"
        }
    },
    "disclamerSectionTitle": "Bevor Sie anfangen",
    "disclamerSectionMessage": "Lassen Sie sich von Ihrem Arzt beraten, bevor Sie ein neues Trainingsprogramm beginnen oder Ihren Lebensstil ändern, um sicherzustellen, dass dies für Sie geeignet ist.",
    "noEarchedAchievements": "Sie haben noch keine Erfolge erzielt. Erfassen Sie eine Aktivität, um anzufangen.",
    "noInProgressAchievements": "Es wurden noch keine laufenden Leistungen registriert.",
    "discardCreatingEventMessage": "Überprüfen Sie, ob Sie alle erforderlichen Felder ausgefüllt haben",
    "discardCreatingEventTitle": "Event kann nicht erstellt werden",
    "discardEditedEventTitle": "Event kann nicht bearbeitet werden",
    "errorEventNameMessage": "Name erforderlich",
    "errorEventStartDateMessage": "Anfangsdatum erforderlich",
    "errorEventEndDateMessage": "Abschlussdatum erforderlich",
    "errorEventDateMessage": "Das Enddatum kann nicht vor dem Anfangsdatum liegen",
    "noAccountsToLink": "Es sind keine Konten zur Verknüpfung mit %{program_name} verfügbar.",
    "accountLinkEmailChanged": "Ihre E-Mail-Adresse wurde aktualisiert. Melden Sie sich in Zukunft mit dem verknüpften Konto an.",
    "accountLinkSuccessful": "Ihr Konto wurde erfolgreich verknüpft.",
    "edit_profile_nan_value": "Der Wert muss eine Zahl sein",
    "advancedLogIn": "Fortgeschrittene Anmeldung",
    "redemptionSessionExpiredToast": {
        "danger": {
            "title": "Einlösen fehlgeschlagen",
            "message": "Die Sitzung ist abgelaufen. Bitte versuchen Sie, die Bestellung erneut aufzugeben."
        }
    },
    "left": "übrig",
    "eventsCarousel": {
        "emptyEvent": {
            "prompt": "Es scheint, als gäbe es derzeit keine Veranstaltungen, an denen Sie teilnehmen können. Warum erstellen Sie nicht eine?"
        }
    },
    "reachedHighestLevel": "Sie haben das höchste Level erreicht!",
    "error": "Fehler",
    "redeemRewardSuccessfulToast": {
        "success": {
            "title": "Belohnungen einlösen",
            "message": "Ihre Bestellung wurde abgeschickt"
        }
    },
    "redeemRewardComplete": "Einlösung abgeschlossen",
    "trackActivityTitle": {
        "oneUnit": "Aufzeichnen: 1 %{unit} von %{activity} am %{date}",
        "nUnit": "Aufzeichnen: {activity} am %{date}"
    },
    "ssoAuthenticationFailure": "Authentifizierungsfehler",
    "earnEvery": "Verdienen Sie pro %{frequency}",
    "earnOnce": "Nur einmal verdienen",
    "goalSettings": {
        "maximumSet": "Sie haben sich bereits das Maximum von 3 Zielen gesetzt.",
        "learnMore": "Erfahren Sie mehr zur Zielsetzung"
    },
    "allowMarketingComms": "Ich möchte Werbemitteilungen erhalten",
    "allowPartnerMarketingComms": "Ich möchte Werbemitteilungen von Partnern erhalten",
    "noUpcomingAchievements": "Es wurden keine zukünftigen Leistungen für Sie registriert.",
    "settingGoalToast": {
        "success": {
            "message": "Ihr neues Ziel wurde festgelegt!"
        }
    },
    "authentication": {
        "saml": {
            "error": "Der Dienst ist derzeit nicht verfügbar",
            "signin": "Integrierte Anmeldung",
            "signup": "Integrierte Anmeldung"
        }
    },
    "monthName": {
        "january": "Januar",
        "february": "Februar",
        "march": "März",
        "april": "April",
        "may": "Mai",
        "june": "Juni",
        "july": "Juli",
        "august": "August",
        "september": "September",
        "october": "Oktober",
        "november": "November",
        "december": "Dezember"
    },
    "promotedForMe": "Unterstützt",
    "appRating": {
        "enjoying": "Gefällt Ihnen unsere App?",
        "feedback": "Möchten Sie uns Ihr Feedback geben?",
        "appStore": "Möchten Sie uns im App Store bewerten?",
        "googlePlay": "Möchten Sie uns bei Google Play bewerten?",
        "notReally": "Nicht wirklich",
        "yes": "Ja!",
        "sure": "Klar",
        "noThanks": "Nein danke",
        "notNow": "Nicht jetzt"
    },
    "getMobileApp": "Um %{programName} auf Ihrem Smartphone zu verwenden, müssen Sie %{appStoreName} aus dem App Store oder bei Google Play herunterladen.",
    "newAppsDevicesDesign": {
        "getMobileApp": "Laden Sie die App %{programName} herunter",
        "searchInAppStore": "Suchen Sie im App Store Ihres Geräts nach %{programName}",
        "getMobileAppNoName": "Holen Sie sich die mobile App"
    },
    "editorAlert": {
        "discardChanges": "Änderungen verwerfen",
        "saveAndContinue": "Speichern und fortfahren",
        "title": "Ungespeicherte Änderungen",
        "text": "Sie haben Änderungen vorgenommen, die nicht gespeichert wurden. Was möchten Sie tun?"
    },
    "resources": "Ressourcen",
    "noResources": "Keine Ressourcen verfügbar",
    "viewAllResources": "Alle Ressourcen ansehen",
    "language": "Sparache",
    "eventStarted": "Das Event hat bereits angefangen. Registrierung abgeschlossen.",
    "Gender": "Geschlecht",
    "show": "Anzeigen",
    "hide": "Verbergen",
    "timeoutError": "Hoppla! Das dauert etwas zu lange. Bitte versuchen Sie es später noch einmal.",
    "SOT": {
        "sample_task": "Beispielaufgabe"
    },
    "cache": {
        "new_version": "Eine neue Version ist verfügbar!",
        "refresh_browser": "Klicken Sie hier, um Ihren Browser zu aktualisieren."
    },
    "welcomeUser": "Herzlich willkommen %{userFirstName}!",
    "quarter": "Quartal",
    "completionReward": "Abschlussbelohnung",
    "bronzeLevel": "Bronze-Level",
    "deviceAppSyncingOk": "Geräte-\/Anwendungssynchronisierung ok",
    "deviceAppSyncingIssue": "Geräte-\/Anwendungssynchronisierungsproblem",
    "deviceAppSyncingError": "Geräte-\/Anwendungssynchronisierungsfehler",
    "lastSync": "Letzte Synchronisierung",
    "period": "Zeitraum",
    "yourDaySummary": "Ihr bisheriger Tag",
    "steps": "Schritte",
    "gender_non_binary": "Nicht-binär oder nicht konform",
    "take_survey": "Fragebogen ausfüllen",
    "social": "Gesellig",
    "finalDay": "Letzter Tag",
    "leaderboard_position": "Platzierung im Ranking",
    "signUp": {
        "apple": {
            "disconnectSettings": "Trennen Sie %{appName} von \"Apple ID Passwort & Sicherheit\" in den Telefoneinstellungen, um mit der Anmeldung fortzufahren"
        }
    },
    "earnPoints": "Sammeln Sie %{customPoints}. Steigen Sie auf.",
    "getReward": "Erhalten Sie %{rewardName}.",
    "buildHealthyHabits": "Gesunde Gewohnheiten entwickeln.",
    "highestLevelIndicator": "Sie haben das höchste Level erreicht!",
    "highestLevelIndicatorNew": "Sie haben alle Levels abgeschlossen!",
    "trackYourActivity": "Um %{customPoints} zu erhalten, müssen Sie Ihre Sport- und Wohlfühlaktivitäten aufzeichnen.",
    "levelUpToGetRewarded": "Wenn Sie ein Level aufsteigen, werden Sie mit %{rewardName} belohnt.",
    "levelUpAndEarn": "Ihr Fortschritt wird pro %{period} zurückgesetzt, sodass Sie immer wieder aufsteigen und Belohnungen erhalten können.",
    "levelUp": "Ihr Fortschritt wird pro %{period} zurückgesetzt, sodass Sie immer weiter aufsteigen können.",
    "goToLibrary": "Zur Mediathek gehen",
    "updateEventIndicator": "Event wird aktualisiert",
    "meTour": {
        "healthSurveyDisabled": "Hier können Sie Ihre Statistiken einsehen und Ihr Profil & Ihre Einstellungen bearbeiten."
    },
    "createNewGoal": "Neues Ziel erstellen",
    "later": "Später",
    "bonusChallenge": "Bonusherausforderung",
    "bonusChallengeInfo": {
        "withReward": "Sie erhalten einen Bonus von %{amount} %{points}, wenn Sie mind. 85% von %{challengeType} abschließen.",
        "noReward": "Sie erhalten einen Bonus, wenn Sie mind. 85% von dieser Herausforderung abschließen.",
        "boldText": "%{amount} Bonus %{points}",
        "noRewardChallengeType": "Sie erhalten einen Bonus, wenn Sie mind. 85% von %{challengeType} abschließen."
    },
    "defaultApp": "Ihre voreingestellte Gesundheits-App",
    "bonusGoal": {
        "additionalInfo": "Wenn Ihre gesamte Aktivität mit einer verbundenen App oder einem Gerät aufgezeichnet wurde, erhalten Sie einen doppelten Bonus von %{points}!",
        "additionalInfoNew": {
            "paragraph2": "Der Bonus von %{points} wird nach Ablauf des Ziels vergeben. Sie erhalten keine Bonus von %{points} für Ziele, die Sie vorzeitig verlassen."
        },
        "boldText": "doppelter Bonus %{points}!",
        "markTitle": "Bonusziel"
    },
    "notify_me": "Benachrichtigt mich",
    "bonusChallengeReward": "Bonusherausforderungsbelohnung",
    "forCompletingChallenge": "Für den Abschluss von %{challengeName}",
    "notifications_text": "Benachrichtigungen helfen Ihnen dabei, Ihre Ziele zu erreichen und auf dem Laufenden zu bleiben.",
    "type_here": "Hier eingeben",
    "bonusEarned": "Erhaltener Bonus",
    "youEarnedBonus": "Sie haben diesen Bonus verdient!",
    "inviteOthersToChallenge": "Andere zum Mitmachen bei dieser Herausforderung einladen",
    "inviteOthersToYourTeam": "Andere in Ihr Team einladen",
    "manageTeam": "Team verwalten",
    "ft": "ft",
    "lbs": "lbs",
    "cm": "cm",
    "kg": "kg",
    "community": "Gemeinschaft",
    "chooseActivity": "Aktivität wählen",
    "Recent": "Neueste",
    "noActivities": "Keine übereinstimmenden Aktivitäten",
    "photoChooseText": "Wählen",
    "photoCancelText": "Abbrechen",
    "signIn": {
        "missingEmail": "Fehlende E-Mail-Adresse",
        "missingPassword": "Bitte vergewissern Sie sich, dass Sie das Passwort eingegeben haben",
        "invalidLogin": "Anmeldung ungültig",
        "accountLocked": "Ihr Konto wurde gesperrt. Bitte kontaktieren Sie Ihren Administrator",
        "accountMayNotExist": "Kein Konto für diese E-Mail-Adresse vorhanden. Melden Sie sich an, um ein Konto zu erstellen.",
        "wrongPassword": "Falsches Passwort. Versuchen Sie es erneut oder klicken Sie auf Passwort vergessen, um es zurückzusetzen."
    },
    "deleteGoalBonusPoints": "Wenn Sie den jeweiligen Bonus noch nicht erhalten haben, können Sie ihn nicht mehr erreichen.",
    "havent_tracked_goal": "Sie haben keine Aktivitäten für dieses Ziel erfasst",
    "trackActivity": {
        "search": "Aktivitäten suchen...",
        "text": "Aktivität verfolgen",
        "done": "Erledigt",
        "discardChanges": "Änderungen verwerfen?",
        "discardMessage": "Sind Sie sicher, dass Sie den Vorgang abbrechen und verwerfen möchten?",
        "discard": "Verwerfen",
        "limitMessage": "Sie können nur max. sieben Tage auf einmal verfolgen.",
        "inputDescription": "Menge an %{activity} am %{date}",
        "gracePeriod": "Sie haben %{n} %{text}, um die verpassten Aktivitäten zu verfolgen"
    },
    "dates": "Termine",
    "pickDates": "Wählen Sie einen anderen Termin",
    "selectDates": "Termine wählen",
    "limitReached": "Sie haben das Limit erreicht",
    "activity": "Aktivität",
    "keepUpTheGoodWork": "Machen Sie weiter so!",
    "activityTracked": "Verfolgte Aktivität",
    "new": "Neu",
    "newFeatureTitle": "Einfachere, schnellere Aktivitätsverfolgung",
    "newFeatureText": "Egal, ob Sie die Aktivitäten von heute, aus der Vergangenheit oder für mehrere Tage verfolgen, wir sind sicher, dass Sie dieses neue Erlebnis lieben werden.",
    "gotIt": "Verstanden!",
    "frequencyViewHistory": "Aufschlüsselung %{frequency} ansehen",
    "challengeDetails": {
        "trackTheseActivities": "Verfolgen Sie eine dieser Aktivitäten, um Fortschritte bei %{challengeType} zu erzielen."
    },
    "member": "Mitglied",
    "weeklyBreakdown": "Wöchentliche Aufschlüsselung",
    "setGoals": {
        "earnPointsText": {
            "start": "Verdienen",
            "end": "für das Festlegen Ihres ersten Ziels!"
        }
    },
    "weeklyGoalEnded": "Die Woche endete am",
    "weekFinished": "Sie haben eine Woche beendet von",
    "restartGoal": {
        "daysLeftToTrack": "Sie haben noch %{quantity} %{days}, um vergessene Fortschritte der letzten Woche zu verfolgen.",
        "weekEnded": "Diese Woche ist vorbei.",
        "timesUp": "Die Zeit ist um!",
        "period": {
            "title": "Zeitraum für das Ziel",
            "text": "Montag bis Sonntag, jede Woche"
        }
    },
    "membersPlural": "Mitglieder",
    "startedADayAgo": "Vor 1 Tag angefangen",
    "goalRestarted": "Sie haben dieses Ziel erneut gestartet",
    "weeklyGoals": "Wochenziel",
    "weeklyGoalsDescription": "Wochenziele fangen jeden Montag neu an, damit Sie gesunde Gewohnheiten über einen längeren Zeitraum aufrechterhalten.",
    "challengeEnded": "%{challengeType} ist vorbei",
    "goalEndedModalTitle": "Die Zeit ist um! %{challengeType} ist vorbei!",
    "yourProgress": "Ihr Fortschritt",
    "earn_withRewards": "Verfolgen Sie Ihre gesunde Aktivität, um (%{pts}) zu verdienen und Level zu bestehen. Wenn du ein Level aufsteigst, erhältst du %{currency}.",
    "earn_noRewards": "Suivez votre exercice et votre activité de bien-être pour gagner (%{pts}) et passer au niveau supérieur.",
    "currentPeriod": "Aktueller Zeitraum",
    "currentScore": "Aktueller Punktestand",
    "viewActivityLog": "Aktivitätsprotokoll ansehen",
    "balanceHistory": "Mein Punkteverlauf",
    "mymedibank": {
        "underAge": {
            "error": "Die Live Better-App ist nur für Nutzer ab 18 Jahren verfügbar. Weitere Informationen finden Sie in den AGBs von Live Better."
        }
    },
    "enhancedHomePageInfo": "Wir haben unsere Startseite umgestaltet! Jetzt können Sie Ihre Herausforderungen und Ziele noch einfacher verfolgen. Los geht's mit der Nachverfolgung!",
    "levelUpTitle": "Level aufsteigen",
    "levelUpDescription": "Steigern Sie Ihr Level, indem Sie Ihre Aktivitäten verfolgen und Ziele und Herausforderungen erfüllen. Wenn Sie aufsteigen, werden Sie mit %{currency} belohnt!",
    "achievementsDescription": "Schalten Sie diese speziellen Abzeichen frei, um %{currency} zu verdienen. Klicken Sie auf ein Abzeichen, um zu sehen, was Sie dafür tun müssen.",
    "bonusChallengesDescription": "Nehmen Sie an Herausforderungen teil und schließen Sie diese ab, um einen %{currency} Bonus zu erhalten.",
    "earnWithPartners": {
        "title": "Verdienen mithilfe von Partnern",
        "description": "Mitglieder von Medibank mit einer Krankenhaus- oder Zusatzversicherung können beim Einkauf oder bei Aktivitäten bei Partnern Punkte sammeln."
    },
    "browseAllPartners": "Alle Partner durchsuchen",
    "resetsIn": "Wird in %{daysNumber} Tagen zurückgesetzt",
    "thisIsALot": "Das ist ganz schön viel!",
    "areYouSure": "Sind sie sicher?",
    "trackingALotMessage": {
        "days": "Sie verfolgen über 2.000 %{customPoints} an %{daysNum} Tagen. Das ist ganz schön viel!",
        "day": "Sie verfolgen über 2.000 %{customPoints} an 1 Tag. Das ist ganz schön viel!"
    },
    "amSure": "Ich bin mir sicher",
    "activeMinutesAndSleep": {
        "title": "Verfolgung von aktiven Minuten und Schlaf durch Ihr Gerät",
        "description": "Ihr Gerät zeichnet aktive Minuten bei mäßiger oder intensiver körperlicher Betätigung auf (das ist ein gutes Training)! Verwenden Sie ein Gerät, um Ihren Schlaf zu verfolgen? Auch dafür erhalten Sie %{points}!"
    },
    "hourShort": "Std.",
    "hoursShort": "Std.",
    "secondsShort": "Sek.",
    "watchToEarn": "Sehen Sie dies an, um zu verdienen",
    "oneParticipant": "1 Teilnehmer",
    "oneTeam": "1 Team",
    "numberOfTeams": "%{num} Teams",
    "inviteToYourTeam": "Zu Ihrem Team einladen",
    "inviteToThisChallenge": "Zu dieser Herausforderung einladen",
    "challengeInstructionText": "Verfolgen Sie diese Aktivität, um Fortschritte bei %{challengeType} zu erzielen.",
    "showLess": "Weniger anzeigen",
    "startsTomorrow": "Fängt morgen an",
    "deadlineDayLeft": "verbleibender Tag",
    "deadlineDaysLeft": "verbleibende Tage",
    "deviceBonus": "Gerätebonus",
    "appsAndDevices": {
        "header": "Apps und Geräte",
        "linked": "Diese verknüpften Apps und Geräte sind für die Verfolgung für %{challengeType} geeignet:",
        "noLinked": "Keine passenden Apps oder Geräte verknüpft",
        "link": "Verknüpfen Sie Ihr Telefon, Ihre Uhr oder Ihre App zur automatischen Verfolgung."
    },
    "yourGoals": "Ihre Ziele",
    "yourChallenges": "Ihre Challenges",
    "position": "Platzierung",
    "team_success": "Team-Erfolg",
    "starts_in": "Beginnt in",
    "team_challenge": "Team-Herausforderung",
    "your_progress_today": "Ihr heutiger Fortschritt",
    "your_daily_avarage": "Ihr Tagesdurchschnitt ist",
    "this_week_progress": "Fortschritt diese Woche",
    "this_month_progress": "Fortschritt diesen Monat",
    "overall_progress": "Gesamter Fortschritt",
    "complete": "abgeschlossen",
    "overallSuccess": "Gesamterfolg",
    "teamSuccessAverage": "Durchschnittlicher Team-Erfolg",
    "progressDetails": "Fortschrittsdetails",
    "dayStreak": "%{n}-Tagesfolge!",
    "weekStreak": "%{n}-Wochenfolge!",
    "dailyProgress": "Täglicher Fortschritt",
    "participantsSuccessCount": {
        "overall": "%{amount} von %{total} Teilnehmern haben das Ziel erreicht",
        "day": "%{amount} von %{total} Teilnehmern haben das Ziel heute erreicht",
        "week": "%{amount} von %{total} Teilnehmern haben das Ziel diese Woche erreicht",
        "month": "%{amount} von %{total} Teilnehmern haben das Ziel diesen Monat erreicht"
    },
    "doubleBonusShort": "Doppelter Bonus!",
    "doubleBonusLong": "Sie haben sich einen doppelten Bonus verdient!",
    "recommendedGoalDescription": "Ziele helfen Ihnen bei der Verfolgung Ihrer Fortschritte und um motiviert zu bleiben!",
    "noParticipation": "Keine Teilnahme",
    "nothingToShow": "Es gibt wohl gerade nichts zu sehen",
    "yourTeam": "Ihr Team",
    "no_activity_title": "Keine Aktivität",
    "brandSupport": {
        "description": "Wir haben eine Unterstützung für die Synchronisierung von Aktivitäten mit Polar- und Withings-Smartwatches hinzugefügt. Zeit für Bewegung!"
    },
    "no_tracked_activities": "Sie haben noch keine Aktivitäten verfolgt.",
    "button_leave_community": "Gemeinschaft verlassen",
    "button_delete_challenge": "%{challengeType} löschen",
    "button_delete_community": "Gemeinschaft löschen",
    "button_delete_activity": "Aktivität löschen",
    "library_header_description": "Originelle Inhalte, um Sie auf Ihrem Weg zum Wohlbefinden zu informieren, motivieren und inspirieren.",
    "library_searchbar": "Mediathek durchsuchen...",
    "library_page_header": "Originelle Inhalte, um Sie auf Ihrem Weg zum Wohlbefinden zu informieren, motivieren und inspirieren.",
    "onboarding_button_title": "Ich bin fertig",
    "refresh_bar": "Zum Aktualisieren hier klicken",
    "content": {
        "min_read": "%{readingTime} Min. gelesen"
    },
    "noMembers": "Keine Mitglieder",
    "saved": "Gespeichert",
    "forYou": "Für Sie",
    "min read (Note: min as in minutes)": "",
    "send me program related email notifications": "",
    "send me weekly email updates": "",
    "you can earn this bade once every quarter": "",
    "badgeInstruction": "%{badgeInstruction} bis",
    "youCanEarnThisBadge": "Verdiene dieses Abzeichen alle einmal %{period}",
    "emailPreferences": "E-Mail-Einstellungen",
    "unsubscribeText": "Von allen Updates per E-Mail abmelden",
    "savingText": "Wird gespeichert...",
    "wrongTryLater": "Etwas ist schief gelaufen. Bitte versuchen Sie es später erneut.",
    "preferencesSaved": "Einstellungen gespeichert",
    "recommendedForYou": "Für Sie empfohlen",
    "formerMember": {
        "label": "Ehemaliges Mitglied"
    },
    "selectionsFromLibrary": "Eine Auswahl aus unserer Mediathek, die wir nur für Sie zusammengestellt haben",
    "goalsInfo": {
        "desc1": "um sich auf die Verbesserung Ihres Wohlbefindens zu konzentrieren.",
        "desc2": "Sie haben die maximale Anzahl an Zielen festgelegt."
    },
    "createMyOwn": "Mein\/e eigene\/s erstellen",
    "isAllSet": "ist fertig eingestellt!",
    "undoLabel": "Rückgängig machen",
    "terms": "Bedingungen",
    "placeOrder": "Bestellung aufgeben",
    "item": "Item",
    "redeemFor": "Einlösen gegen",
    "confirmYourOrder": "Bestätigen Sie Ihre Bestellung",
    "orderComplete": "Bestellung abgeschlossen",
    "redeemedFor": "Eingelöst gegen",
    "orderDetails": "Details zur Bestellung",
    "bonusGoalReward": "Bonuszielbelohnung",
    "orderSummary": "Zusammenfassung der Bestellung",
    "logoutSSO": {
        "title": "Sie haben sich von %{programName} abgemeldet.",
        "description": "Bis bald!",
        "signinAgain": "Klicken Sie hier, um sich erneut anzumelden"
    },
    "nothing_to_show": "Es gibt gerade nichts zum Ansehen",
    "no_saved_content": "Sie haben keine gespeicherten Inhalte",
    "restarts_every_week": "Startet jede Woche neu",
    "myGoals": "Meine Ziele",
    "goalGallery": "Ziele Übersicht",
    "share_smth": "Teilen Sie etwas…",
    "newFeatureModal": {
        "smartGoal": {
            "title": "Unser Schrittziel ist jetzt noch ausgeklügelter!",
            "description": "Ihre Wochen sind immer anders – und Ihre Ziele sind es jetzt auch! \n Mit dem Smart Mode passt sich Ihr Schrittziel an Ihre realen Aktivitäten an.\n Es ist auf Ihren Erfolg und Ihr Wohlbefinden ausgerichtet.",
            "action": "Probieren Sie es aus!"
        },
        "mePage": {
            "title": "Das neue Ich",
            "description": "Wir haben den Bereich „Ich“ neu gestaltet, um das Finden der Dinge, die Ihnen wichtig sind, einfacher zu machen – probieren Sie es aus!",
            "letsSeeBtn": "Mal sehen!",
            "llaterBtn": "Vielleicht später"
        },
        "bellEAP": {
            "title": "Willkommen auf Ihrer Online-Plattform für das Programm zur Unterstützung von Mitarbeitern und Familien!",
            "description": "Entdecken Sie die Tools und Services, die Ihnen und Ihren berechtigten Familienmitgliedern zur Verfügung stehen, um das Wohlbefinden und die Herausforderungen des Lebens zu meistern",
            "button": "Verbinden Sie sich jetzt oder besuchen Sie jederzeit die Seite Quick-Links"
        },
        "quickActivityLogView": {
            "title": " Eine schnellere Möglichkeit, Ihre letzten Aktivitäten anzuzeigen",
            "description": "Sie können jetzt auf den Fortschrittsbalken klicken, um Ihr Aktivitätsprotokoll anzuzeigen."
        }
    },
    "goalSmartMode": {
        "title": "Smart Mode",
        "description": "Erhalten Sie individuell angepasste Wochenziele, die auf Ihrem aktuellen Aktivitätsniveau basieren.",
        "status": "Der Smart Mode ist %{status} für dieses Ziel.",
        "infoModal": {
            "descriptionOne": "Wenn der Smart Mode aktiviert ist, ändert sich das Ziel jede Woche, basierend auf Ihrem aktuellen Aktivitätsniveau.",
            "descriptionTwo": "Wir werden Sie genau in dem Maße herausfordern, wie Sie es brauchen, um erfolgreich zu sein.",
            "instructions": ""
        },
        "settings": {
            "switch": "Smart Mode für mein Schrittziel aktivieren",
            "description": "Wenn der Smart Mode aktiviert ist, erhalten Sie am Anfang jeder Woche ein neues Schrittziel."
        },
        "enableSmartMode": "Smart Mode aktivieren",
        "settingsModal": {
            "descriptionTurnOn": "Ihr Schrittziel wird sich jede Woche ändern, basierend auf Ihren Aktivitäten",
            "descriptionTurnOff": "Ihr Schrittziel wird nicht mehr jede Woche individuell angepasst"
        }
    },
    "On": "An",
    "Off": "Aus",
    "top_posts": "Die besten Beiträge",
    "most_recent": "Neueste",
    "browseByTopic": "Nach Thema durchsuchen",
    "video": "Video",
    "enable": "Aktivieren",
    "turnOff": "Abschalten",
    "new_post": "Neuer Beitrag",
    "new_post_in": "Neuer Beitrag in",
    "dailyTarget": "Tägliches Ziel",
    "dailyTargetForWeek": "Tägliches Ziel für die Woche",
    "showMyActivityLog": "Mein Aktivitätsprotokoll anzeigen",
    "usersReacted": {
        "oneOther": "%{userName} und 1 anderer",
        "multipleOthers": "%{userName} und %{count} andere"
    },
    "reactionsModal": {
        "title": "Mehr Möglichkeiten zum Feiern",
        "description": "Feuern Sie Ihre Kollegen mit neuen Social-Post-Reaktionen an!"
    },
    "account": "Konto",
    "myWellbeingProfile": "Mein Wohlfühlprofil",
    "physicalDetailsDescription": "Diese Informationen werden zur Berechnung Ihres Wohlbefindenswerts benötigt",
    "wellbeingInterests": "Wohlergehensinteressen",
    "myWellbeingInterests": "Mein Wohlergehen interessiert",
    "preferredNameOptional": "Wunschname (optional)",
    "basicPhysicalDetails": "Grundlegende physikalische Details",
    "notRegistered": {
        "infoModal": {
            "title": "Wir können Sie nicht finden,",
            "notInSystem": "das Konto ist nicht in unserem System.",
            "correctEmail": "Stellen Sie sicher, dass Sie das richtige Konto verwenden (in der Regel eine Firmen-E-Mail-Adresse) und prüfen Sie Ihre Eingaben auf Tippfehler.",
            "emailHelp": "Wenn Sie weitere Hilfe benötigen, senden Sie eine E-Mail an unser Support-Team unter"
        }
    },
    "dontHaveAccount": "Sie haben noch kein Konto?",
    "wasThisHelpful": "Hat Ihnen das geholfen?",
    "healthScoreFeedbackModal": {
        "emojiSection": "Wie hilfreich ist diese Seite und Ihr Wohlbefindenfaktor?",
        "commentSectionText": "Wie können sie verbessert werden?",
        "commentSectionPlaceholder": "Kommentar hinzufügen...",
        "thankYouModal": "Vielen Dank für Ihr Feedback!"
    },
    "number_connected": "%{numDevices} verbunden",
    "searchPlaceHolder": "Suche...",
    "noTeamsFound": "Keine Teams gefunden",
    "join_a_challenge": "Einer Challenge beitreten",
    "me_page_titles": {
        "goal": {
            "singular": "Ziel",
            "plural": "Ziele"
        },
        "challenge": {
            "singular": "Challenge",
            "plural": "Challenges"
        }
    },
    "seeMoreText": "…mehr ansehen",
    "adjust_entry": "Bitte korrigieren Sie den Eintrag.",
    "overTracking": {
        "title": "Warnung: übermäßiges Tracking",
        "desc1": {
            "singular": "Dieser Eintrag wird überprüft.",
            "plural": "Diese Einträge werden überprüft."
        },
        "desc2": "Absichtlich übermäßiges Tracking kann zur Sperrung des Kontos führen.",
        "button_edit": "Meine Einträge bearbeiten",
        "button_confirm": "So einreichen"
    },
    "oneEventAttendee": "1 Teilnehmer",
    "multipleEventAttendees": "%{num} Teilnehmer",
    "to": "bis",
    "eventBonusFull": "Für die Teilnahme an diesem Event erhalten Sie %{number} bonus %{points}.",
    "eventBonusBold": "%{number} bonus %{points}",
    "didYouLikeArticle": "Hat Ihnen der Artikel gefallen?",
    "didYouLikeVideo": "Hat Ihnen dieses Video gefallen?",
    "tellUsMore": "Erzählen Sie uns mehr...",
    "thanksForFeedback": "Vielen Dank für Ihr Feedback!",
    "challengesSubtitle": "Erreichen Sie gemeinsam mit anderen Teilnehmern ein Ziel - oder spielen Sie um den Sieg!",
    "appStoreNameSprout": "Sprout at Work",
    "appStoreNameLiveBetter": "Medibank Live Better",
    "appStoreNameTelus": "TELUS Health Wellbeing",
    "huaweiStoreUrlSprout": "https:\/\/appgallery.huawei.com\/app\/C104993765",
    "telusHealthVirtualCare": "Telus Health Virtual Care",
    "virtualCare": "Virtual Care",
    "changePassword": {
        "telus": {
            "info": "Ihr Passwort wird über Ihr %{telusVC}-Konto verwaltet.",
            "button": "Mein %{virtualCare}-Passwort ändern"
        }
    },
    "actions": "Aktionen",
    "onAndUpcoming": "Laufende und kommende",
    "termsAndPrivacyPolicyNew": "Wenn Sie fortfahren, erklären Sie sich einverstanden mit den",
    "invitedToTeam": "Eingeladen zu Team von %{firstName} %{lastName}",
    "decline": "Ablehnen",
    "invitedToChallenge": "Eingeladen von %{firstName} %{lastName}",
    "goalsCard": {
        "emptyStateTitle": "Sie haben noch keine Ziele festgelegt"
    },
    "huaweiStoreUrlTelus": "https:\/\/appgallery.huawei.com\/app\/C107357173",
    "challengesCard": {
        "emptyStateTitle": "Sie nehmen an keinen Challenges teil",
        "buttonLabel": "Challenges ansehen"
    },
    "menu": "Menü",
    "everyone": "Alle",
    "confirmEmployeeID": "Mitarbeiter-ID bestätigen",
    "employeeIDNoMatch": "Die IDs stimmen noch nicht überein",
    "hidePost": "Beiträge von %{ownerName} ausblenden",
    "hidingUserPostToast": {
        "success": {
            "title": "Nutzer verborgen",
            "message": "Sie sehen keine Beiträge mehr von diesem Nutzer."
        }
    },
    "moderateHideUserDescription": "Durch das Ausblenden von Beiträgen für diesen Nutzer werden benutzerspezifische Inhalte aus dem Stream entfernt.",
    "startsInOneDay": "Beginnt in 1 Tag",
    "endsInOneDay": "Endet in 1 Tag",
    "endsToday": "Endet heute",
    "hrisEmployeeID": {
        "infoModal": {
            "notInSystem": "ist nicht in unserem System. Haben Sie sie korrekt eingegeben?",
            "administrator": "Wenn Sie ein neuer Mitarbeiter sind, haben wir möglicherweise noch nicht Ihre Mitarbeiter-ID. Bitte fragen Sie Ihren Administrator, wann Sie es erneut versuchen können.",
            "emailNotInSystem": "Wenn Sie ein neuer Mitarbeiter sind, kann es sein, dass Ihre E-Mail noch nicht in unser System aufgenommen wurde. Bitte fragen Sie Ihren Administrator, wann Sie es erneut versuchen können.",
            "eligibleEmail": "ist keine zulässige E-Mail-Adresse. Haben Sie die Adresse korrekt eingegeben?"
        }
    },
    "oneMember": "1 Mitglied",
    "programCode": {
        "infoModal": {
            "unique": "Ihr Unternehmen verfügt über einen eindeutigen Programmcode, der Ihnen in der Regel in einer E-Mail mitgeteilt wird.",
            "support": "Wenn Sie Ihren Code nicht finden können, wenden Sie sich an den Administrator Ihres Wellness-Programms oder senden Sie eine E-Mail an support@sproutatwork.com mit dem Namen Ihres Unternehmens."
        },
        "instructions": "Geben Sie den von Ihrem Arbeitgeber bereitgestellten Programmcode ein, um loszulegen"
    },
    "whatsMyProgramCode": "Wie lautet mein Programmcode?",
    "enjoyApp": "Nutzen Sie unsere mobile App",
    "programCodeLabel": "Programmcode",
    "createdByMembersChallenges": "Erstellt von Mitgliedern",
    "invites": "Einladungen",
    "recommendedContentTitle": "Bibliothekstipps für Sie",
    "amountExchanged": "Eingetauschter Betrag",
    "orderStatus": "Bestellstatus",
    "orderSuccessfulyyItemForConfirmation": "Bestellung erfolgreich! Eine Bestätigung wurde gesendet an %{email}.",
    "orderedOnDateText": "Auftrag erteilt %{orderCreatedTime}",
    "personalize": {
        "communities": {
            "title": "Gemeinschaften beitreten",
            "description": "Gemeinschaften verbinden Menschen mit gemeinsamen Interessen. Sie können Gemeinschaften jederzeit beitreten oder verlassen."
        },
        "objectives": {
            "title": "Meine Ziele",
            "description": "Bei welchen Aktivitäten können wir Ihnen helfen? Wir werden dies nutzen, um unsere Empfehlungen zu verbessern."
        },
        "topics": {
            "title": "Meine Themen zum Wohlbefinden",
            "description": "Hier finden Sie weitere Tipps und Anleitungen zu dieser Auswahl."
        }
    },
    "recommendedCardDesc": "Setzen Sie sich bis zu 3 Ziele, um Ihr Wohlbefinden zu verbessern",
    "accessibility": {
        "track_activity": "Aktivität verfolgen",
        "cardbody": "Card Body",
        "cardcontainer": "Card Container",
        "cardfooter": "Card Footer",
        "unstartedChallengeHeader": "Unstarted Challenge",
        "activeOrEndedChallengeWrapper": "Challenge Wrapper",
        "activeOrEndedChallengeHeader": "Challenge Header",
        "goalHeader": "Goal Header",
        "openOptions": "Öffnen Sie Optionen"
    },
    "teams": {
        "teamInvites": "Teameinladungen",
        "findTeam": "Ein Team finden",
        "teamFull": "Team ist komplett"
    },
    "deleteAccountText": "Ihr Sprout At Work-Konto und alle dazugehörigen Daten dauerhaft löschen",
    "deleteAccountButtonTitle": "Mein Konto löschen",
    "joinTeamActionSheetText": "Treten Sie einem Team bei oder erstellen Sie ein Team, um an dieser Challenge teilzunehmen",
    "frequencyNone": "keine",
    "quickLinkTitle": "Quick-Links",
    "moreTab": "Mehr",
    "addedBy": "Hinzugefügt von %{companyName}",
    "teamsTitle": "Teams",
    "helpAndSupport": "App-Hilfe & Support",
    "feedbackTitle": "Feedback geben",
    "feedbackDescription": "Sagen Sie uns, was Ihnen an der App gefällt und wo wir uns verbessern können.",
    "leaveTeamAction": "Team verlassen",
    "teamActions": "Teamaktionen",
    "leaveTeamLeaveChallenge": "Wenn Sie dieses Team verlassen, verlassen Sie die Challenge. Sie müssen einem Team beitreten, um weiter teilnehmen zu können.",
    "familyMembers": "Familenmitglieder",
    "familyMembersDescription": "Familienmitglieder müssen über 16 Jahre alt sein. Sie haben vollen Zugang und Einblick in die gesamte Plattform.",
    "learnMoreButton": "Mehr erfahren",
    "thvcSelection": {
        "signUpUsingTelus": "Registrieren Sie sich mit Ihrem TELUS Health Virtual Care Konto",
        "loginGetStarted": "Melden Sie sich bei Virtual Care an, um loszulegen",
        "haveAccount": "Haben Sie ein Virtual Care Konto?",
        "emailHelp": "Brauchen Sie Hilfe? Kontaktieren Sie unser Support-Team unter",
        "yes": "Ja",
        "signMeUp": "Nein, ich möchte mich anmelden"
    },
    "inviteFamilyMember": {
        "label": "Familienmitglied einladen",
        "btn": "Einladung senden",
        "email": "E-Mail-Adresse*",
        "firstName": "Vorname*",
        "lastName": "Nachname*",
        "approval": "Ich bestätige, dass ich die Erlaubnis habe, dieses Familienmitglied einzuladen zu %{company}",
        "multiSelect1": "Gilt dieses Familienmitglied in Ihrer Region bereits als volljährig?",
        "multiSelect2": "Ist dieses Familienmitglied mindestens 16 Jahre alt?",
        "confirmTermsPolicy": "Ich bestätige, dass ich der Erziehungsberechtigte der betreffenden Person bin. Meines Erachtens ist die Person reif genug, um der Nutzung der Plattform zuzustimmen, und ich bin damit einverstanden, dass sie der Plattform beitritt. Ich werde der betreffenden Person die Notwendigkeit eines verantwortungsvollen Verhaltens auf der Plattform und die Art und Weise, wie die Plattform ihre Daten sammelt und verwendet, erklären.",
        "onTheirBehalf": "in ihrem Namen.",
        "confirm": "Ja, ich bestätige die obigen Angaben",
        "warning": "Das Familienmitglied muss mindestens 16 Jahre alt sein, um sich anzumelden.",
        "errorMsg": "Bitte überprüfen Sie die Fehler, bevor Sie fortfahren"
    },
    "deleteFamilyMember": {
        "desc": "Die Löschung des Kontos eines Familienmitglieds ist dauerhaft.",
        "btn": "Familienmitglied löschen",
        "confirmation": {
            "title": "Familienmitglied gelöscht",
            "desc": "Das Konto von %{fullName} gelöscht"
        },
        "areYouSure": "Sind Sie sicher, dass Sie das Konto von %{fullName} löschen möchten?"
    },
    "familyInvitationStatus": {
        "active": "Aktiv",
        "sent": "Einladung gesendet"
    },
    "familyInvitationSent": {
        "title": "Einladungs-E-Mail gesendet",
        "desc": "Einladung gesendet an %{fullName}"
    },
    "programCodeSignup": "Bitte verwenden Sie %{programCodeLabel} %{programCode} nach Klick auf '%{signUpLabel}'",
    "notJoinedCommunityLabel": "Treten Sie dieser Gemeinschaft bei, um zu sehen, was die Mitglieder teilen",
    "moda": {
        "installApp": {
            "title": "Bitte beachten: Mitglieder von Moda Health können nur über ihr Mitglieder-Dashboard auf Sprout at Work zugreifen.",
            "subtitle": "Um Sprout at Work auf Ihrem Smartphone zu verwenden, gehen Sie wie folgt vor:",
            "stepOneA": "1. Installieren Sie die mobile App Sprout at Work.",
            "stepOneB": "Melden Sie sich nicht bei der mobilen App an und melden Sie sich nicht dort an.",
            "stepTwo": "2. Melden Sie sich auf Ihrem Mobiltelefon bei Ihrem Mitglieder-Dashboard an",
            "stepThree": "3. Navigieren Sie zum Sprout-Wellnessprogramm und folgen Sie dem Link. Die mobile Sprout at Work-App sollte geöffnet werden."
        }
    },
    "HRISLocationSelection": {
        "title": "In welchem Land arbeiten Sie?"
    },
    "visibilitySettings": {
        "title": "Sichtbarkeitseinstellungen",
        "desc1": "Ist es in Ordnung, für andere Wellbeing-App-Mitglieder in Ihrem Unternehmen sichtbar zu sein?",
        "desc2": "Sie können dies später jederzeit ändern.",
        "moreTextQ1": "Was können andere Menschen sehen?",
        "moreTextAnswer1": "Ihr Name, Ihr Profilfoto und grundlegende Profildetails (wie Abteilung und Standort) können von Personen in Ihrem Unternehmen gesehen werden. Dadurch wird die App sozialer und unterhaltsamer.",
        "moreTextQ2": "Wo erscheine ich?",
        "moreTextAnswer2": "Sie werden als Teilnehmer für Herausforderungen, Communities und Events, denen Sie beitreten, in Bestenlisten und in Suchergebnissen angezeigt. Sie können dies später anpassen.",
        "moreTextAnswer3": "Wir geben Ihre persönlichen Gesundheitsdaten wie Ihre Größe, Ihr Gewicht oder die Aktivität, die Sie verfolgen, nicht weiter oder zeigen sie nicht an.",
        "btnAgree": "Es ist in Ordnung, es mir zu zeigen",
        "btnDisagree": "Lassen Sie nicht zu, dass andere Mitglieder mich sehen"
    },
    "privacyPolicyReadMore": "Um mehr zu erfahren, lesen Sie unsere Datenschutzrichtlinie",
    "tellMeMore": "Erzähl mir mehr",
    "helpUsImprove": {
        "title": "Helfen Sie uns, uns zu verbessern",
        "desc1": "Wir verwenden Tools, die anonyme Nutzungsdaten erfassen. Das Erkennen von Trends bei dem, was Menschen sehen und anklicken, hilft uns, die App zu verbessern.",
        "desc2": "Sie können dies jederzeit deaktivieren.",
        "moreTextQ1": "Was wir anschauen",
        "moreTextAnswer1": "Wir sind an allgemeinen Trends und Statistiken interessiert, daher betrachten wir Daten nicht auf individueller Ebene.",
        "moreTextQ2": "Wir geben Ihre Daten nicht weiter",
        "moreTextAnswer2": "Diese Daten stehen nur den Personen zur Verfügung, die diese App erstellen, um sie zu verbessern. Wir geben sie nicht an andere Unternehmen weiter, auch nicht an Ihren Arbeitgeber.",
        "moreTextQ3": "Ihre Daten sind anonym",
        "moreTextAnswer3": "Unsere Tools zeichnen weder Ihren Namen noch Ihren genauen Standort noch persönliche Gesundheitsinformationen auf.",
        "btnAgree": "Verfolgen Sie meine Nutzung anonym",
        "btnDisagree": "Ich bin mit der Nachverfolgung nicht einverstanden"
    },
    "deleteAccountTextAppName": "Löschen Sie Ihr %{appName}-Konto und alle seine Daten dauerhaft",
    "anonymousMember": "Anonymes Mitglied",
    "activitiesToTrack": {
        "title": "Aktivitäten zum Verfolgen"
    },
    "includedInMembership": "In Ihrer Mitgliedschaft enthalten",
    "invalidDate": "Ungültiges Datum",
    "discardsStreamPost": {
        "discardTitle": "Beitrag verwerfen?",
        "discardChangesTitle": "Änderungen verwerfen?",
        "discardPostText": "Möchten Sie Ihren Beitrag wirklich verwerfen?",
        "discardPostChangesText": "Sind Sie sicher, dass Sie Ihre Änderungen verwerfen möchten?"
    },
    "trackActivityModalTitle": "Verfolgen für %{date}",
    "noPosts": "Keine Beiträge zu sehen",
    "goalIcon": "Zielsymbol",
    "resetsOn": "Wird am %{date} zurückgesetzt",
    "clickForHelp": "Klicken Sie hier für Hilfe",
    "trackActivityInputLabel": "Geben Sie %{unit} %{activityName} %{dateFormat} ein",
    "itemsFound": "Artikel gefunden",
    "tagState": {
        "active": "Aktiv",
        "notActive": "Nicht aktiv"
    },
    "bonusCheckmarkLabel": "Für den Abschluss wurden %{bonusLabel} Bonuspunkte erhalten",
    "searchBar": {
        "searching": "Suche nach %{term}",
        "result": "Suchergebnisse"
    },
    "activityProgress": "Aktivitätsfortschritt – %{levelName} %{percentFilled}% – Wird in %{daysLeft} Tagen zurückgesetzt",
    "bookmark": {
        "remove": "Aus gespeicherten Elementen entfernen",
        "save": "Speichern Sie diesen Artikel"
    },
    "bonusMark": {
        "earn": "Verdienen Sie %{qty} %{points}",
        "earned": "Sie haben %{qty} %{points} verdient"
    },
    "tabToTrackActivity": "Tippen Sie, um die Aktivität zu verfolgen",
    "videoElementLabel": "%{title}, Dauer %{duration}, Doppeltippen, um das Video abzuspielen",
    "updatedPoliciesPopup": {
        "title": "Wir haben unsere Bedingungen aktualisiert",
        "details": "Wir empfehlen Ihnen, unsere aktualisierten Richtlinien unten zu lesen:",
        "disclaimer": "Indem Sie unten auf die Schaltfläche klicken, stimmen Sie den aktualisierten Richtlinien zu und erkennen diese an.",
        "agree": "Ich stimme zu"
    },
    "editActivityLog": {
        "canNotEditItem": "Sie können diesen Eintrag nicht bearbeiten",
        "canNotEditItemDescription": "Für Aktivitäten, die von Geräten oder Apps synchronisiert werden, ist die Bearbeitung nicht möglich.",
        "updatedItem": "Aktivität aktualisiert",
        "updatedItemDescription": "Ihre Änderungen wurden gespeichert."
    },
    "login_with_email": "Mit E-Mail anmelden",
    "healthconnect_not_available": "Verbindung zu Health Connect nicht möglich. Stellen Sie in der Health Connect-App sicher, dass die Berechtigungen aktiviert sind.",
    "registrationField": {
        "required": {
            "firstName": "Bitte geben Sie Ihren Vornamen ein",
            "lastName": "Bitte geben Sie Ihren Nachnamen ein",
            "email": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
            "password": "Bitte geben Sie ein gültiges Passwort ein"
        }
    },
    "settingsErrorMessage": {
        "firstName": "Bitte geben Sie Ihren Vornamen ein",
        "lastName": "Bitte geben Sie Ihren Nachnamen ein"
    },
    "requiredValidValue": "Bitte geben Sie einen gültigen Wert für Ihren %{value} ein.",
    "passwordHidden": "Passwort ausgeblendet, tippen Sie, um das Passwort anzuzeigen",
    "passwordShown": "Passwort wird angezeigt. Tippen Sie, um das Passwort auszublenden",
    "libraryHeaderContent": {
        "category": "",
        "points": "Sammeln Sie %{points} Punkte."
    },
    "scoreCurrentPeriod": "%{text} ist von %{startDate} bis %{endDate}",
    "scoreCurrent": "%{text} ist %{points} Punkte",
    "abbotResetPasswordModal": {
        "title": "Versuchen Sie, auf ein Konto vom letzten Jahr zuzugreifen?",
        "text": " Wenn Sie sich letztes Jahr für die Challenge angemeldet haben, funktioniert dieses Konto nicht mehr. Sie müssen sich für dieses Jahr anmelden.",
        "goToResetPasswordBtn": "Ich habe mich im %{currentYear} angemeldet",
        "goToSignupBtn": "Ich habe mich im %{currentYear} nicht angemeldet"
    },
    "challengeRegistrationClosed": "Registrierung geschlossen – Challenge hat begonnen",
    "stopSupportGoogleFit": {
        "banner": {
            "title": "Google Fit wird eingestellt",
            "description": "Wechseln Sie zu Health Connect, um Ihre Aktivität weiterhin automatisch zu verfolgen.",
            "linkBtn": "Wechseln Sie zu Health Connect"
        },
        "newFeatureModal": {
            "label": "Aktion erforderlich",
            "title": "Google Fit unterstützt die Synchronisierung von Aktivitäten nicht mehr",
            "web": {
                "doNotHaveApp": "Haben Sie unsere App noch nicht?",
                "getAppText": "Laden Sie es hier herunter,",
                "dateNotIncludedDescription": "Verwenden Sie Ihr Smartphone, um stattdessen zu Google's Health Connect zu wechseln.",
                "dateIncludedDescription": "Wir werden die Google Fit-Integration am %{date} entfernen. Verwenden Sie Ihr Smartphone, um stattdessen zu Google's Health Connect zu wechseln."
            },
            "mobile": {
                "dateNotIncludedDescription": "Wechseln Sie zu Health Connect, um Ihre Aktivität weiterhin automatisch zu verfolgen.",
                "dateIncludedDescription": "Wir werden die Google Fit-Integration am %{date} entfernen. Wechseln Sie zu Health Connect, um Ihre Aktivität weiterhin automatisch zu verfolgen.",
                "buttonLabel": "Zu Health Connect wechseln"
            }
        }
    },
    "RBCTaxableRewardWarning": "Bitte beachten Sie, dass alle über die Wellness-Plattform eingelösten Prämien als steuerpflichtiger Vorteil betrachtet werden und der entsprechende Wert als Einkommen auf Ihrer Gehaltsabrechnung ausgewiesen wird."
};